/**
 * @license
 * Piano Browser SDK-cx@2.8.92.
 * Copyright 2010-2025 Piano Software Inc.
 */
!(function () {
  window.cX = window.cX || {};
  var e = window.cX;
  window.ari = window.ari || {};
  var t,
    n,
    r,
    i,
    o,
    a = window.ari,
    c = function (e) {
      var t = new Date(),
        n = function (e) {
          e && t.setDate(t.getDate() + e);
        };
      if (e instanceof Date) t = e;
      else if ("number" == typeof e) n(e);
      else {
        var r = e,
          i = r.days,
          o = r.minutes;
        (n(i), o && t.setMinutes(t.getMinutes() + o));
      }
      return t;
    },
    s = function (e) {
      var t = e.replace(/\+/g, " ").replace(/^\s+|\s+$/g, "");
      try {
        return decodeURIComponent(t);
      } catch (e) {
        return t;
      }
    },
    u = function (e) {
      return (
        0 === e.indexOf('"') &&
          (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\")),
        s(e)
      );
    },
    l = (function () {
      var e = function (e, t, n) {
          var r = void 0 === n ? {} : n,
            i = r.path,
            o = r.domain,
            a = r.expires,
            s = r.secure,
            u = r.samesite,
            l = r.raw,
            d = r.priority;
          return (
            (l ? e : encodeURIComponent(e)) +
            "=" +
            (l ? t : encodeURIComponent(t)) +
            (a ? "; expires=".concat(c(a).toUTCString()) : "") +
            (i ? "; path=".concat(i) : "") +
            (o ? "; domain=".concat(o) : "") +
            (s ? "; secure" : "") +
            (u
              ? "boolean" == typeof u
                ? "; sameSite"
                : "; sameSite=".concat(u)
              : "") +
            (d ? "; priority=".concat(d) : "")
          );
        },
        t = function (t, n, r, i) {
          var o;
          void 0 === n ||
            (void 0 !== i &&
              ((o = n),
              encodeURI(o).split(/%(?:u[\dA-F]{2})?[\dA-F]{2}|./).length - 1 >
                i)) ||
            (document.cookie = e(t, n, r));
        },
        n = function (e) {
          for (var t = document.cookie.split(";"), n = 0; n < t.length; n++) {
            var r = t[n].split("=");
            if (e(s(r[0]), r[1] || "")) return;
          }
        };
      function r(e) {
        var t = null,
          r = {};
        return (
          n(function (n, i) {
            if (e) {
              if (n === e) return ((t = u(i)), !0);
            } else r[n] = u(i);
          }),
          e ? t : r
        );
      }
      var i,
        o,
        a = function (e, n) {
          t(e, "", Object.assign({}, n, { expires: -1 }));
        },
        l =
          ((i = "_cookie_test"),
          (o = "https:" === document.location.protocol),
          function (e) {
            void 0 === e && (e = []);
            var n = window.location.hostname.split("."),
              c =
                new Date().getTime().toString(36) +
                Math.round(2147483647 * Math.random()).toString(36),
              s = new Date();
            s.setSeconds(s.getSeconds() + 30);
            for (var u = 0; u < n.length; u++)
              try {
                var l = n.slice(-(u + 1)).join(".");
                if (!e.includes(l)) {
                  t(i, c, { expires: s, path: "/", domain: l, secure: o });
                  var d = r(i) === c;
                  if ((a(i, { path: "/", domain: l }), d)) return l;
                }
              } catch (e) {}
          });
      return {
        set: t,
        get: r,
        getNames: function () {
          var e = [];
          return (
            n(function (t) {
              e.push(t);
            }),
            e
          );
        },
        remove: a,
        getTopLevelDomain: l,
        __private__: { _generateCookieString: e },
      };
    })(),
    d =
      ((t = "_ls_ttl"),
      (n = function () {
        try {
          var e = window.localStorage.getItem(t);
          return e ? JSON.parse(e) : null;
        } catch (e) {
          return null;
        }
      }),
      (r = function (e) {
        try {
          Object.keys(e).length
            ? window.localStorage.setItem(t, JSON.stringify(e))
            : window.localStorage.removeItem(t);
        } catch (e) {}
      }),
      (i = function () {
        var e = o(),
          t = n(),
          i = {};
        t &&
          (Object.keys(t).forEach(function (n) {
            if (e.includes(n)) {
              var r = t[n] ? parseInt(t[n], 36) : null;
              if (!(o = r) || o > Date.now()) i[n] = t[n];
              else
                try {
                  window.localStorage.removeItem(n);
                } catch (e) {}
            }
            var o;
          }),
          JSON.stringify(t) !== JSON.stringify(i) && r(i));
      }),
      (o = function () {
        try {
          return Object.keys(window.localStorage);
        } catch (e) {
          return [];
        }
      }),
      i(),
      {
        get: function (e) {
          var t;
          i();
          try {
            return null !== (t = window.localStorage.getItem(e)) && void 0 !== t
              ? t
              : null;
          } catch (e) {
            return null;
          }
        },
        set: function (e, t, i) {
          if (
            (void 0 === i && (i = {}),
            (function (e, t) {
              var i = n();
              if (void 0 === t)
                return ((null == i ? void 0 : i[e]) && (delete i[e], r(i)), !0);
              var o = c(t).getTime();
              return (
                o > Date.now() &&
                (((i = i || {})[e] = o.toString(36)), r(i), !0)
              );
            })(e, i.expires))
          )
            try {
              window.localStorage.setItem(e, t);
            } catch (e) {}
        },
        getNames: o,
        remove: function (e) {
          try {
            window.localStorage.removeItem(e);
          } catch (e) {}
          i();
        },
        expires: i,
        __protected__: {
          get ttlName() {
            return t;
          },
        },
      }),
    f = {
      get: function (e) {
        try {
          return window.sessionStorage.getItem(e);
        } catch (e) {
          return null;
        }
      },
      set: function (e, t) {
        try {
          window.sessionStorage.setItem(e, t);
        } catch (e) {}
      },
      getNames: function () {
        try {
          return Object.keys(window.sessionStorage);
        } catch (e) {
          return [];
        }
      },
      remove: function (e) {
        try {
          window.sessionStorage.removeItem(e);
        } catch (e) {}
      },
    },
    p = function () {
      return (
        (p =
          Object.assign ||
          function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++)
              for (var i in (t = arguments[n]))
                Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
          }),
        p.apply(this, arguments)
      );
    },
    m = function (e, t) {
      return (
        void 0 === t && (t = "_pctx"),
        {
          cookieName: t,
          readonly: !1,
          init: function (t) {
            var n;
            return null !== (n = null != t ? t : e) && void 0 !== n ? n : null;
          },
          refresh: function (e) {
            return e;
          },
          update: function (e) {
            return e;
          },
          set: function (e) {
            return e;
          },
          get: function (e) {
            return e;
          },
        }
      );
    },
    v = function (e) {
      return p(p({}, m(e)), { cookieName: null });
    },
    h = m("anon"),
    g = function (e) {
      return e ? Object.keys(e) : [];
    },
    y = function (e) {
      return Array.isArray(e);
    },
    w = function (e) {
      return null == e;
    },
    b = function (e) {
      return !w(e);
    },
    _ = function (e) {
      return "object" == typeof e;
    },
    I = function (e) {
      return "string" == typeof e;
    },
    S = function () {
      for (var e = new Date().getTime().toString(36); e.length < 16; )
        e += Math.round(2147483647 * Math.random()).toString(36);
      return e.substr(0, 16);
    },
    x = function (e, t) {
      return e
        ? g(e)
            .filter(function (n) {
              return t(e[n]);
            })
            .reduce(function (t, n) {
              var r;
              return p(p({}, t), (((r = {})[n] = e[n]), r));
            }, {})
        : e;
    },
    k = function () {
      var e = {};
      return {
        add: function (t) {
          e[t] = !0;
        },
        values: function () {
          return g(e);
        },
      };
    },
    C = function (e) {
      return "true" === e || !0 === e;
    },
    E = function (e, t) {
      var n,
        r = NaN,
        i = NaN;
      return function (o) {
        var a = null == t ? void 0 : t();
        return ((o === i && r === a) || ((r = a), (i = o), (n = e(o))), n);
      };
    },
    A = function (e) {
      var t;
      return function (n) {
        var r = e();
        r !== t && ((t = r), n(r));
      };
    },
    P = function (e, t) {
      try {
        return e();
      } catch (e) {
        return t ? P(t) : null;
      }
    },
    U = function (e, t) {
      return (
        void 0 === t && (t = !1),
        P(
          function () {
            return JSON.parse(e);
          },
          function () {
            return t ? JSON.parse(window.atob(e)) : null;
          },
        ) || null
      );
    },
    T = function (e, t) {
      if (e === t) return !0;
      if (!e || !t) return null;
      var n = g(e),
        r = g(t);
      return (
        n.length === r.length &&
        !n.some(function (n) {
          return e[n] !== t[n];
        })
      );
    },
    O = function (e) {
      return x(e, function (e) {
        return "CX" !== (null == e ? void 0 : e.type);
      });
    },
    L = p(p({}, m(null)), {
      init: function (e) {
        return O(e || null);
      },
      refresh: O,
      set: function (e, t) {
        return null === e
          ? null
          : x(p(p({}, t), e), function (e) {
              return null !== e;
            });
      },
    }),
    R = function () {
      return window.pdl || {};
    },
    M = function (e, t) {
      return (t({ protect: !0 }), S());
    },
    D = p(p({}, v()), {
      init: function (e, t) {
        return (t({ protect: !0 }), R().pageViewId || S());
      },
      refresh: M,
      update: M,
      set: function (e, t, n) {
        return (n({ protect: !0 }), e);
      },
    }),
    N = "DL",
    j = ["PA", "DMP", "COMPOSER", "ID", "VX", "ESP", "SOCIAL_FLOW", N].map(
      function (e, t) {
        return { name: e, id: t };
      },
    ),
    X = j.reduce(function (e, t, n) {
      var r,
        i = t.name;
      return p(p({}, e), (((r = {})[i] = n), (r[i.toLowerCase()] = n), r));
    }, {});
  ((X["social flow"] = X.SOCIAL_FLOW), (X["Social Flow"] = X.SOCIAL_FLOW));
  var H,
    W = function () {
      var e;
      return null === (e = Te(R().consent)) || void 0 === e
        ? void 0
        : e.products;
    },
    V = A(W),
    F =
      ((H = j),
      function () {
        return (
          V(function (e) {
            H = e
              ? j.filter(function (t) {
                  return e.includes(t.name) || t.name === N;
                })
              : j;
          }),
          H
        );
      }),
    z = function (e, t, n) {
      var r = F().reduce(function (r, i) {
        var o = i.id,
          a = n(null == e ? void 0 : e[o], null == t ? void 0 : t[o], o);
        return (a && (r[o] = a), r);
      }, {});
      return T(r, t) ? t : r;
    },
    q = function (e) {
      var t = Number(e);
      if (Number.isNaN(t)) {
        var n = X[e.toLowerCase()];
        return null != n ? n : null;
      }
      return t < j.length ? t : null;
    },
    Q = function (e, t) {
      return g(e).reduce(function (n, r) {
        var i = j[Number(r)].name,
          o = e[r];
        return ((n[i] = t ? t(o, i) : o), n);
      }, {});
    },
    B = "not-acquired",
    Y = "opt-in",
    G = "essential",
    $ = "opt-out",
    J = "custom",
    K = [Y, G, $],
    Z = K.concat(J),
    ee = Z.reduce(function (e, t, n) {
      var r;
      return p(p({}, e), (((r = {})[n] = t), r));
    }, {}),
    te = [B, Y, J, G, $],
    ne = function (e) {
      return Z.includes(e);
    },
    re = {
      AD: ["DMP", "SOCIAL_FLOW"],
      CP: ["COMPOSER"],
      AM: ["PA"],
      PR: ["ESP", "VX", "ID"],
      DL: ["DL"],
    },
    ie = g(re).reduce(function (e, t) {
      return (
        re[t].forEach(function (n) {
          var r = X[n];
          e[r] = t;
        }),
        e
      );
    }, {}),
    oe = A(function () {
      var e;
      return null === (e = Te(R().consent)) || void 0 === e
        ? void 0
        : e.defaultPurposes;
    }),
    ae = (function () {
      var e = p({}, ie);
      return function () {
        return (
          oe(function (t) {
            ((e = p({}, ie)),
              t &&
                g(t).forEach(function (n) {
                  var r,
                    i = X[n];
                  e[i] =
                    null === (r = t[n]) || void 0 === r
                      ? void 0
                      : r.substring(0, 32);
                }));
          }),
          e
        );
      };
    })(),
    ce = function (e, t) {
      return z(e, t, function (e, t, n) {
        return e || t || ae()[n];
      });
    },
    se = p(p({}, m(null, "_pprv")), {
      init: function (e) {
        return de() ? ce(e || null, null) : null;
      },
      set: function (e, t) {
        return de()
          ? null == e
            ? t
            : ce(
                (function (e) {
                  return g(e).reduce(function (t, n) {
                    var r = q(n),
                      i = ge(e[n]);
                    return (
                      null === r || i === me || r === X[N] || (i && (t[r] = i)),
                      t
                    );
                  }, {});
                })(e),
                t,
              )
          : null;
      },
    }),
    ue = function () {
      return R().consent_modifiers || null;
    },
    le = function () {
      return !!R().requireConsent;
    },
    de = function () {
      return "v2" === R().requireConsent;
    },
    fe = function () {
      return !!R().strictConsent;
    },
    pe = function (e, t) {
      var n;
      return e === J && !(null === (n = ue()) || void 0 === n ? void 0 : n[t]);
    },
    me = "DL",
    ve = ["AD", "AM", "CP", "PR", me].reduce(function (e, t) {
      var n;
      return p(p({}, e), (((n = {})[t] = t), (n[t.toLowerCase()] = t), n));
    }, {}),
    he = function (e) {
      return ve[(null == e ? void 0 : e.toLowerCase()) || ""] || null;
    },
    ge = function (e) {
      return he(e) || (null == e ? void 0 : e.substring(0, 32));
    },
    ye = function (e, t, n) {
      return "".concat(e.join(", "), " ").concat(e.length > 1 ? n : t);
    },
    we = function (e) {
      return '"'.concat(e, '" can not be applied for the dl product');
    };
  function be(e, t, n, r, i) {
    var o = function (e) {
        return { error: e };
      },
      a = function (t, n, r) {
        var i = [];
        if (!ne(t))
          return o(
            (function (e) {
              return "".concat(e, " is unknown consent mode");
            })(t),
          );
        var a = F().reduce(function (o, a) {
          var c = a.id,
            s = a.name;
          return (
            (n &&
              (null == e ? void 0 : e[c]) !== n &&
              !(null == r ? void 0 : r.includes(c))) ||
              (pe(t, s) ? i.push(s) : (o[c] = { mode: t })),
            o
          );
        }, {});
        return i.length
          ? o(
              (function (e) {
                return (
                  ye(e, "does", "do") +
                  "n't have modifier in the pdl. Custom mode can't be applied"
                );
              })(i),
            )
          : Object.keys(a).length
            ? { consent: a }
            : null;
      },
      c = function (t, n) {
        var r = ge(n);
        return ve[r] || Object.values(e || {}).includes(r)
          ? a(t, r)
          : o("Unknown purpose. Provide a product or define within pdl config");
      };
    return de()
      ? i
        ? (function (e, t, n) {
            var r = ge(t),
              i = y(n) ? n : [n],
              s = i.map(q).filter(b);
            if (!s.length)
              return he(t)
                ? c(e, t)
                : o(
                    (function (e) {
                      return (
                        "Custom purpose: " + ye(e, "is", "are") + " unknown"
                      );
                    })(i),
                  );
            if (r !== me && s.includes(X.DL)) return { error: we(r) };
            if (
              r === me &&
              s.some(function (e) {
                return e !== X.DL;
              })
            )
              return o('the "DL" purpose is reserved');
            var u = a(e, r, s);
            if (null == u ? void 0 : u.error) return u;
            var l = s.reduce(function (e, t) {
              return ((e[t] = r), e);
            }, {});
            return {
              consent: (null == u ? void 0 : u.consent) || null,
              purposes: l,
            };
          })(r, n, i)
        : r
          ? c(r, n)
          : a(n)
      : o("Consent v2 is disabled");
  }
  var _e = function (e, t) {
      if (!e) return null;
      var n = Q(t || ie),
        r = fe();
      return F().reduce(function (t, i) {
        var o,
          a,
          c,
          s,
          u,
          l = i.name,
          d = n[l],
          f = r && !(l === N) ? B : Y,
          p = (null === (o = e[l]) || void 0 === o ? void 0 : o.mode) || f;
        return (
          t[d]
            ? ((t[d].mode =
                ((a = t[d].mode),
                (c = p),
                (s = te.indexOf(a)),
                (u = te.indexOf(c)),
                te[Math.max(s, u)])),
              t[d].products.push(l))
            : (t[d] = { mode: p, products: [l] }),
          t
        );
      }, {});
    },
    Ie = ["include", "exclude", "obfuscate"],
    Se = function (e) {
      var t = e && e.length;
      return 16 === t || 36 === t ? e : null;
    },
    xe = function (e, t) {
      return '"'.concat(e, '" should be one of ').concat(t.join(", "));
    },
    ke = function () {},
    Ce = function (e, t) {
      return function (n) {
        return t(e + n);
      };
    },
    Ee = function (e, t) {
      void 0 === t && (t = ke);
      var n = X[e.toLowerCase()];
      return void 0 !== n
        ? j[n].name
        : (t('"'.concat(e, '" is not found')), null);
    },
    Ae = function (e) {
      return (function (e) {
        return K.includes(e);
      })(e)
        ? e
        : null;
    },
    Pe = function (e, t) {
      void 0 === t && (t = ke);
      var n = e.source,
        r = e.patches || [];
      return (
        Ae(n) || (t(xe("source", K)), (n = Y)),
        y(r) || (t('"patches" should be an array'), (r = [])),
        {
          source: n,
          patches: (r = r.reduce(function (e, n, r) {
            if (!_(n) || y(n))
              return (
                t(
                  "patch[".concat(
                    r,
                    "]: should be type of {action, item, with?}",
                  ),
                ),
                e
              );
            var i = n.action,
              o = n.item;
            return Ie.includes(i)
              ? o && _(o) && o.key && o.type
                ? (e.push(n), e)
                : (t(
                    "patch[".concat(
                      r,
                      ']: "item" should be type of {key, type}',
                    ),
                  ),
                  e)
              : (t("patch[".concat(r, "]: ") + xe("action", Ie)), e);
          }, [])),
        }
      );
    },
    Ue = function (e, t) {
      if ((void 0 === t && (t = ke), !e)) return null;
      var n = {};
      (e.products &&
        (y(e.products)
          ? (n.products = e.products.reduce(function (e, n) {
              var r = Ee(n, Ce("consent.products: ", t));
              return (r && e.push(r), e);
            }, []))
          : t("consent.products: should be an array")),
        e.defaultPreset &&
          (n.defaultPreset = g(e.defaultPreset).reduce(function (n, r) {
            var i = Ee(r, Ce("consent.defaultPreset: ", t)),
              o = Ae(e.defaultPreset[r]);
            return (
              o || t("consent.defaultPreset: " + xe(r, K)),
              i && o && (n[i] = o),
              n
            );
          }, {})));
      var r = e.defaultPurposes;
      return (
        r &&
          (n.defaultPurposes = g(r).reduce(function (e, n) {
            var i = Ce("consent.defaultPurposes: ", t),
              o = Ee(n, i),
              a = r[n],
              c = ge(a);
            return (
              c === me || o === N
                ? i('"'.concat(n, ": ").concat(a, '" - invalid config'))
                : o && c && (e[o] = c),
              e
            );
          }, {})),
        n
      );
    },
    Te = E(Ue),
    Oe = p(p({}, m(null, "_pcid")), {
      init: function (e, t) {
        return (t({ protect: !0 }), Se(R().browserId || null) || e || S());
      },
      update: function (e, t) {
        return (t({ protect: !0 }), S());
      },
      set: function (e, t, n) {
        return (n({ protect: !0 }), e);
      },
    }),
    Le = p(p({}, v()), {
      init: function () {
        return R().referrer || document.referrer;
      },
    }),
    Re = p(p({}, v()), {
      init: function () {
        return R().sessionReferrer || document.referrer;
      },
    }),
    Me = [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 2, 2, 2, 2, 0],
      [1, 2, 2, 2, 2, 2, 2, 1],
      [0, 2, 0, 2, 2, 2, 0, 0],
      [1, 2, 2, 2, 2, 2, 1, 1],
      [2, 0, 0, 2, 2, 2, 2, 0],
      [2, 0, 2, 2, 2, 2, 2, 0],
      [2, 2, 2, 2, 2, 2, 0, 2],
      [2, 2, 0, 0, 0, 0, 2, 0],
      [2, 2, 1, 2, 1, 2, 2, 1],
      [2, 2, 1, 1, 2, 2, 2, 1],
    ],
    De = function (e) {
      return e.reduce(function (e, t, n) {
        var r;
        return p(p({}, e), (((r = {})[n] = { mode: ee[t] }), r));
      }, {});
    },
    Ne = Me.map(function (e, t) {
      return { id: t, preset: De(e) };
    }),
    je = A(function () {
      var e;
      return null === (e = Te(R().consent)) || void 0 === e
        ? void 0
        : e.defaultPreset;
    }),
    Xe = (function () {
      var e = Ne;
      return function () {
        return (
          je(function (t) {
            ((e = Ne.slice()),
              t &&
                ((e[0] = { id: 0, preset: p({}, e[0].preset) }),
                g(t).forEach(function (n) {
                  var r = t[n],
                    i = X[n];
                  e[0].preset[i] = { mode: r };
                })));
          }),
          e
        );
      };
    })(),
    He = function (e, t) {
      var n = fe();
      return z(e, t, function (e, t, r) {
        var i = r === X[N],
          o = n && !i ? null : Xe()[0].preset[r].mode,
          a =
            (null == e ? void 0 : e.mode) || (null == t ? void 0 : t.mode) || o;
        return null === a
          ? null
          : a !== (null == t ? void 0 : t.mode)
            ? { mode: a }
            : t;
      });
    },
    We = p(p({}, m(null, "_pprv")), {
      init: function (e) {
        return le() && e ? He(e, null) : null;
      },
      set: function (e, t) {
        var n, r, i;
        return le()
          ? null == e
            ? t
            : (!(function (e) {
                return "number" == typeof e;
              })(e)
                ? y(e)
                  ? ((i = null),
                    e.forEach(function (e) {
                      var t = Me[e];
                      i || !t
                        ? i &&
                          t &&
                          (i = i.map(function (e, n) {
                            return Math.min(e, t[n]);
                          }))
                        : (i = t);
                    }),
                    (r = i && De(i)))
                  : (r = (function (e) {
                      return g(e).reduce(function (t, n) {
                        var r = e[n],
                          i = q(n);
                        if (null === i) return t;
                        var o = ne(r.mode) ? r.mode : null;
                        return (o && (t || (t = {}), (t[i] = { mode: o })), t);
                      }, null);
                    })(e))
                : (r =
                    (null === (n = Xe()[e]) || void 0 === n
                      ? void 0
                      : n.preset) || null),
              r ? He(r, t) : t)
          : null;
      },
      get: E(
        function (e) {
          return (
            e &&
            Q(e, function (e, t) {
              var n,
                r = p({}, e);
              return (
                r.mode === J &&
                  (r.modifier =
                    (null === (n = ue()) || void 0 === n ? void 0 : n[t]) ||
                    null),
                r
              );
            })
          );
        },
        function () {
          return ue();
        },
      ),
    }),
    Ve = p(p({}, v()), { init: Xe, set: Xe }),
    Fe = p(p({}, v()), { init: F, set: F }),
    ze = p(p({}, v(null)), {
      readonly: !0,
      set: function () {
        return null;
      },
      get: ue,
    }),
    qe = function (e) {
      var t = Number(e);
      return Number.isNaN(t) ? String(e) : t;
    },
    Qe = function (e) {
      return y(e)
        ? e
        : e.split(",").map(function (e) {
            return e.trim().replace(/^['"](.+)['"]$/, "$1");
          });
    },
    Be = function (e) {
      return e;
    },
    Ye = {
      id: Be,
      type: Be,
      zone: Be,
      createdAt: qe,
      modifiedAt: qe,
      authors: Qe,
      section: Be,
      tags: Qe,
      keywords: Qe,
      title: Be,
      description: Be,
      isNative: C,
    },
    Ge = function (e) {
      return "last" === e;
    };
  function $e(e, t) {
    if (
      (void 0 === e && (e = "meta"),
      (function (e) {
        return "first" === e;
      })(t))
    )
      return document.querySelector(e);
    var n = document.querySelectorAll(e);
    return Ge(t) ? n[n.length - 1] : Array.from(n);
  }
  var Je,
    Ke =
      ((Je = null),
      {
        refresh: function () {
          (Je = $e() || null) &&
            setTimeout(function () {
              Je = null;
            }, 0);
        },
        find: function (e, t) {
          return (
            void 0 === t && (t = !1),
            Je
              ? Je.reduce(function (n, r) {
                  for (var i = 0, o = e; i < o.length; i++) {
                    var a = o[i],
                      c = (("name" === a ? r.name : r.getAttribute(a)) || "")
                        .trim()
                        .toLowerCase(),
                      s = r.content;
                    if (c && (!t || s)) {
                      (n[c] || (n[c] = []), n[c].push(r));
                      break;
                    }
                  }
                  return n;
                }, {})
              : null
          );
        },
      }),
    Ze = function (e) {
      var t,
        n =
          e.getContent ||
          function (e) {
            return e.content;
          };
      return e.selector
        ? ((t = $e(e.selector, e.take || "first")) && n(t)) || null
        : (function () {
            var t = Ke.find(e.attr || ["name"], e.hasContent),
              r = e.names || [],
              i = !("all" === e.take),
              o = Ge(e.take);
            if (!t) return null;
            for (
              var a = function (e) {
                  var r = [],
                    a = t[e];
                  if (a) {
                    if (i) {
                      var c = a[o ? a.length - 1 : 0];
                      return { value: n(c) || "" };
                    }
                    a.forEach(function (e) {
                      r = r.concat(n(e) || "");
                    });
                  }
                  if (r.length) return { value: r };
                },
                c = 0,
                s = r;
              c < s.length;
              c++
            ) {
              var u = a(s[c]);
              if ("object" == typeof u) return u.value;
            }
            return null;
          })();
    },
    et = function (e) {
      for (var t = 0, n = e; t < n.length; t++) {
        var r = n[t],
          i = Ze(r);
        if (i) return i;
      }
    },
    tt = function (e, t, n) {
      var r = Ye[t];
      if (!Boolean(e[t]) && r) {
        var i = (
            "function" == typeof n
              ? n
              : function () {
                  return y(n) ? et(n) : Ze(n);
                }
          )(),
          o = i && r(i);
        o && (e[t] = o);
      }
    },
    nt = function (e) {
      return { names: [e] };
    };
  function rt(e) {
    return e && I(e["@type"]) && e["@type"].includes("Article");
  }
  function it() {
    var e,
      t = document.querySelectorAll('script[type="application/ld+json"]');
    if (t) {
      var n = Array.from(t).flatMap(function (e) {
        return U(e.innerHTML);
      });
      return (
        (y((e = n)) &&
          e.find(function (e) {
            return rt(e);
          })) ||
        {}
      );
    }
    return {};
  }
  var ot = {
      januar: "01",
      january: "01",
      jan: "01",
      februar: "02",
      february: "02",
      feb: "02",
      mars: "03",
      march: "03",
      mar: "03",
      april: "04",
      apr: "04",
      mai: "05",
      may: "05",
      juni: "06",
      june: "06",
      jun: "06",
      juli: "07",
      july: "07",
      jul: "07",
      august: "08",
      aug: "08",
      september: "09",
      sept: "09",
      sep: "09",
      oktober: "10",
      october: "10",
      okt: "10",
      oct: "10",
      november: "11",
      nov: "11",
      desember: "12",
      december: "12",
      dec: "12",
      des: "12",
    },
    at = function (e) {
      var t = e
          .replace(/DAY/g, "(0?[1-9]|[12][0-9]|3[01])")
          .replace(/MONTHLONG/g, "(" + g(ot).join("|") + ")")
          .replace(/MONTH/g, "(0?[1-9]|1[012])")
          .replace(/YEAR2/g, "([0-9][0-9])")
          .replace(/YEAR/g, "(197[1-9]|19[8-9][0-9]|20[0-9][0-9])")
          .replace(
            /TIME/g,
            "([0-9][0-9]):([0-9][0-9]):([0-9][0-9])(?:\\.[0-9][0-9][0-9])?([zZ]|[+-][0-9][0-9](?::?[0-9][0-9])?)?",
          ),
        n = e.replace(/.*?([YMD])(EAR|ONTH|AY).*?/g, "$1").substring(0, 3);
      return [new RegExp(t), n];
    },
    ct = [
      "\\bDAY\\.MONTH\\.YEAR\\b",
      "\\bDAY\\.?\\s{0,3}MONTHLONG\\.?\\s{1,3}YEAR\\b",
      "\\bYEAR-MONTH-DAY(?:[tT]|\\b)",
      "\\bMONTHLONG\\.?\\s{0,3}DAY(?:st|nd|rd|th)?,?\\s{1,3}YEAR\\b",
      "\\bDAY(?:st|nd|rd|th|\\.)?\\s{0,3}MONTHLONG\\.?,?\\s{1,3}YEAR\\b",
      "\\bYEAR[/å¹´]MONTH[/æœˆ]DAY(?=\\b|æ—¥)",
      "\\bDAY\\.MONTH\\.YEAR2\\b",
      "\\bDAY/MONTH/YEAR\\b",
    ].map(at),
    st = at("YEAR-MONTH-DAY[tT]TIME")[0],
    ut = function (e) {
      return (e && parseInt(e, 10)) || 0;
    };
  function lt(e, t, n, r, i, o, a) {
    var c = new Date(Date.UTC(ut(e), ut(t) - 1, ut(n), ut(r), ut(i), ut(o))),
      s = (a || "").match(/^([+-][0-9][0-9])(?::?([0-9][0-9])?)$/);
    s &&
      (c = new Date(
        c.getTime() - 36e5 * Number(s[1]) - 6e4 * (Number(s[2]) || 0),
      ));
    var u = Date.now() - c.getTime();
    return u > 0 || -u < 1728e5 ? c.toISOString() : null;
  }
  function dt(e) {
    var t = (e = e.toLowerCase()).match(st);
    if (t) return lt(t[1], t[2], t[3], t[4], t[5], t[6], t[7]);
    for (var n = 0, r = ct; n < r.length; n++) {
      var i = r[n],
        o = e.match(i[0]);
      if (o)
        return lt(
          2 ===
            (o =
              "DMY" === i[1]
                ? ["", o[3], o[2], o[1]]
                : "MDY" === i[1]
                  ? ["", o[3], o[1], o[2]]
                  : o)[1].length
            ? (ut(o[1]) < 60 ? "20" : "19") + o[1]
            : o[1],
          o[2].length <= 2 ? o[2] : ot[o[2]],
          o[3],
        );
    }
  }
  var ft = function (e) {
    return e
      .replace(/<\/?[^>?]*\/?>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };
  function pt(e) {
    return (
      void 0 === e && (e = ""),
      ft(e.replace(/,(?=\s*(jr|sr)(\.?)\b)/g, " "))
    );
  }
  var mt,
    vt,
    ht,
    gt,
    yt = function (e) {
      return p(p({}, e), { take: "last" });
    },
    wt = function (e) {
      return p(p({}, e), {
        take: "last",
        hasContent: !0,
        getContent: function (e) {
          return ft(e.content || "");
        },
      });
    },
    bt = [
      yt({
        attr: ["name", "property", "itemprop"],
        names: [
          "cxenseparse:publishtime",
          "cxenseparse:recs:publishtime",
          "article:published_time",
          "date",
          "dc.date",
          "dc.date.created",
          "dc.terms.issued",
          "pub_date",
          "article.published",
          "datepublished",
          "og:article:published_time",
        ],
      }),
      yt({
        selector: "time.published[datetime],time[pubdate][datetime]",
        getContent: function (e) {
          return e.getAttribute("datetime");
        },
      }),
      yt({
        selector: 'time[itemprop="datePublished"][datetime]',
        getContent: function (e) {
          return e.getAttribute("datetime");
        },
      }),
    ],
    _t = [
      yt({
        attr: ["name", "property", "itemprop"],
        names: ["article:modified_time", "datemodified"],
      }),
      yt({
        selector: 'time[itemprop="dateModified"][datetime]',
        getContent: function (e) {
          return e.getAttribute("datetime");
        },
      }),
    ],
    It = [
      {
        attr: ["property", "name"],
        names: [
          "cxenseparse:author",
          "og:article:author",
          "article:author",
          "og:book:author",
          "book:author",
          "author",
          "dc.creator",
          "article.author",
        ],
        take: "all",
        getContent: function (e) {
          var t,
            n = e.getAttribute("data-separator"),
            r = e.content;
          return n
            ? pt(r).split(n)
            : (void 0 === (t = r) && (t = ""),
              pt(
                t
                  .replace(/\n+/, ";")
                  .replace(/(\<|&lt;)br(\>|&gt;)/, ";")
                  .replace(/\b(and|und|og)\b/g, ";"),
              ).split(/[,;]/));
        },
      },
    ],
    St = [
      wt({ names: ["cxenseparse:keywords"] }),
      wt({ attr: ["property", "name"], names: ["news_keywords"] }),
      wt({ names: ["keywords"] }),
    ],
    xt = [
      wt({ names: ["cxenseparse:description"] }),
      wt({ attr: ["property"], names: ["og:description"] }),
      wt({ names: ["description"] }),
    ],
    kt = [
      { names: ["cxenseparse:title"] },
      yt({ attr: ["property", "name"], names: ["og:title"] }),
    ],
    Ct = function () {
      var e,
        t = Array.from(
          document.querySelectorAll("meta[property^=content]"),
        ).reduce(function (e, t) {
          var n,
            r =
              null === (n = null == t ? void 0 : t.getAttribute("property")) ||
              void 0 === n
                ? void 0
                : n.split(":").pop(),
            i = Ye[r];
          return (
            i &&
              t &&
              (e[r] = i(
                (null == t ? void 0 : t.getAttribute("content")) || "",
              )),
            e
          );
        }, {});
      return (
        Ke.refresh(),
        tt((e = t), "type", { attr: ["property"], names: ["og:type"] }),
        tt(e, "section", nt("section")),
        tt(e, "id", nt("id")),
        tt(e, "authors", nt("author")),
        (function (e) {
          (tt(e, "createdAt", function () {
            var e = et(bt);
            return e ? dt(e.toLowerCase()) : null;
          }),
            tt(e, "modifiedAt", function () {
              var e = et(_t);
              return e ? dt(e.toLowerCase()) : null;
            }),
            tt(e, "authors", It),
            tt(e, "keywords", function () {
              var e = et(St);
              return e && e.length <= 1024 ? e : null;
            }),
            tt(e, "title", kt),
            tt(e, "description", xt));
        })(t),
        (function (e) {
          var t = it();
          rt(t) &&
            (tt(e, "createdAt", function () {
              var e = t.datePublished;
              return e ? dt(e.toLowerCase()) : null;
            }),
            tt(e, "modifiedAt", function () {
              var e = t.dateModified;
              return e ? dt(e.toLowerCase()) : null;
            }),
            tt(e, "authors", function () {
              var e = t.author;
              return e
                ? y(e)
                  ? e
                      .map(function (e) {
                        return e.name;
                      })
                      .join(", ")
                  : e.name
                : null;
            }),
            tt(e, "keywords", function () {
              var e = t.keywords;
              return I(e) && e.length <= 1024 ? e : null;
            }),
            tt(e, "title", function () {
              return t.headline;
            }),
            tt(e, "description", function () {
              return t.description;
            }));
        })(t),
        t
      );
    },
    Et = p(p({}, v(null)), {
      init: function () {
        return Ct();
      },
      refresh: function (e) {
        var t = Ct();
        return (
          (null == e ? void 0 : e._fixed_) &&
            (null == e ||
              e._fixed_.forEach(function (e) {
                delete t[e];
              })),
          p(p({}, e), t)
        );
      },
      set: function (e, t) {
        if (null === e) return {};
        var n = new Set(t && t._fixed_),
          r = function (t, n) {
            g(x(e, t)).forEach(n);
          };
        return (
          r(b, function (e) {
            n.add(e);
          }),
          r(w, function (e) {
            n.delete(e);
          }),
          x(p(p(p({}, t), e), { _fixed_: Array.from(n.values()) }), b)
        );
      },
      get: E(function (e) {
        var t = p({}, e);
        return (delete t._fixed_, e && t);
      }),
    }),
    At = p(p({}, m(null, "_pcus")), {
      init: function (e) {
        return (
          void 0 === e && (e = null),
          e &&
            x(e, function (e) {
              return _(e) && y(e.segments);
            })
        );
      },
    }),
    Pt = {
      pageViewId: D,
      browserId: Oe,
      users: L,
      userStatus: h,
      siteId: m(),
      consent: We,
      consentPresets: Ve,
      products: Fe,
      consentModifiers: ze,
      purposes: se,
      content: Et,
      userSegments: At,
      referrer: Le,
      sessionReferrer: Re,
    },
    Ut = ["pantheon.io", "go-vip.net", "go-vip.co"],
    Tt =
      void 0 ===
      (ht =
        null ===
          (vt =
            null === (mt = R()) || void 0 === mt ? void 0 : mt.cookieDefault) ||
        void 0 === vt
          ? void 0
          : vt.domain)
        ? l.getTopLevelDomain(Ut)
        : ht,
    Ot = {
      path: "/",
      expires: 395,
      samesite: "lax",
      secure: "https:" === window.location.protocol,
      domain: Tt,
    },
    Lt = function (e) {
      return e.getTime().toString(36);
    },
    Rt = function (e) {
      return e
        ? P(function () {
            return new Date(parseInt(e, 36));
          })
        : null;
    },
    Mt = "_t",
    Dt = function (e, t) {
      var n = t.encode,
        r = t.decode,
        i = !1,
        o = null,
        a = null,
        c = null;
      !(function () {
        var t,
          n = null === (t = r(e || "")) || void 0 === t ? void 0 : t[Mt];
        if (n) {
          var c = n.split("|");
          ((o = Rt(c[0])), (a = Rt(c[1])), (i = !!o));
        }
      })();
      var s = function (e) {
        return (o =
          o ||
          (function (e) {
            var t = new Date();
            if (e instanceof Date) t = e;
            else {
              if ("number" != typeof e) return null;
              t.setDate(t.getDate() + e);
            }
            return t;
          })(e.expires));
      };
      return {
        get fixedAt() {
          return i ? [a, o] : null;
        },
        onChange: function (e) {
          c = e;
        },
        setMode: function (e) {
          var t = i;
          (i = e) !== t && ((o = null), (a = null), null == c || c(i));
        },
        bindOptions: function (e) {
          return i && (o = s(e)) ? p(p({}, e), { expires: o }) : e;
        },
        decode: function (e) {
          var t = r(e);
          return ((null == t ? void 0 : t[Mt]) && delete t[Mt], t);
        },
        encode: function (e, t) {
          return (
            i
              ? (o = s(t)) && (e[Mt] = Lt(o) + "|" + Lt((a = a || new Date())))
              : delete e[Mt],
            n(e)
          );
        },
      };
    },
    Nt = "essential",
    jt = "optional",
    Xt = "mandatory",
    Ht = function (e, t, n) {
      return (
        void 0 === t && (t = jt),
        void 0 === n && (n = !1),
        {
          cookieName: e,
          consent: t,
          encode: function (e) {
            return (function (e, t) {
              void 0 === t && (t = !1);
              var n = JSON.stringify(e);
              return (
                P(function () {
                  return t ? window.btoa(n) : n;
                }) || n
              );
            })(e, n);
          },
          decode: function (e) {
            return U(e, !0);
          },
        }
      );
    },
    Wt = String.fromCharCode,
    Vt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",
    Ft = {};
  function zt(e) {
    return null == e
      ? ""
      : (function (e, t, n) {
          if (null == e) return "";
          var r,
            i,
            o,
            a = {},
            c = {},
            s = "",
            u = "",
            l = "",
            d = 2,
            f = 3,
            p = 2,
            m = [],
            v = 0,
            h = 0;
          for (o = 0; o < e.length; o += 1)
            if (
              ((s = e.charAt(o)),
              Object.prototype.hasOwnProperty.call(a, s) ||
                ((a[s] = f++), (c[s] = !0)),
              (u = l + s),
              Object.prototype.hasOwnProperty.call(a, u))
            )
              l = u;
            else {
              if (Object.prototype.hasOwnProperty.call(c, l)) {
                if (l.charCodeAt(0) < 256) {
                  for (r = 0; r < p; r++)
                    ((v <<= 1),
                      h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++);
                  for (i = l.charCodeAt(0), r = 0; r < 8; r++)
                    ((v = (v << 1) | (1 & i)),
                      h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                      (i >>= 1));
                } else {
                  for (i = 1, r = 0; r < p; r++)
                    ((v = (v << 1) | i),
                      h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                      (i = 0));
                  for (i = l.charCodeAt(0), r = 0; r < 16; r++)
                    ((v = (v << 1) | (1 & i)),
                      h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                      (i >>= 1));
                }
                (0 == --d && ((d = Math.pow(2, p)), p++), delete c[l]);
              } else
                for (i = a[l], r = 0; r < p; r++)
                  ((v = (v << 1) | (1 & i)),
                    h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                    (i >>= 1));
              (0 == --d && ((d = Math.pow(2, p)), p++),
                (a[u] = f++),
                (l = String(s)));
            }
          if ("" !== l) {
            if (Object.prototype.hasOwnProperty.call(c, l)) {
              if (l.charCodeAt(0) < 256) {
                for (r = 0; r < p; r++)
                  ((v <<= 1),
                    h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++);
                for (i = l.charCodeAt(0), r = 0; r < 8; r++)
                  ((v = (v << 1) | (1 & i)),
                    h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                    (i >>= 1));
              } else {
                for (i = 1, r = 0; r < p; r++)
                  ((v = (v << 1) | i),
                    h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                    (i = 0));
                for (i = l.charCodeAt(0), r = 0; r < 16; r++)
                  ((v = (v << 1) | (1 & i)),
                    h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                    (i >>= 1));
              }
              (0 == --d && ((d = Math.pow(2, p)), p++), delete c[l]);
            } else
              for (i = a[l], r = 0; r < p; r++)
                ((v = (v << 1) | (1 & i)),
                  h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
                  (i >>= 1));
            0 == --d && ((d = Math.pow(2, p)), p++);
          }
          for (i = 2, r = 0; r < p; r++)
            ((v = (v << 1) | (1 & i)),
              h == t - 1 ? ((h = 0), m.push(n(v)), (v = 0)) : h++,
              (i >>= 1));
          for (;;) {
            if (((v <<= 1), h == t - 1)) {
              m.push(n(v));
              break;
            }
            h++;
          }
          return m.join("");
        })(e, 6, function (e) {
          return Vt.charAt(e);
        });
  }
  function qt(e) {
    return null == e
      ? ""
      : "" == e
        ? null
        : (function (e, t, n) {
            var r,
              i,
              o,
              a,
              c,
              s,
              u,
              l = [],
              d = 4,
              f = 4,
              p = 3,
              m = "",
              v = [],
              h = { val: n(0), position: t, index: 1 };
            for (r = 0; r < 3; r += 1) l[r] = r;
            for (o = 0, c = Math.pow(2, 2), s = 1; s != c; )
              ((a = h.val & h.position),
                (h.position >>= 1),
                0 == h.position && ((h.position = t), (h.val = n(h.index++))),
                (o |= (a > 0 ? 1 : 0) * s),
                (s <<= 1));
            switch (o) {
              case 0:
                for (o = 0, c = Math.pow(2, 8), s = 1; s != c; )
                  ((a = h.val & h.position),
                    (h.position >>= 1),
                    0 == h.position &&
                      ((h.position = t), (h.val = n(h.index++))),
                    (o |= (a > 0 ? 1 : 0) * s),
                    (s <<= 1));
                u = Wt(o);
                break;
              case 1:
                for (o = 0, c = Math.pow(2, 16), s = 1; s != c; )
                  ((a = h.val & h.position),
                    (h.position >>= 1),
                    0 == h.position &&
                      ((h.position = t), (h.val = n(h.index++))),
                    (o |= (a > 0 ? 1 : 0) * s),
                    (s <<= 1));
                u = Wt(o);
                break;
              case 2:
                return "";
            }
            for (l[3] = u, i = u, v.push(u); ; ) {
              if (h.index > e) return "";
              for (o = 0, c = Math.pow(2, p), s = 1; s != c; )
                ((a = h.val & h.position),
                  (h.position >>= 1),
                  0 == h.position && ((h.position = t), (h.val = n(h.index++))),
                  (o |= (a > 0 ? 1 : 0) * s),
                  (s <<= 1));
              switch ((u = o)) {
                case 0:
                  for (o = 0, c = Math.pow(2, 8), s = 1; s != c; )
                    ((a = h.val & h.position),
                      (h.position >>= 1),
                      0 == h.position &&
                        ((h.position = t), (h.val = n(h.index++))),
                      (o |= (a > 0 ? 1 : 0) * s),
                      (s <<= 1));
                  ((l[f++] = Wt(o)), (u = f - 1), d--);
                  break;
                case 1:
                  for (o = 0, c = Math.pow(2, 16), s = 1; s != c; )
                    ((a = h.val & h.position),
                      (h.position >>= 1),
                      0 == h.position &&
                        ((h.position = t), (h.val = n(h.index++))),
                      (o |= (a > 0 ? 1 : 0) * s),
                      (s <<= 1));
                  ((l[f++] = Wt(o)), (u = f - 1), d--);
                  break;
                case 2:
                  return v.join("");
              }
              if ((0 == d && ((d = Math.pow(2, p)), p++), l[u])) m = l[u];
              else {
                if (u !== f) return null;
                m = i + i.charAt(0);
              }
              (v.push(m),
                (l[f++] = i + m.charAt(0)),
                (i = m),
                0 == --d && ((d = Math.pow(2, p)), p++));
            }
          })((e = e.replace(/ /g, "+")).length, 32, function (t) {
            return (function (e, t) {
              if (!Ft[e]) {
                Ft[e] = {};
                for (var n = 0; n < e.length; n++) Ft[e][e.charAt(n)] = n;
              }
              return Ft[e][t];
            })(Vt, e.charAt(t));
          });
  }
  !(function (e) {
    e.URI = "URI";
  })(gt || (gt = {}));
  var Qt,
    Bt,
    Yt = { URI: { prefix: "{u}", compress: zt, decompress: qt } },
    Gt = g(Yt).reduce(function (e, t) {
      return ((e[Yt[t].prefix] = Yt[t]), e);
    }, {}),
    $t = {
      cookieName: "_pctx",
      consent: Xt,
      encode: function (e, t) {
        void 0 === t && (t = gt.URI);
        var n = JSON.stringify(e),
          r = Yt[t].compress(n);
        return Yt[t].prefix + r;
      },
      decode: function (e) {
        var t = (function (e) {
          var t = e.slice(0, 3),
            n = e.slice(3);
          if (!Gt[t]) return null;
          var r = Gt[t].decompress(n);
          if (!r) return null;
          try {
            return JSON.parse(r);
          } catch (e) {
            return null;
          }
        })(e || "");
        return _(t) ? t : null;
      },
    },
    Jt = function () {
      var e, t;
      return !!(null ===
        (t = null === (e = R().cookies) || void 0 === e ? void 0 : e._pprv) ||
      void 0 === t
        ? void 0
        : t.jsonOnly);
    },
    Kt = {
      _pprv: Ht("_pprv", Xt, !Jt()),
      _pcid: Ht("_pcid", Nt),
      _pcus: Ht("_pcus", jt, !0),
      _pctx: $t,
    },
    Zt = (function (e) {
      return g(e).reduce(function (t, n) {
        return (
          (t[n] = (function (e) {
            var t = e.cookieName,
              n = e.consent,
              r = l.get(t),
              i = !!r,
              o = i,
              a = Dt(r, e),
              c = !!a.fixedAt,
              s = i,
              u = null,
              d = p({}, Ot),
              f = null,
              m = function () {
                return i && s;
              },
              v = function (e) {
                var n = h(e),
                  r = u || (f ? a.encode(f, n) : "");
                if (!r) {
                  var i = l.get(t),
                    s = a.decode(i || "");
                  r = s ? a.encode(s, n) : "";
                }
                r && ((c = !0), l.set(t, r, a.bindOptions(n)), (o = !0));
              },
              h = function (e) {
                return p(p({}, d), x(e || {}, b));
              },
              g = function (e) {
                m() && (o && l.remove(t, h(e)), (o = !1));
              },
              y = function (e, t) {
                var n = e && t;
                (!m() && n && v(),
                  m() && !n && g(),
                  m() && n && !c && v(),
                  (i = e),
                  (s = t));
              };
            return (
              a.onChange(function () {
                m() && ((c = !1), v());
              }),
              {
                get cookieName() {
                  return t;
                },
                get cookieEnabled() {
                  return m();
                },
                get fixedAt() {
                  return a.fixedAt;
                },
                get consent() {
                  return n;
                },
                set: function (e, t) {
                  ((f = e), m() && v(t));
                },
                get: function () {
                  return a.decode(l.get(t) || "");
                },
                remove: g,
                setCookieOptions: function (e) {
                  ((d = h(e)), m() && v());
                },
                setCookieEnabled: function (e, t) {
                  (void 0 === t && (t = null), (u = e ? t : null), y(e, s));
                },
                lazyActive: function () {
                  y(i, !0);
                },
                setFixedMode: function (e) {
                  a.setMode(e);
                },
              }
            );
          })(e[n])),
          t
        );
      }, {});
    })(Kt),
    en = "__pctx_connection__",
    tn = "uvm42pas28m",
    nn = {},
    rn = function () {
      var e,
        t,
        n =
          ((e = null),
          (t = null),
          {
            register: function (n) {
              return (
                (e = p(p({}, n.fields), e)),
                (t = p(p({}, n.cookieByName), t))
              );
            },
            get wrappers() {
              return t;
            },
            get: function () {
              var e = {};
              return (
                t &&
                  g(t).forEach(function (n) {
                    e = p(p({}, e), t[n].get());
                  }),
                e
              );
            },
            set: function (n, r) {
              void 0 === r && (r = null);
              var i = {};
              (g(n).forEach(function (o) {
                var a = n[o],
                  c = null == e ? void 0 : e[o];
                c &&
                  (i[c] ||
                    (i[c] = {
                      wrapper: null == t ? void 0 : t[c],
                      data: {},
                      update: !1,
                      remove: !0,
                    }),
                  (i[c].data[o] = a),
                  (i[c].remove = i[c].remove && null === a),
                  (r && (i[c].update || a === r[o])) || (i[c].update = !0));
              }),
                g(i).forEach(function (e) {
                  var t = i[e],
                    n = t.wrapper,
                    r = t.update,
                    o = t.remove;
                  (o && n.remove(), r && !o && n.set(i[e].data));
                }));
            },
          }),
        r = {},
        i = null,
        o = new Map(),
        a = new Map(),
        c = [],
        s = function (e, t, n) {
          void 0 === n && (n = !1);
          var r = [];
          return (
            g(t).forEach(function (i) {
              var o = t[i],
                c = !a.has(i) || a.get(i) === e || n;
              o && c ? a.set(i, e) : !o && c ? a.delete(i) : r.push(i);
            }),
            r.length > 0 ? r : null
          );
        };
      return function (e, t) {
        var u = S();
        return (
          o.set(u, e),
          t && n.register(t),
          (r = p(p({}, n.get()), r)),
          {
            getInitCookieData: function () {
              return r;
            },
            getCachedData: function () {
              return i || nn;
            },
            setProtectionData: function (e) {
              return s(u, e);
            },
            setProtectionDataUnsafe: function (e) {
              return s(u, e, !0);
            },
            updateData: function (e) {
              return (function (e, t) {
                var o = {},
                  s = {};
                g(t).forEach(function (e) {
                  a.has(e)
                    ? (o[e] = (null == i ? void 0 : i[e]) || null)
                    : (s[e] = t[e]);
                });
                var u = i || r,
                  l = p(p({}, i), s);
                return (
                  T(l, u) ||
                    (n.set(l, u),
                    (i = l),
                    c.forEach(function (e) {
                      return (0, e[1])(s);
                    })),
                  g(o).length > 0 ? o : null
                );
              })(0, e);
            },
            onUpdateData: function (e) {
              !(function (e, t) {
                c.push([e, t]);
              })(u, e);
            },
            terminate: function () {
              (!(function (e) {
                c = c.filter(function (t) {
                  return t[0] !== e;
                });
              })(u),
                o.delete(u));
            },
            setCookieOptions: function () {
              return null;
            },
            setCookieEnabled: function () {
              return null;
            },
            get registeredCookiesWrapper() {
              return n.wrappers;
            },
          }
        );
      };
    },
    on =
      (void 0 === Qt && (Qt = !1),
      function (e, t) {
        var n = rn();
        try {
          Object.defineProperty(window, en, {
            configurable: Qt,
            set: function (e) {
              var t = e();
              t === tn ? e(n) : "mrlqf5trgho" === t && (n = rn());
            },
          });
        } catch (e) {}
        return (
          (window[en] = function (e) {
            return (e && (n = e), tn);
          }),
          n(e, t)
        );
      }),
    an = function (e) {
      return e.includes("*");
    },
    cn = function (e, t) {
      return [new RegExp("^" + e.replace(/\*/g, ".*") + "$"), t];
    },
    sn = function (e) {
      return g(e)
        .filter(an)
        .map(function (t) {
          return cn(t, e[t]);
        });
    },
    un = function (e, t) {
      for (var n = 0, r = t; n < r.length; n++) {
        var i = r[n];
        if (i[0].test(e)) return i[1];
      }
      return null;
    },
    ln = function (e, t) {
      switch (e) {
        case Y:
          return !0;
        case G:
          return t === Nt || t === Xt;
        case $:
          return t === Xt;
        default:
          return !0;
      }
    },
    dn = function (e) {
      switch (e) {
        case "include":
        case "obfuscate":
          return !0;
        case "exclude":
          return !1;
      }
    },
    fn = function (e) {
      if (e && e !== N) {
        var t = W();
        return !(!t || t.includes(e));
      }
      return !1;
    },
    pn = function (e) {
      var t = e.product || null,
        n = Object.assign({}, e.items),
        r = sn(n),
        i = function (e) {
          return n[e] || un(e, r) || jt;
        };
      return function (n, r) {
        var o = R().requireConsent,
          a = !y(n),
          c = a ? [n] : n,
          s = (function () {
            var n = function () {
                return c.map(function (e) {
                  return { name: e, allowed: !o || fn(t) };
                });
              },
              a = r || e.getConsent();
            if (!a) return n();
            if (a.mode === J) {
              var s = (function (e, t, n) {
                var r = t && Pe(t, n);
                if (!r) return null;
                for (
                  var i = [], o = {}, a = 0, c = r.patches;
                  a < c.length;
                  a++
                ) {
                  var s = c[a],
                    u = s.action,
                    l = s.with,
                    d = void 0 === l ? null : l,
                    f = s.item;
                  if (f.type === e) {
                    var p = { action: u, data: d };
                    ((o[f.key] = p), an(f.key) && i.push(cn(f.key, p)));
                  }
                }
                return {
                  source: r.source,
                  getModifier: function (e) {
                    return o[e] || un(e, i);
                  },
                };
              })(e.type, a.modifier, e.log);
              if (!s) return n();
              var u = s.source;
              return c.map(function (e) {
                var t = s.getModifier(e),
                  n = (function (e, t) {
                    return "obfuscate" === e ? t : null;
                  })(
                    null == t ? void 0 : t.action,
                    null == t ? void 0 : t.data,
                  ),
                  r = {
                    name: e,
                    allowed: (null == t ? void 0 : t.action)
                      ? dn(t.action)
                      : ln(u, i(e)),
                  };
                return (null !== n && (r.data = n), r);
              });
            }
            return c.map(function (e) {
              return { name: e, allowed: ln(a.mode, i(e)) };
            });
          })();
        return a ? s[0] : s;
      };
    },
    mn = Object.freeze({
      __proto__: null,
      createCheckConsentWrapper: pn,
      createMask: cn,
      getByMask: un,
      isMask: an,
      itemsToMask: sn,
    }),
    vn =
      ((Bt = {
        pa_vid: function (e) {
          return Se(U(e || "", !0) || e);
        },
        atuserid: function (e) {
          var t;
          return Se(
            (null === (t = U(e || "", !0)) || void 0 === t ? void 0 : t.val) ||
              "",
          );
        },
      }),
      function (e) {
        for (
          var t = function (e) {
              try {
                var t = (function () {
                  if (e.ls)
                    return (
                      (function (e) {
                        var t = function (e) {
                            return P(function () {
                              return window.localStorage.getItem(e);
                            });
                          },
                          n = t(e),
                          r = P(function () {
                            return parseInt(U(t("_ls_ttl"))[e], 36);
                          });
                        return r && r <= Date.now() ? null : n;
                      })(e.ls) || null
                    );
                  var t = l.get(e);
                  return Bt[e] && t ? Bt[e](t) : t;
                })();
                if (t) return { value: t };
              } catch (e) {}
            },
            n = 0,
            r = e;
          n < r.length;
          n++
        ) {
          var i = t(r[n]);
          if ("object" == typeof i) return i.value;
        }
        return null;
      }),
    hn = { PA: { browserId: ["pa_vid", "atuserid"] } },
    gn = function (e) {
      var t,
        n = p(
          {},
          (function (e, t) {
            return (
              void 0 === t && (t = ke),
              g(e || {}).reduce(function (n, r) {
                var i = null == e ? void 0 : e[r],
                  o = Ee((null == i ? void 0 : i.source) || "", t);
                return ((n[r] = p(p({}, i), { source: o })), n);
              }, {})
            );
          })(null === (t = R()) || void 0 === t ? void 0 : t.migration),
        );
      g(n).forEach(function (t) {
        var r,
          i,
          o = e.params.get(t),
          a = null === (r = n[t]) || void 0 === r ? void 0 : r.source,
          c =
            (a && (null === (i = hn[a]) || void 0 === i ? void 0 : i[t])) || [];
        if (o && c.length) {
          var s = R()[t],
            u = vn(c);
          u &&
            !s &&
            ((o.readonly = !1), e.updateValues(t, u, !0), (o.readonly = !0));
        }
      });
    },
    yn = "@@Data-layer/",
    wn = yn + "update_value",
    bn = yn + "refresh_value",
    _n = yn + "refresh_locked_key",
    In = function () {
      var e = p({}, window.pdl),
        t = function (e) {
          return (
            (t = e),
            (n = {
              path: String,
              domain: String,
              secure: C,
              expires: function (e) {
                return e instanceof Date ? e : Number(e);
              },
              samesite: function (e) {
                return I(e) ? e : C(e);
              },
            }),
            _(t)
              ? g(t).reduce(function (e, r) {
                  var i = t[r],
                    o = n[r],
                    a = o && o(i);
                  return (void 0 !== a && (e[r] = a), e);
                }, {})
              : t
          );
          var t, n;
        };
      return (
        (null == e ? void 0 : e.cookies) &&
          (e.cookies = g(e.cookies).reduce(function (n, r) {
            return ((n[r] = t(e.cookies[r])), n);
          }, {})),
        (null == e ? void 0 : e.cookieDefault) &&
          (e.cookieDefault = t(e.cookieDefault)),
        e
      );
    },
    Sn = function (e) {
      var t = (function (e) {
        var t,
          n,
          r = R(),
          i =
            (null === (t = r.consent) || void 0 === t ? void 0 : t.products) ||
            [],
          o = 1 === i.length && "PA" === i[0],
          a =
            "opt-out" ===
            (null === (n = null == e ? void 0 : e.PA) || void 0 === n
              ? void 0
              : n.mode);
        return !!r.requireConsent && o && a;
      })(e);
      return { _pprv: !R().requireConsent, _pctx: t, _pcid: t, _pcus: t };
    },
    xn = function (e, t, n) {
      var r = 1 === n ? "can not be" : "was";
      console.warn(
        '[DL]: Consent v2: the "'.concat(
          e,
          '" has a conflicted consent mode, ',
        ) + "mode ".concat(r, ' changed to "').concat(t, '"'),
      );
    },
    kn = (function (e, t, n) {
      var r,
        i = (function (e, t) {
          return {
            fields: g(e).reduce(function (t, n) {
              var r = e[n].cookieName;
              return (null !== r && (t[n] = r), t);
            }, {}),
            cookieByName: t,
          };
        })(e, t),
        o = on("data-layer", i),
        a = !1,
        c = new Map(),
        s = new Set(),
        u = new Map(),
        l = function () {
          if (!o) throw new Error("DataLayer can't be connected");
          return o;
        },
        d = function (e) {
          var t = l().registeredCookiesWrapper;
          t && e(t);
        },
        f = function (e) {
          d(function (t) {
            e.forEach(function (e) {
              var n = t[e];
              n && n.lazyActive();
            });
          });
        },
        m = function () {
          var e = null;
          return (
            d(function (t) {
              e = g(t).reduce(function (e, n) {
                var r = t[n].cookieEnabled,
                  i = t[n].fixedAt || null;
                return (
                  (e[t[n].cookieName] = r ? { enabled: r, fixedAt: i } : null),
                  e
                );
              }, {});
            }),
            e
          );
        },
        v = function () {
          var e = {},
            t = function (t) {
              return g(e).reduce(function (n, r) {
                var i = e[r];
                return (void 0 !== i[t] && (n[r] = i[t]), n);
              }, {});
            };
          return {
            add: function (t, n) {
              e[t] = n;
            },
            call: function () {
              var e;
              ((e = t("protect")),
                g(e).length > 0 && l().setProtectionData(e),
                (function () {
                  var e = t("protectUnsafe");
                  g(e).length > 0 && l().setProtectionDataUnsafe(e);
                })());
            },
          };
        },
        h = function (e, t) {
          return g(e).reduce(function (n, r) {
            var i = u.get(r),
              o = e[r];
            return (i && (n[r] = t ? t(i, o) : i.get(o)), n);
          }, {});
        },
        w = function () {
          return {
            params: u,
            getConnection: l,
            addChangeListener: A,
            get: S,
            updateValues: _,
          };
        },
        b = function (e) {
          var t = !1;
          (g(e).forEach(function (n) {
            var i,
              o = n,
              a = u.get(o);
            if (a) {
              var s = e[o];
              r[o] !== s &&
                ((r[o] = s),
                (t = !0),
                null === (i = c.get(o)) ||
                  void 0 === i ||
                  i.forEach(function (e) {
                    return e(a.get(s));
                  }));
            }
          }),
            t &&
              s.forEach(function (e) {
                return e(h(r));
              }));
        },
        _ = function (e, t, n) {
          var i;
          void 0 === n && (n = !1);
          var o = e,
            a = k();
          I(e) && (((i = {})[e] = t), (o = i));
          var c = v(),
            s = v();
          ((o = g(o).reduce(function (e, t) {
            var n = o[t],
              i = u.get(t),
              l = t;
            return (null == i ? void 0 : i.readonly)
              ? e
              : (i && i.cookieName && a.add(i.cookieName),
                i && n !== r[t]
                  ? n === bn
                    ? ((e[t] = i.refresh(r[t], function (e) {
                        s.add(l, e);
                      })),
                      e[t] !== r[t] && c.add(l, { protectUnsafe: !1 }),
                      e)
                    : n === wn
                      ? ((e[t] = i.update(r[t], function (e) {
                          s.add(l, e);
                        })),
                        e)
                      : ((e[t] = i.set(n, r[t], function (e) {
                          s.add(l, e);
                        })),
                        e)
                  : e);
          }, {})),
            f(a.values()),
            c.call());
          var d = l().updateData(o);
          if (d && n) {
            var m = g(d).reduce(function (e, t) {
              var n;
              return p(p({}, e), (((n = {})[t] = !1), n));
            }, {});
            (l().setProtectionDataUnsafe(m), l().updateData(o));
          }
          return (s.call(), d && h(d));
        };
      function S(e) {
        var t,
          n,
          i = k(),
          o = I(e);
        return (
          void 0 === e
            ? (n = r)
            : o
              ? (((t = {})[e] = r[e]), (n = t))
              : (n = e.reduce(function (e, t) {
                  return (u.has(t) && (e[t] = r[t]), e);
                }, {})),
          (n = h(n, function (e, t) {
            return (e.cookieName && i.add(e.cookieName), e.get(t));
          })),
          f(i.values()),
          o ? n[e] : n
        );
      }
      function x(e, t) {
        return _(e, t, !1);
      }
      var C = function (e, t) {
          void 0 === t && (t = !1);
          var n = e;
          return (
            y(e) || (n = [e]),
            _(
              n.reduce(function (e, t) {
                return ((e[t] = wn), e);
              }, {}),
              void 0,
              t,
            )
          );
        },
        E = function (e, t, n) {
          var r;
          void 0 === n && (n = !1);
          var i = n ? l().setProtectionDataUnsafe : l().setProtectionData,
            o = e;
          return (I(e) && (((r = {})[e] = t), (o = r)), i(o));
        };
      function A(e, t) {
        var n;
        I(e) ? null === (n = c.get(e)) || void 0 === n || n.add(t) : s.add(e);
      }
      return {
        init: function (t) {
          if ((void 0 === t && (t = {}), !a)) {
            var s, f;
            (o || (o = on("data-layer", i)),
              (s = p(p({}, t), In())),
              (f = s.cookieDefault),
              d(function (e) {
                g(e).forEach(function (t) {
                  var n,
                    r,
                    i,
                    o,
                    a = e[t].cookieName,
                    c =
                      null === (n = s.cookies) || void 0 === n ? void 0 : n[a],
                    u =
                      "fixed" ===
                      (null === (r = s.cookies) || void 0 === r
                        ? void 0
                        : r.storageMode);
                  (null === (o = (i = e[t]).setFixedMode) ||
                    void 0 === o ||
                    o.call(i, u),
                    (f || c) && e[t].setCookieOptions(p(p({}, f), c)));
                });
              }),
              (a = !0),
              g(e).forEach(function (t) {
                var n = e[t];
                (c.set(t, new Set()), u.set(t, n));
              }));
            var m = !1,
              h = l().getInitCookieData(),
              y = l().getCachedData(),
              _ = v(),
              I = g(e).reduce(function (t, n) {
                var r = n,
                  i = e[n];
                return (
                  (t[n] =
                    (null == y ? void 0 : y[r]) ||
                    i.init(null == h ? void 0 : h[r], function (e) {
                      _.add(r, e);
                    })),
                  (null == y ? void 0 : y[r]) || (m = !0),
                  t
                );
              }, {});
            ((r = I),
              m && l().updateData(I),
              _.call(),
              l().onUpdateData(function (e) {
                return b(e);
              }),
              null == n || n(w()));
          }
        },
        set: x,
        get: S,
        update: function (e) {
          return C(e);
        },
        refresh: function () {
          var e;
          if (l().setProtectionData((((e = {})[_n] = !0), e))) return !1;
          var t = [];
          u.forEach(function (e, n) {
            return t.push(n);
          });
          var n = t.reduce(function (e, t) {
            return ((e[t] = bn), e);
          }, {});
          return (_(n), !0);
        },
        protect: function (e, t) {
          return E(e, t);
        },
        addChangeListener: A,
        removeChangeListener: function (e) {
          (s.delete(e),
            c.forEach(function (t) {
              return t.delete(e);
            }));
        },
        terminate: function () {
          (null == o || o.terminate(),
            c.clear(),
            s.clear(),
            (o = null),
            (a = !1),
            (r = {}));
        },
        updateMigration: function () {
          a && gn(w());
        },
        get isReady() {
          return a;
        },
        utils: {
          validateModifier: Pe,
          validateConsent: Ue,
          checkConsent: mn,
          setConsent: function (e, t, n) {
            S("consent");
            var r = be(S("purposes"), 0, e, t, n);
            return r
              ? r.error
                ? r.error
                : (x({ consent: r.consent, purposes: r.purposes }), null)
              : null;
          },
          getConsent: function () {
            var e = S(["consent", "purposes"]),
              t = e.consent,
              n = e.purposes;
            return _e(t, n);
          },
          notAcquiredConsent: de()
            ? g(re).reduce(function (e, t) {
                return ((e[t] = { mode: B, products: re[t] }), e);
              }, {})
            : null,
          compressLz: zt,
          decompressLz: qt,
        },
        get cookies() {
          return m();
        },
        get cookieEnabled() {
          return m();
        },
        setUnsafe: function (e, t) {
          _(e, t, !0);
        },
        protectUnsafe: function (e, t) {
          return E(e, t, !0);
        },
        updateUnsafe: function (e) {
          return C(e, !0);
        },
        setCookieEnabled: function (e) {
          d(function (t) {
            var n = g(e);
            n.length
              ? n.forEach(function (n) {
                  var r = t[n];
                  r && r.setCookieEnabled(e[n]);
                })
              : g(t).forEach(function (n) {
                  t[n].setCookieEnabled(e);
                });
          });
        },
      };
    })(Pt, Zt, function (e) {
      (!(function (e) {
        var t,
          n = g(Kt).reduce(function (e, t) {
            return ((e[t] = Kt[t].consent), e);
          }, {}),
          r = function (t) {
            var n;
            return (
              t ||
              (null === (n = e.get("consent")) || void 0 === n
                ? void 0
                : n.DL) ||
              null
            );
          },
          i = pn({ items: n, type: "cookie", getConsent: r }),
          o = r(),
          a =
            (null === (t = e.get("consent")) || void 0 === t ? void 0 : t.PA) ||
            null,
          c = function (t, n) {
            var r,
              o = Sn(n),
              a =
                null === (r = e.getConnection()) || void 0 === r
                  ? void 0
                  : r.registeredCookiesWrapper;
            if (a) {
              var c = g(a).map(function (e) {
                return a[e].cookieName;
              });
              i(c, t).forEach(function (e) {
                var t = e.name,
                  n = e.allowed,
                  r = e.data,
                  i = t,
                  c = n && !o[i];
                a[i].setCookieEnabled(c, r || null);
              });
            }
          };
        (e.addChangeListener("consent", function (e) {
          var t = (null == e ? void 0 : e.DL) || null,
            n = (null == e ? void 0 : e.PA) || null;
          ((null == o ? void 0 : o.mode) === (null == t ? void 0 : t.mode) &&
            (null == a ? void 0 : a.mode) === (null == n ? void 0 : n.mode)) ||
            ((o = t), (a = n), c(t, e));
        }),
          c(o, e.get("consent")));
      })(e),
        gn(e),
        (function (e) {
          var t = null,
            n = {},
            r = function (t) {
              var r = _e(t, e.get("purposes"));
              if (r && t) {
                var i = !1,
                  o = g(r).reduce(function (e, o) {
                    var a = r[o].mode;
                    return (
                      r[o].products.forEach(function (r) {
                        var o;
                        a !== B &&
                          a !==
                            (null === (o = t[r]) || void 0 === o
                              ? void 0
                              : o.mode) &&
                          (pe(a, r)
                            ? n[r] || ((n[r] = !0), xn(r, a, 1))
                            : ((e[r] = { mode: a }), (i = !0), xn(r, a, 2)));
                      }),
                      e
                    );
                  }, {});
                i && e.updateValues({ consent: o });
              }
            };
          (e.addChangeListener("consent", function (e) {
            de() &&
              (t && (clearTimeout(t), (t = null)),
              (t = setTimeout(function () {
                (r(e), (t = null));
              }, 200)));
          }),
            de() && r(e.get("consent")));
        })(e));
    }),
    Cn = document.createElement.bind(document),
    En = document.getElementById.bind(document),
    An = document.getElementsByTagName.bind(document),
    Pn = encodeURIComponent,
    Un = parseInt,
    Tn = Object.prototype.hasOwnProperty,
    On = Array.prototype.slice,
    Ln = Math.abs,
    Rn = Math.round,
    Mn = Math.max,
    Dn = Math.min,
    Nn = Math.floor,
    jn = Math.pow,
    Xn = Math.random;
  function Hn() {
    return "development" === e.env.nodeEnv;
  }
  function Wn(e) {
    Hn() && console.error(e);
  }
  function Vn() {
    Hn() && console.info.apply(window, Array.prototype.slice.call(arguments));
  }
  function Fn(t, n) {
    e.library.m_logs.push([t, n]);
  }
  function zn() {
    return Date.now();
  }
  function qn() {
    return Rn(zn() / 1e3);
  }
  function Qn() {
    var e = new Date(),
      t = e.getTimezoneOffset();
    try {
      if (Ln(t) > 840 || t % 15 != 0) {
        var n = Rn(e.getUTCHours() - e.getHours()) % 24;
        t =
          30 *
          Rn(
            (60 * (n += n < -12 ? 24 : n > 12 ? -24 : 0) +
              e.getUTCMinutes() -
              e.getMinutes()) /
              30,
          );
      }
    } catch (e) {
      Wn(e);
    }
    return t;
  }
  function Bn(e) {
    return void 0 === e;
  }
  function Yn(e) {
    return null === e;
  }
  function Gn(e) {
    return "boolean" == typeof e;
  }
  function $n(e) {
    return "number" == typeof e;
  }
  function Jn(e) {
    return "string" == typeof e;
  }
  function Kn(e) {
    return "function" == typeof e;
  }
  function Zn(e) {
    return Kn(Number.isNaN) ? Number.isNaN(e) : $n(e) && window.isNaN(e);
  }
  function er(e) {
    return "[object Array]" === Object.prototype.toString.call(e);
  }
  function tr(e) {
    return "object" == typeof e && !Yn(e) && !er(e);
  }
  function nr(e) {
    return !e.length;
  }
  function rr(e) {
    return !1 !== e;
  }
  function ir(e, t, n) {
    for (var r = 0; r < e.length; r++) t.call(n, e[r], r, e);
  }
  function or(e, t) {
    return e.indexOf(t) > -1;
  }
  var ar = {
    some: function (e, t, n) {
      var r = !1;
      return (
        ir(e, function (i, o) {
          r = r || t.call(n, i, o, e);
        }),
        r
      );
    },
    forEach: ir,
    remove: function (e, t) {
      var n = e.indexOf(t);
      return (n > -1 && e.splice(n, 1), e);
    },
  };
  function cr(e, t, n) {
    for (var r in e) Tn.call(e, r) && t.call(n, e[r], r, e);
  }
  var sr = {
    forEach: cr,
    some: function (e, t, n) {
      var r = !1;
      return (
        cr(e, function (i, o) {
          r = r || t.call(n, i, o, e);
        }),
        r
      );
    },
    keys: function (e) {
      var t = [];
      return (
        cr(e, function (e, n) {
          t.push(n);
        }),
        t
      );
    },
  };
  function ur(e) {
    var t = !0;
    return (
      cr(e, function () {
        t = !1;
      }),
      t
    );
  }
  function lr(e, t) {
    return (
      ir(t, function (t) {
        e.push(t);
      }),
      e
    );
  }
  var dr = ["__proto__", "prototype", "constructor"];
  function fr(e, t) {
    return (
      cr(t, function (t, n) {
        or(dr, "" + n) ||
          (tr(t)
            ? (tr(e[n]) || (e[n] = {}), fr(e[n], t))
            : er(t)
              ? (er(e[n]) || (e[n] = []), lr(e[n], t))
              : (e[n] = t));
      }),
      e
    );
  }
  function pr(e) {
    return lr([], e);
  }
  function mr(e) {
    return fr({}, e);
  }
  function vr() {
    for (var e = {}, t = 0; t < arguments.length; t++)
      arguments[t] && fr(e, arguments[t]);
    return e;
  }
  function hr() {
    return Rn(2147483647 * Xn());
  }
  function gr() {
    for (var e = zn().toString(36); e.length < 16; ) e += hr().toString(36);
    return e.slice(0, 16);
  }
  var yr = 0;
  function wr() {}
  function br(e) {
    return e.replace(/^\s*/, "").replace(/\s*$/, "");
  }
  function _r(t, n) {
    var r = window.setTimeout(function () {
      (ar.remove(e.library.m_timerIds, r), t.apply(window, arguments));
    }, n);
    return (e.library.m_timerIds.push(r), r);
  }
  function Ir(e, t, n) {
    var r,
      i,
      o = !1;
    return function a() {
      var c = n || window;
      if (o) return ((r = arguments), void (i = c));
      (e.apply(c, arguments),
        (o = !0),
        setTimeout(function () {
          ((o = !1), r && (a.apply(i, r), (r = void 0), (i = void 0)));
        }, t));
    };
  }
  function Sr(e, t) {
    return (
      Element.prototype.matches ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector
    ).call(e, t);
  }
  function xr(e, t, n, r) {
    e.addEventListener && e.addEventListener(t, n, tr(r) ? r : !!r);
  }
  function kr(e, t, n, r) {
    e.removeEventListener && e.removeEventListener(t, n, tr(r) ? r : !!r);
  }
  var Cr = { stringify: JSON.stringify, parse: JSON.parse };
  function Er() {
    try {
      var e = navigator.userAgent;
      return /Safari/.test(e) && !/Android|Chrome|bot|link/.test(e);
    } catch (e) {
      return !1;
    }
  }
  function Ar() {
    return /Firefox/.test(navigator.userAgent);
  }
  function Pr() {
    try {
      return /Edg\/8/.test(navigator.userAgent);
    } catch (e) {
      return !1;
    }
  }
  function Ur(e) {
    return "postMessage" in (e || window);
  }
  var Tr = "_cX_check";
  function Or() {
    try {
      return (
        window.localStorage.setItem(Tr, Tr),
        window.localStorage.removeItem(Tr),
        !0
      );
    } catch (e) {
      return !1;
    }
  }
  function Lr() {
    try {
      return (
        window.sessionStorage.setItem(Tr, Tr),
        window.sessionStorage.removeItem(Tr),
        !0
      );
    } catch (e) {
      return !1;
    }
  }
  function Rr() {
    var e = !1;
    try {
      var t = Object.defineProperty({}, "passive", {
        get: function () {
          return ((e = !0), !0);
        },
      });
      xr(window, "test", wr, t);
    } catch (e) {
    } finally {
      kr(window, "test", wr);
    }
    return e;
  }
  function Mr() {
    try {
      return window.history && "pushState" in window.history;
    } catch (e) {
      return !1;
    }
  }
  function Dr() {
    if (Ar()) return !0;
    var e = navigator.userAgent;
    return (
      (function (e) {
        if (/Chrom[[e|ium]+/i.test(e)) {
          var t = e.match(/Chrom[^ /]+\/(\d+)/i),
            n = t && t[1] && Un(t[1], 10);
          return !!n && (n < 51 || n >= 67);
        }
        return !1;
      })(e) ||
      (function (e) {
        var t = /iP.+;\sCPU\s.*OS\s12/i.test(e),
          n = /Mac\sOS\sX\s10_14/i.test(e),
          r =
            /^Mozilla\/[.\d].*\(Macintosh;.*Mac OS X\s*(?:\S.*)?\) AppleWebKit\/[.\d].*\(KHTML, like Gecko.*\)/i.test(
              e,
            );
        return (Er() || r) && !t && !n;
      })(e) ||
      (function (e) {
        if (/UCBrowser/i.test(e)) {
          var t = e.match(/UCBrowser\/(\d+)\.(\d+)\.(\d+)/i);
          if (t && t.length >= 4) {
            var n = Un(t[1], 10),
              r = Un(t[2], 10),
              i = Un(t[3], 10);
            return !(
              n < 12 ||
              (12 === n && r < 13) ||
              (12 === n && 13 === r && i < 2)
            );
          }
        }
        return !1;
      })(e)
    );
  }
  function Nr() {
    try {
      return "https:" === window.location.protocol;
    } catch (e) {
      return !1;
    }
  }
  function jr() {
    return document.body;
  }
  function Xr() {
    return En("cX-root");
  }
  function Hr() {
    return "hidden" === document.visibilityState;
  }
  function Wr(e) {
    var t = { left: 0, top: 0 };
    if (e.offsetParent)
      do {
        ((t.left += e.offsetLeft), (t.top += e.offsetTop));
      } while ((e = e.offsetParent));
    return t;
  }
  function Vr() {
    var e = { width: 0, height: 0 };
    return (
      $n(window.innerWidth)
        ? ((e.width = window.innerWidth), (e.height = window.innerHeight))
        : document.documentElement &&
            (document.documentElement.clientWidth ||
              document.documentElement.clientHeight)
          ? ((e.width = document.documentElement.clientWidth),
            (e.height = document.documentElement.clientHeight))
          : document.body &&
            (document.body.clientWidth || document.body.clientHeight) &&
            ((e.width = document.body.clientWidth),
            (e.height = document.body.clientHeight)),
      e
    );
  }
  function Fr() {
    var e = jr() || {},
      t = document.documentElement || {};
    return {
      width: Mn(
        t.clientWidth || 0,
        e.scrollWidth || 0,
        t.scrollWidth || 0,
        e.offsetWidth || 0,
        t.offsetWidth || 0,
      ),
      height: Mn(
        t.clientHeight || 0,
        e.scrollHeight || 0,
        t.scrollHeight || 0,
        e.offsetHeight || 0,
        t.offsetHeight || 0,
      ),
    };
  }
  function zr(e) {
    return e ? e.width + "x" + e.height : "";
  }
  function qr() {
    return window.top === window.self;
  }
  function Qr(e, t) {
    return !!Ur(window.parent) && (window.parent.postMessage(e, t), !0);
  }
  function Br(e, t, n, r) {
    return (
      !!(Ur() && e.contentWindow && e.contentWindow.postMessage) &&
      (e.contentWindow.postMessage(n, r || "*"), !0)
    );
  }
  function Yr() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      var n = arguments[t];
      Jn(n) && !or(e, n)
        ? e.push(n)
        : er(n) &&
          ar.forEach(n, function (t) {
            Jn(t) && !or(e, t) && e.push(t);
          });
    }
    return e;
  }
  function Gr(e, t, n, r) {
    if (rr(t)) {
      var i = Cn("script");
      ((i.async = !0),
        (i.type = "text/javascript"),
        n && (i.charset = n),
        r && (i.id = r),
        (i.src = e));
      var o = document.head || An("head")[0];
      o.insertBefore(i, o.firstChild);
    } else
      document.write(
        '<script type="text/javascript" src="' +
          e +
          '"' +
          (r ? ' id="' + r + '"' : "") +
          (n ? ' charset="' + n + '"' : "") +
          "><\/script>",
      );
  }
  var $r = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512];
  function Jr(t) {
    e.library.m_useCases |= $r[t];
  }
  function Kr(t) {
    (kn.set("siteId", t), (e.library.m_siteId = t));
  }
  function Zr() {
    return kn.get("siteId");
  }
  function ei() {
    return e.library.m_accountId;
  }
  function ti(t, n) {
    rr(n)
      ? (kn.setUnsafe("pageViewId", t), (e.library.m_rnd = t))
      : (e.library.m_rnd = kn.get("pageViewId"));
  }
  function ni() {
    return kn.get("pageViewId");
  }
  var ri = {
      cdn: "cdn.cxense.com",
      event: "comcluster.cxense.com",
      id: "id.cxense.com",
      p1: "p1cluster.cxense.com",
      api: "api.cxense.com",
      csyn: "csyn.cxense.com",
      csynR: "csyn-r.cxense.com",
      stats: "stats-collector.cxense.com",
    },
    ii = 395,
    oi = 7;
  function ai(e, t) {
    return "https://" + ri[e] + "/" + t;
  }
  function ci(e) {
    var t = {},
      n = e.replace(/\?/, "").replace(/#/, "").split("&");
    return (
      ar.forEach(n, function (e) {
        var n = e.split("=");
        if (2 === n.length) {
          var r = decodeURIComponent(n[0]),
            i = decodeURIComponent(n[1]);
          Bn(t[r]) ? (t[r] = i) : (er(t[r]) || (t[r] = [t[r]]), t[r].push(i));
        }
      }),
      t
    );
  }
  function si(e) {
    var t = "";
    return (
      sr.forEach(e, function (e, n) {
        Jn(e) || $n(e) || Gn(e)
          ? (t += (nr(t) ? "" : "&") + Pn(n) + "=" + Pn("" + e))
          : er(e) &&
            ar.forEach(e, function (e) {
              t += (nr(t) ? "" : "&") + Pn(n) + "=" + Pn("" + e);
            });
      }),
      t
    );
  }
  function ui(e) {
    var t = e || window.location.href || "",
      n = t.indexOf("#");
    return n > -1 ? t.slice(n + 1) : "";
  }
  function li(e) {
    return ci(ui(e));
  }
  function di(e) {
    return ci(e || window.location.search);
  }
  function fi(e, t, n) {
    var r = di(),
      i = li();
    return (
      n && (r[t] = n),
      e.replace(/[?#].*$/, "") +
        (ur(r) ? "" : "?" + si(r)) +
        (ur(i) ? "" : "#" + si(i))
    );
  }
  function pi(t) {
    var n;
    return (
      e.env.hasLocalStorage &&
        (n = e.library._consent.localStorage.get("_" + t)),
      n
    );
  }
  function mi(t, n, r) {
    e.env.hasLocalStorage &&
      e.library._consent.localStorage.set("_" + t, n, { expires: r || void 0 });
  }
  function vi(t) {
    e.env.hasLocalStorage && e.library._consent.localStorage.remove("_" + t);
  }
  function hi() {
    e.env.hasLocalStorage && e.library._consent.localStorage.expires();
  }
  var gi = ["pv", "segment", "ad", "recs"],
    yi = ["geo", "device"],
    wi = {
      sendPageViewEvent: "pv",
      sendActivityEvent: "pv",
      addExternalId: "pv",
      sendEvent: "pv",
      getUserSegmentIds: "segment",
      cint: "segment",
      sync: "ad",
      insertAdSpace: "ad",
      insertMultipleAdSpaces: "ad",
    };
  function bi() {
    for (var t; (t = e._consentCallQueue.shift()); ) e.callQueue.push(t);
  }
  function _i(t) {
    ((e.library.m_usesConsent = $n(t) || rr(t)),
      (e.library.m_consentVersion = $n(t) ? t : 1),
      e.library.m_usesConsent || bi(),
      e.callQueue.push(["_handleRequireOrChangeConsent"]));
  }
  function Ii() {
    return !!e.library.m_noConsentCache;
  }
  function Si() {
    return e.library && !!e.library.m_usesConsent;
  }
  function xi() {
    if (Ii()) return e.library.m_consentParameters;
    var t = pi("cX_cons");
    if (Yn(t)) return {};
    var n = {};
    return (
      sr.forEach(ci(t), function (e, t) {
        n[t] = "true" === e;
      }),
      n
    );
  }
  function ki(t) {
    return (
      !(
        2 === e.library.m_consentVersion ||
        !(function (e) {
          return or(yi, e);
        })(t)
      ) || !!xi()[t]
    );
  }
  function Ci(t, n) {
    try {
      var r = !Bn(n) && n.runCallQueue,
        i = fr({}, xi());
      i = fr(i, t);
      var o = sr.some(i, function (e) {
        return e;
      });
      if (Ii()) e.library.m_consentParameters = o ? i : {};
      else if (o) {
        mi("cX_cons", si(i), null);
      } else vi("cX_cons");
      (t && r && o && bi(),
        e.callQueue.push(["_handleRequireOrChangeConsent"]),
        (e.library.m_hasSetConsent = !0));
    } catch (e) {
      Wn(e);
    }
  }
  function Ei() {
    var e = xi(),
      t = ["y"];
    return (
      sr.forEach(e, function (e, n) {
        e && t.push(n);
      }),
      t
    );
  }
  function Ai() {
    return Ei().join(",");
  }
  var Pi = lr(lr([], gi), yi);
  function Ui(t) {
    Ci(
      (function (t) {
        var n = {};
        return (
          ar.forEach(2 === e.library.m_consentVersion ? Pi : gi, function (e) {
            n[e] = t;
          }),
          n
        );
      })(t),
      { runCallQueue: t },
    );
  }
  var Ti = function (e) {
      return function () {
        var t = e.dataLayer.get("consent");
        return (t && t[e.productName]) || null;
      };
    },
    Oi = function (e, t) {
      var n = null,
        r = function (r) {
          var i = (null == r ? void 0 : r[e.productName]) || null;
          i !== n && ((n = i), t(i));
        };
      return (
        e.dataLayer.addChangeListener("consent", r),
        function () {
          e.dataLayer.removeChangeListener(r);
        }
      );
    },
    Li = function (e, t) {
      return e.utils.checkConsent.createCheckConsentWrapper(t);
    },
    Ri = function (e, t, n) {
      var r = e.utils.checkConsent,
        i = r.itemsToMask(t),
        o = Object.keys(t).filter(function (e) {
          return !r.isMask(e);
        });
      return n().filter(function (e) {
        return o.includes(e) || r.getByMask(e, i);
      });
    },
    Mi = function (e, t, n) {
      var r,
        i = Ti(n),
        o = Li(n.dataLayer, {
          items: n.items,
          type: t,
          getConsent: i,
          product: n.productName,
        }),
        a = function (t) {
          var r;
          null === (r = o(Ri(n.dataLayer, n.items, e.getNames), t)) ||
            void 0 === r ||
            r.forEach(function (t) {
              t.allowed ? t.data && e.set(t.name, t.data) : e.remove(t.name);
            });
        };
      return (
        (r = void 0 === n.checkConsentOnInit && n.enableAutoRemove),
        n.enableAutoRemove && Oi(n, a),
        r && a(i()),
        Object.assign({}, e, {
          set: function (t, n, r) {
            var i,
              a = o(t);
            if (null == a ? void 0 : a.allowed) {
              var c = null !== (i = a.data) && void 0 !== i ? i : n,
                s = r ? [t, c, r] : [t, c];
              e.set.apply(null, s);
            }
          },
          check: o,
        })
      );
    },
    Di = function (e, t) {
      return {
        check: Li(t.dataLayer, {
          items: t.items,
          type: e,
          getConsent: Ti(t),
          product: t.productName,
        }),
      };
    },
    Ni = function (e) {
      var t = (function (e) {
          var t = d.__protected__.ttlName,
            n = { dataLayer: e, productName: "DL" },
            r = (function () {
              var e,
                r = Li(n.dataLayer, {
                  items: ((e = {}), (e[t] = "mandatory"), e),
                  type: "localStorage",
                  getConsent: Ti(n),
                  product: n.productName,
                });
              return function () {
                var e = r(t);
                return e.allowed && !e.data;
              };
            })(),
            i = !0,
            o = function () {
              (i = r()) || d.remove(t);
            };
          return (
            Oi(n, o),
            o(),
            function () {
              return i;
            }
          );
        })(e.dataLayer),
        n = Mi(d, "localStorage", e);
      return Object.assign({}, n, {
        set: function (e, r, i) {
          var o = i;
          return (
            (null == i ? void 0 : i.expires) &&
              !t() &&
              delete (o = Object.assign({}, i)).expires,
            n.set(e, r, o)
          );
        },
      });
    },
    ji = function (e) {
      var t = e.dataLayer.utils.checkConsent,
        n = Ti(e),
        r = {},
        i = [],
        o = {},
        a = {};
      Object.keys(e.items).forEach(function (n) {
        var a = e.items[n];
        if (a.type) {
          var c = a,
            s = c.type,
            u = c.domain,
            l = c.path,
            d = {};
          ((o[n] = s),
            u && (d.domain = u),
            l && (d.path = l),
            t.isMask(n) ? i.push(t.createMask(n, d)) : (r[n] = d));
        } else o[n] = a;
      });
      var c,
        s = Li(e.dataLayer, {
          items: o,
          type: "cookie",
          getConsent: n,
          product: e.productName,
        }),
        u = function (n) {
          var c;
          null === (c = s(Ri(e.dataLayer, o, l.getNames), n)) ||
            void 0 === c ||
            c.forEach(function (e) {
              var n = function () {
                return r[e.name] || t.getByMask(e.name, i) || a;
              };
              e.allowed
                ? e.data && l.set(e.name, e.data, n())
                : l.remove(e.name, n());
            });
        };
      ((c = !(void 0 !== e.checkConsentOnInit || !e.enableAutoRemove)),
        e.enableAutoRemove && ((a = e.enableAutoRemove), Oi(e, u)),
        c && u(n()));
      return Object.assign({}, l, {
        check: s,
        set: function (e, t, n, r) {
          var i,
            o = s(e);
          (null == o ? void 0 : o.allowed) &&
            l.set(e, null !== (i = o.data) && void 0 !== i ? i : t, n, r);
        },
      });
    },
    Xi = function (e) {
      return Mi(f, "sessionStorage", e);
    },
    Hi = function (e) {
      return Di("event", e);
    };
  function Wi(t, n, r, i, o, a, c) {
    e.library._consent.cookie.set(
      t,
      n,
      {
        expires: r || void 0,
        path: i,
        domain: o,
        secure: (a || e.library.m_usesSecureCookies) && e.env.isSecureProtocol,
        samesite: a && e.env.canSetSameSite && "lax",
      },
      c || 1024,
    );
  }
  function Vi(t) {
    return e.library._consent.cookie.get(t);
  }
  function Fi(t, n, r, i) {
    e.library._consent.cookie.remove(t, { path: n, domain: r, secure: i });
  }
  var zi = ["pantheon.io", "go-vip.net", "go-vip.co"];
  function qi() {
    return l.getTopLevelDomain(zi);
  }
  var Qi = { dataLayer: kn, productName: "DMP" },
    Bi = {
      items: {
        _cookie_test: "mandatory",
        cX_P: "essential",
        cX_G: "essential",
        cX_S: "essential",
        cX_segmentInfo: "essential",
        gckp: "essential",
        "cX_*": "optional",
      },
      enableAutoRemove: { domain: qi(), path: "/" },
    },
    Yi = {
      items: { _cX_segmentInfo: "essential", "_cX_*": "optional" },
      enableAutoRemove: !0,
    },
    Gi = {
      items: {
        _cX_S: "essential",
        _cX_partner: "essential",
        "_cX_*": "optional",
      },
      enableAutoRemove: !0,
    },
    $i = {
      items: {
        segment: "essential",
        pv: "essential",
        ad: "essential",
        recs: "essential",
        device: "optional",
        geo: "optional",
      },
    };
  function Ji(e) {
    return (
      !!window.pdl &&
      !!window.pdl.requireConsent &&
      (!e || window.pdl.requireConsent === e)
    );
  }
  function Ki(t) {
    return Si()
      ? !ki(t)
      : !!Ji() &&
          !(function (t) {
            var n = e.library._consent.events.check(t);
            return !Yn(n) && n.allowed;
          })(t);
  }
  function Zi(e) {
    return !Ki(e);
  }
  function eo(t) {
    var n;
    return (
      e.env.hasSessionStorage &&
        (n = e.library._consent.sessionStorage.get("_" + t)),
      n
    );
  }
  function to(t, n) {
    e.env.hasSessionStorage &&
      e.library._consent.sessionStorage.set("_" + t, n);
  }
  function no(e, t, n) {
    var r,
      i,
      o = n || {},
      a = "cXJsonpCB" + (r && (yr = 0), ++yr),
      c = a + "script";
    ((window[a] = function () {
      (i && clearTimeout(i), (window[a] = wr));
      try {
        Kn(t) && t.apply(window, arguments);
      } catch (e) {
        Wn(e);
      }
      var e = En(c);
      Yn(e) || Yn(e.parentElement) || e.parentElement.removeChild(e);
    }),
      o.timeout && (i = _r(window[a], o.timeout)),
      Vn("== jsonp request sent", e),
      Gr(e.replace(/\{\{callback\}\}/, Pn(a)), !o.synchronous, o.charset, c));
  }
  function ro(e, t, n) {
    var r = new Image();
    return (
      e && ((r.src = e), Vn("== image request sent", e)),
      Kn(t) && (r.onload = t),
      Kn(n) && (r.onerror = n),
      r
    );
  }
  function io(e, t, n) {
    var r = Cn("iframe");
    return (
      t && (r.onload = t),
      n && n.id && ((r.id = n.id), (r.name = n.id)),
      (r.width = "1"),
      (r.height = "1"),
      (r.src = e),
      (r.style.display = "none"),
      r.setAttribute("scrolling", "no"),
      r.setAttribute("frameBorder", "0"),
      {
        send: function (t) {
          return (
            (t || Xr() || jr()).appendChild(r),
            Vn("== iframe request sent", e),
            r
          );
        },
      }
    );
  }
  function oo(t) {
    return function (n) {
      e.library.m_activityState &&
        $n(e.library.m_activityState.pvLatency) &&
        (e.library.m_activityState.pvLatency = n - t);
    };
  }
  function ao(e) {
    var t = eo("cX_S");
    return (!t && rr(e) && to("cX_S", (t = gr())), t);
  }
  function co(t) {
    if (Ki("pv")) return null;
    try {
      if (tr(window.cXNative) && Kn(window.cXNative.getUserId)) {
        var n = window.cXNative.getUserId();
        if (n) return n;
      }
    } catch (e) {
      Wn(e);
    }
    var r = Vi("cX_P");
    if (!rr(t)) return r;
    r || (r = kn.get("browserId"));
    try {
      Fi("cX_P", "/");
    } catch (e) {
      Wn(e);
    }
    try {
      Fi("cX_P", "/", window.location.hostname);
    } catch (e) {
      Wn(e);
    }
    return (
      Wi("cX_P", r, e.library.m_maxCookieExpires, "/", qi()),
      kn.get("browserId")
    );
  }
  function so(t) {
    try {
      if (!Bn(t)) {
        try {
          Fi("cX_G", "/");
        } catch (e) {
          Wn(e);
        }
        try {
          Fi("cX_G", "/", window.location.hostname);
        } catch (e) {
          Wn(e);
        }
        Wi("cX_G", t, e.library.m_maxCookieExpires, "/", qi());
      }
      return Vi("cX_G");
    } catch (e) {
      Wn(e);
    }
  }
  function uo() {
    return so();
  }
  function lo(t, n, r, i, o) {
    var a = so();
    if (a) Kn(o) && o(a);
    else
      try {
        var c = [{ type: "ckp", id: t }];
        (n && c.push({ type: "lst", id: n }),
          r && c.push({ type: "cst", id: r }));
        var s =
          e.library.cxenseUserIdUrl +
          "?json=" +
          Pn(Cr.stringify({ identities: c, redirectLocation: i }));
        if (i) window.location.replace(s);
        else {
          no(s + "&callback={{callback}}", function (t) {
            try {
              var n = t.response;
              ((e.library.m_isNewUser = n.newUser),
                so(n.userId),
                Kn(o) && o(t));
            } catch (e) {
              Wn(e);
            }
          });
        }
      } catch (e) {
        Wn(e);
      }
  }
  function fo() {
    mi("cX_clearId", gr(), e.library.m_maxCookieExpires);
  }
  var po = [
      "cX_lastP1Time",
      "cX_lst",
      "cX_segmentInfo",
      "cX_atfr",
      "cX_expires",
      "cX_cintSet",
    ],
    mo = ["cX_S", "cX_SA"],
    vo = ["cX_P", "cX_G", "_cookie_test"];
  function ho() {
    if (!e.env.isSafari) {
      var t = io(e.library.clearBaseUrl, void 0, {
          id: "cx_rep_iframe_" + Xn(),
        }),
        n = En("cX-clear");
      if (n) t.send(n);
      else {
        var r = function () {
          jr() ? t.send(jr()) : _r(r, 100);
        };
        r();
      }
    }
    no(e.library.clearIdUrl + "?ngc=1&callback={{callback}}");
  }
  var go = "cxrecs_s";
  function yo() {
    var e = !1;
    try {
      window.location.href &&
        document.referrer &&
        "" !== window.location.href &&
        window.location.href.split("#")[0] === document.referrer &&
        (e = !0);
    } catch (e) {
      Wn(e);
    }
    return e;
  }
  function wo() {
    try {
      return /cXense/i.test(navigator.userAgent);
    } catch (e) {
      return (Wn(e), !1);
    }
  }
  function bo(t, n) {
    return (
      (t = t || window.location.href),
      (n = n || kn.get("referrer") || document.referrer),
      or(t, go) ||
        /cdn\.cxpublic\.com\/generic_v\d+\.html/.test(n) ||
        !0 === e.library.m_isSpaRecsDestination
    );
  }
  function _o(t, n) {
    "object" != typeof t ||
      Yn(t) ||
      (Bn(n) && (n = ""),
      sr.forEach(t, function (t, r) {
        if (!Bn(t)) {
          r = n + ((r = "" + r).length > 20 ? r.slice(0, 20) : r);
          var i = e.library.m_rawCustomParameters[r];
          ((e.library.m_rawCustomParameters[r] = t),
            er(t)
              ? ((t = t.slice(0, 10)),
                ar.forEach(t, function (e, n) {
                  t[n] = "" + e;
                }),
                (t = t.sort().join(",")))
              : (t = "" + t));
          var o = "cp_" + Pn(r);
          (i &&
            e.library.m_customParameters.splice(
              e.library.m_customParameters.indexOf(o + "=" + i),
              1,
            ),
            e.library.m_customParameters.push(o + "=" + Pn(t)));
        }
      }));
  }
  function Io(e) {
    to("cX_SA", si(e));
  }
  function So() {
    var e = {},
      t = eo("cX_SA");
    return (t && (e = ci(t)), e);
  }
  function xo(e) {
    (_o({ userState: e }), ti(kn.get("pageViewId")));
  }
  var ko = [
    "null",
    "undefined",
    "[object Object]",
    "false",
    "true",
    "NaN",
    "0",
  ];
  function Co() {
    var e = kn.get("users"),
      t = [];
    return (
      Yn(e) ||
        sr.forEach(e, function (e, n) {
          t.push({
            id: ("" + n).replace("{" + e.prefix + "}", ""),
            type: e.prefix,
          });
        }),
      t
    );
  }
  function Eo() {
    var e = "";
    return (
      ar.forEach(Co(), function (t, n) {
        ((e += "&eid" + n + "=" + Pn("" + t.id)),
          (e += "&eit" + n + "=" + Pn("" + t.type)));
      }),
      e
    );
  }
  function Ao(t) {
    if (Bn(t)) return !1;
    var n = e.library.cdn.template,
      r = [n.direct.http, n.direct.https, n.mapped.http, n.mapped.https],
      i = t.toLowerCase();
    return ar.some(r, function (e) {
      return or(i, e.replace(/^https?/, ""));
    });
  }
  function Po() {
    var e = kn.get("referrer") || document.referrer;
    if (Ao(e)) {
      var t = e.match(/[?&]ref=([^&#$]+)/);
      t && 2 === t.length && (e = decodeURIComponent(t[1]));
    }
    return e;
  }
  function Uo() {
    var e = kn.get("content");
    return !Yn(e) && e.modifiedAt
      ? $n(e.modifiedAt)
        ? e.modifiedAt
        : Date.parse(e.modifiedAt) / 1e3
      : null;
  }
  function To(e) {
    return ei() + "_" + Zr() + "_" + (e || window.location.href);
  }
  function Oo(t) {
    return e.library.m_previousPageViewReport === To(t);
  }
  function Lo(e) {
    return !Oo(e);
  }
  function Ro(t) {
    e.library.m_customEventAttributes = t;
  }
  function Mo() {
    if (!Zi("pv")) {
      var t = window.location.href;
      if (Lo(t))
        ((e.library.m_previousPageViewReport = To(t)),
          ro(
            e.library.eventReceiverBaseUrlGif +
              "?" +
              si({ con: "y", loc: t, sid: Zr(), rnd: ni() }),
          ));
    }
  }
  function Do() {
    Hr() && Mo();
  }
  function No(t) {
    return e.library.m_widgetSpecs[t];
  }
  function jo(t, n) {
    e.library.m_widgetSpecs[t] = n;
  }
  function Xo(e, t, n, r) {
    return e * (t + n + r);
  }
  function Ho(e) {
    var t = e.elementId,
      n = No(t);
    if (n) {
      var r = Un(e.matchedAdCount, 10),
        i = "false" !== e.isVerticallyOriented,
        o = !1;
      if (n.onImpressionResult && Kn(n.onImpressionResult)) {
        var a = {
          elementId: t,
          matchedAdCount: r,
          isVerticallyOriented: i,
          contentWidth: e.contentWidth,
          contentHeight: e.contentHeight,
        };
        o = !1 === n.onImpressionResult(a);
      }
      if (!o) {
        var c = En(t);
        !n.resizeToContentSize && n.adUnitWidth && n.adUnitHeight && n.margins
          ? i
            ? ((c.style.height =
                Xo(r, n.adUnitHeight, n.margins.top, n.margins.bottom) + "px"),
              0 === n.initialHorizontalAdUnits &&
                (c.style.width =
                  Xo(1, n.adUnitWidth, n.margins.left, n.margins.right) + "px"))
            : ((c.style.width =
                Xo(r, n.adUnitWidth, n.margins.left, n.margins.right) + "px"),
              0 === n.initialVerticalAdUnits &&
                (c.style.height =
                  Xo(1, n.adUnitHeight, n.margins.top, n.margins.bottom) +
                  "px"))
          : rr(n.resizeToContentSize) &&
            (Bn(e.contentWidth) || (c.style.width = e.contentWidth + "px"),
            Bn(e.contentHeight) || (c.style.height = e.contentHeight + "px"));
      }
    }
  }
  function Wo() {
    var e = Cn("div");
    return (
      (e.innerHTML = "&nbsp;"),
      (e.style.clear = "both"),
      (e.style.width = "0"),
      (e.style.height = "0"),
      (e.style.border = "0"),
      (e.style.margin = "0"),
      (e.style.padding = "0"),
      (e.style.outline = "0"),
      (e.style.overflow = "hidden"),
      e
    );
  }
  function Vo(e) {
    var t = {};
    return (
      sr.forEach(e, function (n, r) {
        "media" === r ||
          "renderTemplateUrl" === r ||
          "useMappedRenderTemplate" === r ||
          "rnd" === r ||
          0 === r.indexOf("lf-") ||
          ("asId" === r
            ? (t.adSpaceId = n)
            : "auw" === r
              ? (t.adUnitWidth = Un(e.auw, 10))
              : "auh" === r
                ? (t.adUnitHeight = Un(e.auh, 10))
                : (t[r] = n));
      }),
      t
    );
  }
  function Fo(e) {
    var t = { left: 0, top: 0, right: 0, bottom: 0 };
    try {
      if (e) {
        var n = br(e).replace(/\s+/g, " ").split(" "),
          r = [];
        (ar.forEach(n, function (e, t) {
          r[t] = Un(e, 10);
        }),
          1 === r.length &&
            ((t.top = r[0]),
            (t.right = r[0]),
            (t.bottom = r[0]),
            (t.left = r[0])),
          2 === r.length &&
            ((t.top = r[0]),
            (t.right = r[1]),
            (t.bottom = r[0]),
            (t.left = r[1])),
          3 === r.length &&
            ((t.top = r[0]),
            (t.right = r[1]),
            (t.bottom = r[2]),
            (t.left = r[1])),
          4 === r.length &&
            ((t.top = r[0]),
            (t.right = r[1]),
            (t.bottom = r[2]),
            (t.left = r[3])));
      }
    } catch (e) {
      Wn(e);
    }
    return t;
  }
  function zo(e) {
    return "#text" === e.nodeName.toLowerCase();
  }
  function qo(t) {
    return e.env.hasHistory ? (zo(t) ? t.data : t.value) : t.nodeValue;
  }
  function Qo(t, n) {
    e.env.hasHistory
      ? zo(t)
        ? (t.data = n)
        : (t.value = n)
      : (t.nodeValue = n);
  }
  var Bo =
    "on(click|change|(un)?load|error|focus|key(down|press|up)|mouse(over|move|down|up|out)|drag(start|enter|leave|over|end)?|drop|touch(start|end|cancel|move))$";
  function Yo(e) {
    var t = qo(e);
    if (t && or(t, "{{")) {
      new RegExp("^tmp:" + Bo, "i").test(e.nodeName)
        ? Qo(e, t.replace(/\{\{(window\['([^\]]*)'\])\}\}/g, "$1"))
        : Qo(
            e,
            t.replace(/\{\{window\['([^\]]*)'\]\}\}/g, function (e, t) {
              var n = window[t];
              return (delete window[t], n);
            }),
          );
    }
  }
  function Go(e) {
    if (e instanceof Element && e.attributes && !nr(e.attributes)) {
      for (var t = [], n = 0; n < e.attributes.length; n++) {
        var r = e.attributes[n];
        (Yo(r), 0 === r.nodeName.indexOf("tmp:") && (t[t.length] = r));
      }
      for (var i = 0; i < t.length; i++) {
        var o = t[i],
          a = o.nodeName.replace(/^tmp:/, ""),
          c = qo(o);
        Yn(c) ||
          ("style" === a
            ? e.setAttribute("style", c)
            : "class" === a
              ? (e.className = c)
              : new RegExp("^" + Bo, "i").test(a)
                ? (e[a] = new Function(c))
                : (e[a] = c));
        try {
          e.removeAttribute && e.removeAttribute(o.nodeName);
        } catch (e) {
          Wn(e);
        }
      }
    }
    if ((zo(e) && Yo(e), e.childNodes && !nr(e.childNodes)))
      for (var s = 0; s < e.childNodes.length; s++) {
        Go(e.childNodes[s]);
      }
  }
  function $o(e, t, n, r) {
    for (var i = 0; or(e, "\x3c!--<"); ) {
      if (
        ((e = e.replace(/<!--<\s*"([^"]*)"\s*>-->/g, function (e, t) {
          return En(t).innerHTML;
        })),
        ++i > 40)
      )
        break;
    }
    var o = "\nvar html = '';\n";
    ((o += "var varPrefix = 'cXTmplMgck' + '" + gr() + "';\n"),
      (o += "var varIndex = 0;\n"));
    for (var a = e.split("%--\x3e"), c = 0; c < a.length; c++) {
      var s = a[c].split("\x3c!--%"),
        u = s[0];
      nr(br(u)) ||
        (or(
          (u = u
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/\t/g, "\\t")
            .replace(/'/g, "\\'")),
          "{{",
        )
          ? ((o += "var localText = '" + u + "';\n"),
            (o += "var replaceFunc = function (str, p1, p2, offset, s) {\n"),
            (o += "    var varName = varPrefix + varIndex;\n"),
            (o += "    varIndex++;\n"),
            (o += "    try {\n "),
            (o += "    window[varName] = eval(p1);\n"),
            (o += "    } catch(e) {\n"),
            (o += "        window[varName] = '';\n"),
            (o += Hn() ? "        console.error(e); \n" : ""),
            (o += "    }\n"),
            (o += "    return '{{window[\\'' + varName + '\\']}}';\n"),
            (o += "}\n"),
            (o +=
              "localText = localText.replace(/{{([^}]*)}}/g, replaceFunc);\n"),
            (o += "html += localText;\n"))
          : (o += "html += '" + u + "';\n"));
      var l = "";
      (s.length > 1 &&
        (l = (l = (l = br(s[1])).replace(
          /(cX\.(library\.)?defaultAdRenderer)/g,
          "html += $1",
        )).replace(/(cX\.(library\.)?renderContainedImage)/g, "html += $1")),
        (o += l + "\n"));
    }
    o += "return html;\n";
    var d = new Function("data", "context", o)(n, r),
      f = En(t);
    f.innerHTML = d;
    for (var p = 0; p < f.childNodes.length; p++) {
      Go(f.childNodes[p]);
    }
  }
  function Jo(e, t, n, r) {
    $o(" " + En(e).innerHTML + " ", t, n, r);
  }
  function Ko(t, n) {
    if (((n = n || {}), !wo())) {
      var r = (function (t, n) {
          Si() && (n.consent = Ei());
          var r = co(),
            i = window.cx_props ? vr(window.cx_props, t) : t;
          if (
            ((i.k = window.cx_props ? Yr(window.cx_props.k, t.k) : Yr(t.k)),
            i.forwardHashArgs)
          ) {
            var o = Vo(li());
            if (
              (((i = o ? vr(o, i) : i).k = o ? Yr(o.k, i.k) : i.k),
              o.requestObject)
            ) {
              var a = "cxParse_" + gr();
              ((window[a] = Cr.parse(o.requestObject)), (n = fr(window[a], n)));
            }
          }
          ((n = fr({ context: { referrer: Po() } }, n)),
            qr() && (n.context.autoRefresh = yo()));
          var c = "html",
            s = "?",
            u = !(!i.renderTemplateUrl && !i.useMappedRenderTemplate),
            l = Co();
          if (u || i.isSlave)
            ((s = "#"),
              (i.widgetId || n.widgetId) &&
                (s += "requestObject=" + Pn(Cr.stringify(n)) + "&"),
              er(l) && !nr(l) && (s += Eo().replace("&", "") + "&"));
          else if (
            (i.templateElementId ||
              i.renderFunction ||
              i.widgetId ||
              n.widgetId) &&
            ((c = "javascript"),
            !i.adSpaceId && !i.adSpaceIds && (i.widgetId || n.widgetId))
          ) {
            ((n.widgetId = n.widgetId || i.widgetId),
              i.backend &&
                ((n.backend = i.backend), (i.backend = "production")),
              (n.user = fr({ ids: {} }, n.user || {})),
              Zi("pv")
                ? ((n.user.ids.usi = i.usi || r),
                  er(l) &&
                    !nr(l) &&
                    ar.forEach(l, function (e) {
                      n.user.ids[e.type] = e.id;
                    }))
                : (n.user = void 0));
            var d = n.context || (n.context = {});
            (d.url || (d.url = i.ctx || window.location.href),
              (n.prnd = i.prnd || ni()),
              2 === e.library.m_consentVersion && (n.consentVersion = "2"),
              (s += "json=" + Pn(Cr.stringify(n)) + "&"));
          }
          (i.adSpaceIds &&
            ((c = "multipart-html-json"),
            (s += "asId=" + i.adSpaceIds.join("&asId=") + "&")),
            i.adSpaceId &&
              er(i.adSpaceId) &&
              ((c = "javascript"),
              (s += "asId=" + i.adSpaceId.join("&asId=") + "&")),
            (s += "media=" + Pn(c)),
            i.adSpaceId &&
              (er(i.adSpaceId) || (s += "&asId=" + Pn(i.adSpaceId)),
              (i.initialHorizontalAdUnits = i.initialHorizontalAdUnits || 0),
              (i.initialVerticalAdUnits = i.initialVerticalAdUnits || 0),
              (i.adUnitWidth = i.adUnitWidth || 0),
              (i.adUnitHeight = i.adUnitHeight || 0)),
            Bn(i.siteId)
              ? "0" !== Zr() && (s += "&sid=" + Pn(Zr()))
              : (s += "&sid=" + Pn(i.siteId)));
          var f = [
              "k",
              "delayImpression",
              "forwardHashArgs",
              "renderTemplateUrl",
              "requestObject",
              "useSecureUrls",
              "useMappedRenderTemplate",
              "templateElementId",
              "targetElementId",
              "onImpressionResult",
              "siteId",
              "adSpaceId",
              "adSpaceIds",
              "parentId",
              "appendToElementId",
              "insertBeforeElementId",
              "adUnitWidth",
              "adUnitHeight",
              "loc",
              "synchronous",
              "masterTargetElementId",
              "initialVerticalAdUnits",
              "initialHorizontalAdUnits",
              "destinationUrlParameters",
              "destinationUrlPrefix",
              "ctrlLinksCss",
              "ctrlSpaAttr",
            ],
            p = [
              "backend",
              "secureBaseAdDeliveryUrl",
              "baseAdDeliveryUrl",
              "width",
              "height",
            ];
          sr.forEach(i, function (e, t) {
            if (
              (Kn(e) ||
                ("parentElementId" === t && "html" !== c) ||
                or(f, t) ||
                (!u && or(p, t)) ||
                (s += "&" + Pn(t) + "=" + Pn(e)),
              "k" === t && i.k)
            ) {
              var n = i.k;
              ar.forEach(n, function (e) {
                s += "&k=" + Pn(e);
              });
            }
            if (
              "destinationUrlParameters" === t &&
              i.destinationUrlParameters
            ) {
              var r = "",
                o = !0,
                a = i.destinationUrlParameters;
              (sr.forEach(a, function (e, t) {
                Kn(e) ||
                  (o || (r += "&"), (r += Pn(t) + "=" + Pn(e)), (o = !1));
              }),
                (s += "&" + Pn(t) + "=" + Pn(r)));
            }
            "destinationUrlPrefix" === t &&
              (s += "&dup=" + Pn(i.destinationUrlPrefix));
          });
          var m =
            i.baseAdDeliveryUrl ||
            e.library.backends[i.backend || "production"].baseAdDeliveryUrl;
          try {
            e.env.isSecureProtocol &&
              ((s += "&useSecureUrls=true"),
              (m =
                i.secureBaseAdDeliveryUrl ||
                e.library.backends[i.backend || "production"]
                  .secureBaseAdDeliveryUrl));
          } catch (e) {
            Wn(e);
          }
          if (i.renderTemplateUrl || i.useMappedRenderTemplate) {
            if (i.renderTemplateUrl)
              ((m = i.renderTemplateUrl),
                e.env.isSecureProtocol &&
                  (m = m.replace(
                    /https?:\/\/cdn\.cxpublic\.com\//gi,
                    e.library.cdn.template.direct.https,
                  )));
            else {
              if (i.widgetId)
                ((m =
                  e.library.cdn.template.mapped.http +
                  "Widget_" +
                  i.widgetId +
                  ".html"),
                  e.env.hasHistory ||
                    (m += "?ref=" + Pn(window.location.href)));
              else {
                var v =
                  "sandbox" === i.backend
                    ? "AdSpaceSandbox"
                    : "AdSpaceProduction";
                m =
                  e.library.cdn.template.mapped.http +
                  v +
                  "_" +
                  i.adSpaceId +
                  ".html";
              }
              e.env.isSecureProtocol &&
                (m = m.replace(
                  /https?:\/\/cdn-templates\.cxpublic\.com\//gi,
                  e.library.cdn.template.mapped.https,
                ));
            }
            if (!i.ctx)
              try {
                s += "&ctx=" + Pn(window.location.href.replace(/#.*$/, ""));
              } catch (e) {
                Wn(e);
              }
          } else
            i.isSlave
              ? (m =
                  "http" +
                  (e.env.isSecureProtocol ? "s://" : "://") +
                  "cdn.cxense.com/adspace-slave.html")
              : n.widgetId && (m = e.library.publicWidgetDataUrl);
          if (
            !u &&
            "html" === c &&
            i.adSpaceId &&
            i.adUnitWidth &&
            i.adUnitHeight
          )
            try {
              s += "&sz=" + Pn(i.adUnitWidth + "x" + i.adUnitHeight);
            } catch (e) {
              Wn(e);
            }
          if (!i.usi && !Yn(r))
            try {
              s += "&usi=" + Pn(r);
            } catch (e) {
              Wn(e);
            }
          s += Eo();
          try {
            s += "&rnd=" + hr();
          } catch (e) {
            Wn(e);
          }
          if (!i.prnd)
            try {
              s += "&prnd=" + ni();
            } catch (e) {
              Wn(e);
            }
          if (!i.tzo)
            try {
              s += "&tzo=" + Pn("" + Qn());
            } catch (e) {
              Wn(e);
            }
          if (i.uhm)
            try {
              window.location.href.length < 1e3 &&
                (s += "&loc=" + Pn(window.location.href));
            } catch (e) {
              Wn(e);
            }
          return (
            Si() ? (s += "&con=" + Ai()) : Ki("pv") && (s += "&con=y"),
            [i, n, s, m, c]
          );
        })(t, n),
        i = r[0];
      n = r[1];
      var o,
        a = r[2],
        c = r[3],
        s = r[4],
        u = Fo(i["lf-am"]),
        l = "cxWidget_" + Xn();
      i.adSpaceIds ||
        jo(l, {
          adSpaceId: i.adSpaceId,
          widgetId: i.widgetId,
          experienceId: i.experienceId,
          element: null,
          margins: u,
          visible: {
            maxPercent: 0,
            prevPercent: 0,
            timeNone: 0,
            timePartly: 0,
            timeHalf: 0,
            timeFully: 0,
          },
          callbacks: [],
          triggers: [],
          initialHorizontalAdUnits: i.initialHorizontalAdUnits,
          initialVerticalAdUnits: i.initialVerticalAdUnits,
          adUnitWidth: i.adUnitWidth,
          adUnitHeight: i.adUnitHeight,
          resizeToContentSize: i.resizeToContentSize,
          onImpressionResult: i.onImpressionResult,
        });
      var d = No(l);
      if (i.adSpaceIds) {
        var f,
          p = io(c + (a += "&synchronous=true"), i.masterOnLoadHandler, {
            id: i.masterId,
          });
        (i.masterTargetElementId
          ? (f = En(i.masterTargetElementId))
          : (f = En("insertAdSpaceBeforeThis_" + i.adSpaceIds[0])) ||
            (f = En("scriptForAdSpace_" + i.adSpaceIds[0])),
          f && p.send(f));
      } else if ("html" === s) {
        var m = Bn(i.width)
            ? Xo(i.initialHorizontalAdUnits, i.adUnitWidth, u.left, u.right)
            : i.width,
          v = Bn(i.height)
            ? Xo(i.initialVerticalAdUnits, i.adUnitHeight, u.top, u.bottom)
            : i.height;
        try {
          a += "&parentElementId=" + Pn(l);
        } catch (e) {
          Wn(e);
        }
        if (
          (((o = Cn("iframe")).id = l),
          (o.name = l),
          (o.width = "" + m),
          (o.height = "" + v),
          !0 === i.delayImpression
            ? ((d.delayImpressionSrc = c + a),
              (d.src = e.library.emptyWidgetUrl))
            : (d.src = c + a),
          (o.src = d.src),
          (o.style.display = "block"),
          o.setAttribute("scrolling", "no"),
          o.setAttribute("frameBorder", "0"),
          i.appendToElementId)
        ) {
          var h = En(i.appendToElementId);
          h && h.appendChild(o);
        } else {
          var g = i.insertBeforeElementId || i.targetElementId;
          g || (g = "insertAdSpaceBeforeThis_" + i.adSpaceId);
          var y = En(g);
          (y || ((g = "scriptForAdSpace_" + i.adSpaceId), (y = En(g))),
            y && y.parentNode && y.parentNode.insertBefore(o, y));
        }
        d.element = o;
      } else {
        if (
          (i.experienceId && (a += "&experienceId=" + Pn(i.experienceId)),
          no(
            c + (a += "&callback={{callback}}"),
            function (e) {
              if (
                (Kn(i.renderFunction) && i.renderFunction(e, i),
                i.templateElementId &&
                  i.targetElementId &&
                  Jo(i.templateElementId, i.targetElementId, e, i),
                i.parentElementId && i.resizeToContentSize && n && n.widgetId)
              ) {
                var t = jr(),
                  r = Wo(),
                  o = Wo();
                (t.insertBefore(r, t.firstChild), t.appendChild(o));
                var a = t.clientWidth || t.offsetWidth;
                if (i.targetElementId)
                  for (var c = En(i.targetElementId); c && c !== t; )
                    ((a = c.clientWidth || c.offsetWidth),
                      (c = c.offsetParent));
                (Qr(
                  "method=updateAdSpace&contentWidth=" +
                    a +
                    "&contentHeight=" +
                    (t.offsetHeight || t.clientHeight) +
                    "&elementId=" +
                    Pn(i.parentElementId),
                  "*",
                ),
                  t.removeChild(r),
                  t.removeChild(o));
              }
              if (Kn(i.onImpressionResult)) {
                var s = {};
                if (
                  e &&
                  e.searchResult &&
                  e.searchResult.spaces &&
                  e.searchResult.spaces[0]
                ) {
                  var u = e.searchResult.spaces[0];
                  ((s.matchedAdCount = u.ads ? u.ads.length : 0),
                    (s.isVerticallyOriented = u.isVerticallyOriented));
                }
                i.onImpressionResult(s, e, i);
              }
            },
            { synchronous: i.synchronous },
          ),
          i.targetElementId)
        ) {
          var w = En(i.targetElementId);
          w && (d.element = w);
        }
      }
    }
  }
  function Zo(e) {
    if (!Ki("ad")) return Ko(e);
  }
  function ea(e) {
    var t = "cXTmplMgck" + gr();
    return ((window[t] = e), "{{window['" + t + "']}}");
  }
  function ta(e) {
    var t = e.element || En(e.elementId),
      n = t.id || "cXElId" + gr(),
      r = No(n);
    (r ||
      (jo(n, {
        element: t,
        widgetElId: n,
        visible: {
          maxPercent: 0,
          prevPercent: 0,
          timeNone: 0,
          timePartly: 0,
          timeHalf: 0,
          timeFully: 0,
        },
        callbacks: [],
        triggers: [],
      }),
      (r = No(n))),
      e.callback && r.callbacks.push(e.callback),
      e.trigger && r.triggers.push(e.trigger));
  }
  function na(e) {
    return Jn(e) && "&" === e[0] ? e : null;
  }
  function ra() {
    return e.library.m_activityState;
  }
  function ia(t, n) {
    if (!Ki("pv")) {
      var r = !!t && (Gn(t) ? !!t : !!t.heartbeat),
        i = pi("cX_atfr");
      ((i = na(i)), r || vi("cX_atfr"));
      var o =
        e.library.activityPushUrl +
        "?" +
        si({
          ver: "2.8.92",
          rnd: ni(),
          ckp: co(),
          loc: window.location.href,
          sid: Zr(),
          glb: uo() || "",
        }) +
        i;
      (!r &&
        (function (e, t) {
          var n = !1;
          try {
            return (
              (n = navigator.sendBeacon(e)),
              Kn(t) && t.apply(window, arguments),
              Vn("== beacon request sent", e),
              n
            );
          } catch (e) {
            return (Wn(e), !1);
          }
        })(o, n)) ||
        ro(o, n);
    }
  }
  function oa() {
    Hr() && ia();
  }
  var aa = !1;
  function ca(e) {
    return function () {
      aa || ((aa = !0), e());
    };
  }
  function sa() {
    (xr(document, "visibilitychange", ca(oa), !0),
      xr(window, "pagehide", ca(ia), !0));
  }
  function ua() {
    var e = { left: 0, top: 0 },
      t = ra();
    return (
      t.currScrollTop || t.currScrollLeft
        ? ((e.top = t.currScrollTop), (e.left = t.currScrollLeft))
        : (e = (function () {
            var e = { left: 0, top: 0 };
            return (
              $n(window.scrollY)
                ? ((e.top = window.scrollY), (e.left = window.scrollX))
                : document.body &&
                    (document.body.scrollLeft || document.body.scrollTop)
                  ? ((e.top = document.body.scrollTop),
                    (e.left = document.body.scrollLeft))
                  : document.documentElement &&
                    (document.documentElement.scrollLeft ||
                      document.documentElement.scrollTop) &&
                    ((e.top = document.documentElement.scrollTop),
                    (e.left = document.documentElement.scrollLeft)),
              e
            );
          })()),
      e
    );
  }
  function la() {
    ra().hadHIDActivity = !0;
  }
  function da() {
    try {
      la();
    } catch (e) {
      Wn(e);
    }
    return !0;
  }
  function fa(e) {
    var t = ra();
    try {
      (Ln(t.prevScreenX - e.screenX) > 1 ||
        Ln(t.prevScreenY - e.screenY) > 1) &&
        ((t.prevScreenX = e.screenX), (t.prevScreenY = e.screenY), la());
    } catch (e) {
      Wn(e);
    }
    return !0;
  }
  function pa(e) {
    return !!e && "IFRAME" === e.nodeName.toUpperCase();
  }
  function ma() {
    var t = Vr(),
      n = ra(),
      r = "&";
    return (
      (r += si({
        altm: e.library.m_scriptStartTime,
        arnd: ni(),
        aatm: Rn(n.activeTime / 1e3),
        axtl: n.exitLink,
        awsz: t.width + "x" + t.height,
        amvw: n.maxViewLeft + "x" + n.maxViewTop,
        ascp: n.scrollDepthPercentage + "x" + n.scrollDepthPixels,
        aclk: bo() ? 1 : 0,
        ause: e.library.m_useCases.toString(16),
      })),
      n.pvLatency > 0 && (r += "&altc=" + n.pvLatency),
      (r += (function () {
        var t = "",
          n = "",
          r = "",
          i = "",
          o = "",
          a = 0;
        for (var c in e.library.m_widgetSpecs) {
          var s = No(c);
          if (s && (s.adSpaceId || s.widgetId)) {
            var u = s.adSpaceId || s.widgetId;
            if (
              ((t += (0 === a ? "&aaid=" : ",") + Pn(u)),
              0 === a
                ? ((o = "&aavp="),
                  (i = "&aaps="),
                  (n = "&aasz="),
                  (r = "&aavt="))
                : ((o += ","), (i += ","), (n += ","), (r += ",")),
              s.element)
            ) {
              var l = Wr(s.element);
              ((o += Pn("" + s.visible.maxPercent)),
                (i += Pn(l.left + "x" + l.top)),
                (n += Pn(s.element.offsetWidth + "x" + s.element.offsetHeight)),
                (r += Pn(
                  Rn(s.visible.timePartly / 1e3) +
                    "x" +
                    Rn(s.visible.timeFully / 1e3),
                )));
            }
            if (++a > 10) break;
          }
        }
        return t + o + r + n + i;
      })())
    );
  }
  function va() {
    window.requestAnimationFrame(function () {
      ra().activeTime > 0 && mi("cX_atfr", ma(), null);
    });
  }
  function ha(e) {
    try {
      la();
      for (var t = e.target, n = 0; n < 10 && !Bn(t) && !Yn(t); n++) {
        if (
          1 === t.nodeType &&
          (r = t) &&
          "A" === r.nodeName.toUpperCase() &&
          t.href
        ) {
          ((ra().exitLink = t.href), va());
          break;
        }
        t = t.parentNode;
      }
    } catch (e) {
      Wn(e);
    }
    var r;
    return !0;
  }
  function ga() {
    return (
      (!Gn(e.shouldPoll) && !Gn(e.library.shouldPoll)) ||
      !(!e.library.shouldPoll && !e.shouldPoll)
    );
  }
  function ya() {
    return e.shouldPollActiveTime || e.library.shouldPollActiveTime || !1;
  }
  function wa() {
    var e = ra(),
      t = (function () {
        var e = !1,
          t = Vr(),
          n = ra();
        try {
          (n.prevWindowWidth === t.width && n.prevWindowHeight === t.height) ||
            ((n.prevWindowWidth = t.width),
            (n.prevWindowHeight = t.height),
            (e = !0));
        } catch (e) {
          Wn(e);
        }
        return [e, t];
      })(),
      n = (function () {
        var e = !1,
          t = ua(),
          n = ra();
        try {
          (n.prevScrollLeft === t.left && n.prevScrollTop === t.top) ||
            ((n.prevScrollLeft = t.left), (n.prevScrollTop = t.top), (e = !0));
        } catch (e) {
          Wn(e);
        }
        return [e, t];
      })(),
      r = t[1],
      i = n[1],
      o = t[0] || n[0] || e.hadHIDActivity;
    try {
      ((e.maxViewLeft = Mn(i.left + r.width, e.maxViewLeft)),
        (e.maxViewTop = Mn(i.top + r.height, e.maxViewTop)));
    } catch (e) {
      Wn(e);
    }
    if (o) {
      e.hadHIDActivity = !1;
      var a = zn(),
        c = Dn(3e4, a - e.prevActivityTime);
      ((e.activeTime += c), (e.prevActivityTime = a), va());
    }
  }
  function ba(e, t, n, r) {
    if (
      (100 === t && 100 === e.visible.prevPercent && (e.visible.timeFully += n),
      t >= 50 && e.visible.prevPercent >= 50 && (e.visible.timeHalf += n),
      t > 0 && e.visible.prevPercent > 0
        ? (e.visible.timePartly += n)
        : (e.visible.timeNone += n),
      r(),
      !nr(e.callbacks) || !nr(e.triggers))
    ) {
      var i = {
        visibility: {
          percent: t,
          previousPercent: e.visible.prevPercent,
          maxPercent: e.visible.maxPercent,
          timeNone: e.visible.timeNone / 1e3,
          timeSome: e.visible.timePartly / 1e3,
          timeHalf: e.visible.timeHalf / 1e3,
          timeFull: e.visible.timeFully / 1e3,
        },
      };
      ar.forEach(e.callbacks, function (e) {
        try {
          e(i);
        } catch (e) {
          Wn(e);
        }
      });
      for (var o = 0; o < e.triggers.length; o++) {
        var a = e.triggers[o];
        try {
          if (a.on(i)) {
            if (a.callback)
              try {
                a.callback(i);
              } catch (e) {
                Wn(e);
              }
            (a.imageUrl && ro(a.imageUrl), e.triggers.splice(o, 1), o--);
          }
        } catch (e) {
          Wn(e);
        }
      }
    }
    e.visible.prevPercent = t;
  }
  function _a() {
    window.requestAnimationFrame(function () {
      wa();
    });
  }
  function Ia() {
    ga() &&
      (wa(),
      (function () {
        var t = ra(),
          n = Vr(),
          r = ua(),
          i = zn();
        if (qr() || t.parentMetrics) {
          var o = i - t.prevTime;
          ((t.prevTime = i),
            sr.forEach(e.library.m_widgetSpecs, function (e, a) {
              try {
                var c = No(a);
                if (Tn.call(c, "element") && c.element) {
                  var s = c.element,
                    u = Wr(s),
                    l = { width: s.offsetWidth, height: s.offsetHeight },
                    d = Mn(u.left, r.left),
                    f = Dn(u.left + l.width, r.left + n.width),
                    p = Mn(u.top, r.top),
                    m = Dn(u.top + l.height, r.top + n.height),
                    v = t.parentMetrics;
                  v &&
                    ((d = Mn(v.overlapPos.left + r.left, d)),
                    (f = Dn(
                      v.overlapPos.left + v.overlapSize.width + r.left,
                      f,
                    )),
                    (p = Mn(v.overlapPos.top + r.top, p)),
                    (m = Dn(
                      v.overlapPos.top + v.overlapSize.height + r.top,
                      m,
                    )));
                  var h = Mn(f - d, 0),
                    g = Mn(m - p, 0),
                    y = Rn(((h * g) / (l.width * l.height)) * 100);
                  if (
                    (ba(c, y, o, function () {
                      if (y > c.visible.maxPercent) {
                        if (0 === c.visible.maxPercent)
                          try {
                            c.delayImpressionSrc &&
                              ((c.src = c.delayImpressionSrc),
                              pa(s) &&
                                s.contentWindow &&
                                s.contentWindow.location.replace(c.src));
                          } catch (e) {
                            Wn(e);
                          }
                        c.visible.maxPercent = y;
                      }
                    }),
                    pa(s))
                  ) {
                    var w = [
                      i,
                      r.left,
                      r.top,
                      n.width,
                      n.height,
                      u.left,
                      u.top,
                      l.width,
                      l.height,
                      d - u.left,
                      p - u.top,
                      h,
                      g,
                      -1,
                      -1,
                    ];
                    ar.forEach(w, function (e, t) {
                      w[t] = Rn(e);
                    });
                    var b =
                      "method=updateParentMetrics&parentMetrics=" + w.join(",");
                    qr() && c.src && Br(s, c.src, b, "*");
                  }
                }
              } catch (e) {
                Wn(e);
              }
            }),
            va());
        }
      })());
  }
  function Sa(e) {
    var t,
      n = ra(),
      r = e.target;
    Yn(r) ||
      ((n.currScrollLeft = r.scrollLeft),
      (n.currScrollTop = r.scrollTop),
      (t = r.scrollHeight));
    var i = ua(),
      o = Vr(),
      a = Fr(),
      c = Rn(i.top + o.height),
      s = Dn(Rn((100 * c) / (t || a.height)), 100);
    s > n.scrollDepthPercentage &&
      ((n.scrollDepthPercentage = s), (n.scrollDepthPixels = c));
  }
  function xa(e) {
    var t = ra(),
      n = e.parentMetrics.split(","),
      r = [];
    (ar.forEach(n, function (e, t) {
      r[t] = Un(e, 10);
    }),
      (t.parentMetrics = {
        updateTime: r[0],
        scrollPos: { left: r[1], top: r[2] },
        windowSize: { width: r[3], height: r[4] },
        widgetPos: { left: r[5], top: r[6] },
        widgetSize: { width: r[7], height: r[8] },
        overlapPos: { left: r[9], top: r[10] },
        overlapSize: { width: r[11], height: r[12] },
        documentSize: { width: r[13], height: r[14] },
      }));
  }
  var ka = function () {
    var e = null;
    return (
      (window.__pctx_connection__ = function (t) {
        if (t) {
          var n = t("get-data");
          ((e = Object.assign({}, n.getCachedData())), n.terminate());
        }
        return "uvm42pas28m";
      }),
      e
    );
  };
  function Ca() {
    return e.library && !!uo();
  }
  function Ea(e) {
    return e > 6
      ? 10
      : (function (e) {
          var t = (1 + jn(5, 0.5)) / 2,
            n = (1 - jn(5, 0.5)) / 2;
          return Nn((jn(t, e) - jn(n, e)) / jn(5, 0.5));
        })(e + 2) - 1;
  }
  function Aa(e, t, n, r, i, o) {
    if (!Ki("pv")) {
      var c,
        s = fr({}, t),
        u = fr(s, n),
        l = fr(u, r),
        d = fr(l, "in-screen" === e ? {} : i),
        f = si(fr(d, "in-screen" === e ? {} : o)),
        p = (function (e, t) {
          if (((t = t || 4095), e.length > t)) {
            var n = e.slice(0, t),
              r = n.lastIndexOf("&"),
              i = n.lastIndexOf("%2C"),
              o = Mn(r, i);
            return -1 === o ? n : n.slice(0, o);
          }
          return e;
        })(a.statsCollectorUrl + "/" + e + "?" + f);
      Kn(window.fetch)
        ? ((c = p), window.fetch(c), Vn("== fetch request sent", c))
        : no(p);
    }
  }
  function Pa() {
    var e = {},
      t = {};
    try {
      t = ka() || {};
    } catch (e) {
      Wn(e);
    }
    var n = t.content,
      r = t.consent;
    return (
      (e.ckp = t.browserId),
      (e.rnd = t.pageViewId),
      Ca() && (e.cxId = uo()),
      fr(
        e,
        (function (e) {
          var t = {};
          return (
            e.siteId && (t.cxSiteId = e.siteId),
            window.tp && window.tp.aid && (t.ciSiteId = window.tp.aid),
            window.pa && (t.paSiteId = window.pa.getConfiguration("site")),
            t
          );
        })(t || {}),
      ),
      fr(
        e,
        (function (e) {
          return {
            cCreatedAt: e.createdAt,
            cAuthor: e.authors ? e.authors.join(",") : void 0,
            cSection: e.section,
            cTags: e.tags,
            cType: e.type,
            t: e.title,
          };
        })(n || {}),
      ),
      fr(
        e,
        (function (e) {
          if (!Ji()) return {};
          var t = e.PA ? e.PA.mode : "not-acquired";
          return { conPurpose: Ji("v2") ? "AM" : void 0, conMode: t };
        })(r || {}),
      ),
      e
    );
  }
  function Ua() {
    var e = window.googletag.pubads();
    if (Kn(e.getTargeting)) {
      var t = {},
        n = e.getTargeting("permutive"),
        r = e.getTargeting("CxSegments");
      return (
        n && !nr(n) && (t = fr(t, { permutiveSids: n.join(",") })),
        r && !nr(r) && (t = fr(t, { cxSids: r.join(",") })),
        t
      );
    }
    return {};
  }
  function Ta() {
    var e =
      window.instBid && Kn(window.instBid.getUserIds)
        ? window.instBid.getUserIds()
        : window.pbjs && Kn(window.pbjs.getUserIds)
          ? window.pbjs.getUserIds()
          : {};
    return e && !ur(e) ? { userIdSources: sr.keys(e).join(",") } : {};
  }
  function Oa(e, t, n) {
    a.suspendEvents
      ? a._eventsCache.push([e, t, n])
      : Aa(e, t, n, Pa(), Ua(), Ta());
  }
  function La() {
    return { location: window.location.href };
  }
  function Ra(e) {
    var t = e.getResponseInformation();
    return Yn(t)
      ? { adId: null, bnId: null, pId: e.getAdUnitPath() }
      : {
          adId: t.lineItemId || t.sourceAgnosticLineItemId,
          bnId: t.creativeId || t.sourceAgnosticCreativeId,
          pId: e.getAdUnitPath(),
        };
  }
  function Ma(e) {
    return e.adId + "_" + e.bnId + "_" + e.pId;
  }
  var Da = {},
    Na = {},
    ja = {},
    Xa = {};
  function Ha() {
    return "viewability" === a.mode;
  }
  function Wa(e) {
    try {
      if (e.slot) {
        var t = Ra(e.slot),
          n = Ma(t);
        if (e.isEmpty) return;
        if (!t.adId && !t.bnId) return;
        if (
          (Da[n]
            ? ja[n] && clearTimeout(ja[n])
            : (Da[n] = { adId: t.adId, bnId: t.bnId, pId: t.pId }),
          Kn(e.slot.getOutOfPage) && e.slot.getOutOfPage())
        )
          return;
        Ha() || Oa("imp", La(), t);
      } else Vn("== ARI Event slot is undefined", e);
    } catch (e) {
      Wn(e);
    }
  }
  function Va(e) {
    var t = Ma(e);
    (ja[t] && clearTimeout(ja[t]),
      (ja[t] = window.setTimeout(
        function () {
          if (Da[t]) {
            var n = Nn((zn() - Da[t].timeOnScreen) / 1e3);
            if (((e.timeOnScreen = n), n >= 60))
              return void (Na[t] && (Na[t] = 0));
          }
          (Na[t]++, Oa("in-screen", La(), e), Va(e));
        },
        1e3 * Ea(Na[t]),
      )));
  }
  function Fa(e) {
    try {
      if (e.slot) {
        var t = Ra(e.slot),
          n = Ma(t);
        (Da[n] || (Da[n] = { adId: t.adId, bnId: t.bnId, pId: t.pId }),
          (Na[n] = 0),
          (Da[n].timeOnScreen = zn() - 1e3),
          Kn(e.slot.getOutOfPage) &&
            e.slot.getOutOfPage() &&
            (Ha() || Oa("imp", La(), t)),
          Va(t));
      } else Vn("== ARI Event slot is undefined", e);
    } catch (e) {
      Wn(e);
    }
  }
  function za(e) {
    try {
      if (e.slot) {
        var t = Ma(Ra(e.slot));
        e.inViewPercentage < 1 &&
          (ja[t] && clearTimeout(ja[t]), Na[t] && (Na[t] = 0));
      } else Vn("== ARI Event slot is undefined", e);
    } catch (e) {
      Wn(e);
    }
  }
  function qa(e) {
    try {
      if (tr(e) && Jn(e.data)) {
        var t = ci(e.data);
        "click" === t.gptEvent &&
          Jn(t.gptParams) &&
          !Ha() &&
          Oa("click", La(), Cr.parse(t.gptParams));
      }
    } catch (e) {
      Wn(e);
    }
  }
  function Qa() {
    ((a._eventsCache = []),
      (window.googletag = window.googletag || { cmd: [] }),
      window.googletag.cmd.push(function () {
        var e = window.googletag.pubads();
        (e.addEventListener("slotRenderEnded", Wa),
          e.addEventListener("impressionViewable", Fa),
          e.addEventListener("slotVisibilityChanged", za),
          xr(window, "message", qa));
      }),
      (window.OBREvents = window.OBREvents || []));
    var e = {};
    return (
      window.OBREvents.push({
        name: "rendered",
        widgetId: "all",
        callback: function (t) {
          var n = t.servedWidgetId || t.widgetId;
          setTimeout(function () {
            e[n] || Oa("wid", La(), { adPlatform: "outbrain", pId: n });
          }, 10);
        },
      }),
      window.OBREvents.push({
        name: "norecs",
        widgetId: "all",
        callback: function (t) {
          e[t.servedWidgetId || t.widgetId] = !0;
        },
      }),
      (window._taboola = window._taboola || []),
      window._taboola.push({
        listenTo: "render",
        handler: function (e) {
          var t = br(e.detail.placement.split("|")[0]);
          Xa[t] ||
            ((Xa[t] = { adPlatform: "taboola", pId: t }),
            Oa("wid", La(), Xa[t]));
        },
      }),
      function () {
        kr(window, "message", qa);
      }
    );
  }
  function Ba() {
    try {
      for (var t, n = sr.keys(wi); (t = e.callQueue.shift()); ) {
        var r = t[0];
        if (
          Ki(wi[r]) &&
          ar.some(n, function (e) {
            return r === e;
          })
        )
          e._consentCallQueue.push(t);
        else
          try {
            if ("prebid" === r) e._prebidCallQueue.push(t);
            else {
              var i = t.slice(1);
              (("invoke" !== r || (Kn(i[0]) && "cceFunction" !== i[0].name)) &&
                (Hn() && Fn(r, i),
                Vn("== callQueue: cX.library." + r, Cr.stringify(i))),
                e.library[r].apply(e.library, i));
            }
          } catch (e) {
            Wn(e);
          }
      }
    } catch (e) {
      Wn(e);
    }
  }
  function Ya(t) {
    var n = e.library.m_clientStorage.messageContexts[t.id];
    if (n) {
      var r = Bn(t.value) ? null : t.value;
      ("OK" !== t.result
        ? n.error && n.error(t.result)
        : n.success && n.success(r),
        (e.library.m_clientStorage.messageContexts[t.id] = void 0));
    }
  }
  function Ga() {
    var t = e.library.m_clientStorage;
    t.iframeEl ||
      (t.iframeEl = io(t.iframeOrigin + t.iframePath, function () {
        var e;
        for (t.iframeIsLoaded = !0; (e = t.messageQueue.shift()); )
          try {
            t.iframeEl &&
              t.iframeEl.contentWindow &&
              t.iframeEl.contentWindow.postMessage(e, t.iframeOrigin);
          } catch (i) {
            try {
              var n = ci(e);
              if (Jn(n.id)) {
                var r = t.messageContexts[n.id];
                r.error && r.error("PostMessageError: " + i);
              }
            } catch (e) {
              Wn(e);
            }
          }
      }).send());
  }
  function $a(t, n) {
    var r = e.library.m_clientStorage;
    if (
      (n &&
        (n.error || n.success) &&
        ((t.id = gr()), (r.messageContexts[t.id] = n)),
      e.env.hasLocalStorage && Ur())
    ) {
      Ga();
      var i = si(t);
      r.iframeIsLoaded
        ? r.iframeEl &&
          r.iframeEl.contentWindow &&
          r.iframeEl.contentWindow.postMessage(i, r.iframeOrigin)
        : r.messageQueue.push(i);
    } else n && n.error && n.error("MissingPostMessageOrLocalStorage");
  }
  var Ja,
    Ka,
    Za = {
      pv: [1, 9, 10],
      ad: [2, 3, 4, 7, 9],
      recs: [1, 5, 6, 8],
      segment: [2, 3, 4, 7, 9],
    },
    ec = {},
    tc = {};
  function nc(e) {
    (Jr(1), (ec = e));
  }
  function rc(e, t) {
    for (var n = {}, r = 1; r <= t; r++) Bn(e[r]) ? (n[r] = !1) : (n[r] = e[r]);
    return n;
  }
  function ic(e, t, n) {
    Kn(window.__tcfapi)
      ? window.__tcfapi(e, 2, t, n)
      : _r(function () {
          ic(e, t, n);
        }, 10);
  }
  function oc(e) {
    ic("addEventListener", function (t, n) {
      var r, i, o, a, c, s;
      if (n) {
        if (
          t &&
          ("tcloaded" === t.eventStatus ||
            "useractioncomplete" === t.eventStatus)
        ) {
          if (!t.gdprApplies) return (_i(!1), void (Kn(e) && e(t, n)));
          if (!t.vendor.consents[412]) return (Ui(!1), void (Kn(e) && e(t, n)));
          var u =
            ((r = (t.publisher && t.publisher.restrictions) || {}),
            (i = t.purpose.consents),
            (o = t.specialFeatureOptins),
            (a = []),
            (c = rc(i, 10)),
            (s = rc(o, 2)),
            sr.forEach(Za, function (e, t) {
              (ec[t] && (e = ec[t]),
                sr.forEach(r, function (n, r) {
                  e.indexOf(Un(r, 10)) >= 0 && 0 === n[412] && a.push(t);
                }),
                sr.forEach(c, function (n, r) {
                  !n && e.indexOf(Un(r, 10)) > -1 && a.push(t);
                }));
            }),
            s[1] || tc.geo || a.push("geo"),
            s[2] || tc.device || a.push("device"),
            a);
          (Ci(
            {
              pv: !or(u, "pv"),
              ad: !or(u, "ad"),
              recs: !or(u, "recs"),
              segment: !or(u, "segment"),
              device: !or(u, "device"),
              geo: !or(u, "geo"),
            },
            { runCallQueue: !0 },
          ),
            Kn(e) && e(t, n));
        }
      } else Kn(e) && e({}, n);
    });
  }
  function ac() {
    (Jr(0), (e.library.m_usesTcf20Consent = !0), _i(2), oc());
  }
  function cc(t, n) {
    (kn.init(tr(n) ? n : void 0),
      (t._consent = (function () {
        var t = ji(fr(fr({}, Qi), Bi)),
          n = Ni(fr(fr({}, Qi), Yi)),
          r = Xi(fr(fr({}, Qi), Gi)),
          i = Hi(fr(fr({}, Qi), $i));
        return (
          kn.addChangeListener("consent", function (t) {
            if (!Yn(t) && t.DMP) {
              var n = e.library._consent.cookie.check("gckp");
              Yn(n) || n.allowed || e.callQueue.push(["_clearThirdPartyIds"]);
            }
          }),
          { cookie: t, localStorage: n, sessionStorage: r, events: i }
        );
      })()));
  }
  function sc() {
    (kr(document, "visibilitychange", Do, !0), kr(window, "pagehide", Mo, !0));
  }
  function uc() {
    try {
      (sc(),
        Ki("pv") &&
          (xr(document, "visibilitychange", Do, !0),
          xr(window, "pagehide", Mo, !0)));
    } catch (e) {
      Wn(e);
    }
  }
  function lc(t) {
    var n,
      r,
      i = e.options || {},
      o = t ? "" : e.library.m_referrer;
    (fr(e.library, {
      clearIdUrl: (n = i.makeUrlEndpoint || ai)("event", "public/clearid"),
      eventReceiverBaseUrlGif: n("event", "Repo/rep.gif"),
      p1BaseUrl: n("cdn", "sp1.html"),
      clearBaseUrl: n("cdn", "sclear.html"),
      cxenseUserIdUrl: n("id", "public/user/id"),
      p1JsUrl: n("p1", "p1.js"),
      dmpPushUrl: n("event", "dmp/push?callback={{callback}}"),
      activityPushUrl: n("event", "activity/push"),
      userSegmentUrl: n("api", "profile/user/segment?callback={{callback}}"),
      segmentLookupUrl: n("api", "segment/lookup?callback={{callback}}"),
      cookieSyncUrl: n("csyn", ""),
      cookieSyncRUrl: n("csynR", ""),
      publicWidgetDataUrl: n("api", "public/widget/data"),
      emptyWidgetUrl: n("", "empty.html"),
      statsCollectorUrl: n("stats", "cr-stats/event"),
      backends: {
        production: {
          baseAdDeliveryUrl: "http://adserver.cxad.cxense.com/adserver/search",
          secureBaseAdDeliveryUrl:
            "https://s-adserver.cxad.cxense.com/adserver/search",
        },
        sandbox: {
          baseAdDeliveryUrl:
            "http://adserver.sandbox.cxad.cxense.com/adserver/search",
          secureBaseAdDeliveryUrl:
            "https://s-adserver.sandbox.cxad.cxense.com/adserver/search",
        },
      },
      cdn: {
        template: {
          direct: {
            http: "http://cdn.cxpublic.com/",
            https: "https://cdn.cxpublic.com/",
          },
          mapped: {
            http: "http://cdn-templates.cxpublic.com/",
            https: "https://cdn-templates.cxpublic.com/",
          },
        },
      },
      csdUrls: {
        domainScriptUrl: "//csd.cxpublic.com/d/",
        customerScriptUrl: "//csd.cxpublic.com/t/",
      },
    }),
      fr(e, {
        env: {
          nodeEnv: "production",
          canSetSameSite: Dr(),
          isSafari: Er(),
          isEdgeNotChromium: Pr(),
          isFirefox: Ar(),
          isSecureProtocol: Nr(),
          hasHistory: Mr(),
          hasLocalStorage: Or(),
          hasSessionStorage: Lr(),
        },
      }),
      i.dataLayer &&
        i.dataLayer.cookie &&
        ((i.dataLayer.cookieDefault = i.dataLayer.cookie),
        delete i.dataLayer.cookie),
      cc(e.library, i.dataLayer),
      t || (Mo(), kn.set("referrer", o), kn.refresh()),
      (function (t, n, r, i, o, a, c) {
        ((t.m_logs = []),
          (t.m_isNewUser = o),
          (t.m_rnd = t.m_rnd || r),
          (t.m_siteId = t.m_siteId || "0"),
          (t.m_accountId = t.m_accountId || "0"),
          (t.m_customParameters = []),
          (t.m_rawCustomParameters = {}),
          (t.m_atfr = null),
          (t.m_isSpaRecsDestination = !!t.m_isSpaRecsDestination),
          (t.m_spaRecsClickUrl = Jn(t.m_spaRecsClickUrl)
            ? t.m_spaRecsClickUrl
            : null),
          (t.m_clientStorage = {
            messageContexts: {},
            messageQueue: [],
            iframeEl: null,
            iframeIsLoaded: !1,
            iframeOrigin: "https://clientstorage.cxense.com",
            iframePath: "/clientstorage_v2.html",
          }),
          (t.m_timerIds = []),
          (t.m_useCases = 0),
          (t.m_widgetSpecs = {}),
          (t.m_previousPageViewReport = null),
          (t.m_p1Complete = !1),
          (t.m_previousSegmentReport = []),
          (t.m_scriptStartTime = i),
          (t.m_activityState = {
            parentMetrics: void 0,
            prevActivityTime: i,
            prevTime: i,
            exitLink: "",
            activeTime: 0,
            prevScreenX: 0,
            prevScreenY: 0,
            maxViewLeft: 0,
            maxViewTop: 0,
            prevScrollLeft: 0,
            prevScrollTop: 0,
            currScrollLeft: 0,
            currScrollTop: 0,
            prevWindowWidth: 0,
            prevWindowHeight: 0,
            scrollDepthPercentage: 0,
            scrollDepthPixels: 0,
            pvLatency: 0,
          }),
          (t.m_atfr = null),
          (t.m_externalUserIds = []),
          (t.m_usesSecureCookies = rr(n.secureCookies)),
          (t.m_usesConsent = !!n.consent),
          (t.m_consentVersion = n.consentVersion ? n.consentVersion : 1),
          (t.m_consentParameters = {}),
          (t.m_hasSetConsent = a),
          (t.m_noConsentCache = !!n.noConsentCache),
          (t.m_usesTcf20Consent = !1),
          (t.m_referrer = c));
        var s = e.env.isSafari || e.env.isFirefox || e.env.isEdgeNotChromium;
        ((t.m_thirdPartyIds = s
          ? "edgeid" === n.thirdPartyIds && "edgeid"
          : "edgeid" === n.thirdPartyIds || rr(n.thirdPartyIds)),
          t.m_thirdPartyIds && Jr(3),
          (t.m_maxCookieExpires = n.maxCookieExpires || ii),
          (t.shouldPoll = Gn(e.shouldPoll) ? e.shouldPoll : rr(n.shouldPoll)),
          (t.m_activityEvents = !!t.shouldPoll && rr(n.activityEvents)));
      })(
        e.library,
        i,
        kn.get("pageViewId"),
        zn(),
        !co(!1),
        !!pi("cX_cons"),
        kn.get("referrer"),
      ),
      t || Jr(8),
      xo(kn.get("userStatus")),
      kn.addChangeListener("userStatus", function (e) {
        xo(e);
      }),
      Kn(i.makeUrlEndpoint) && Jr(9),
      i.tcf20Restrictions && nc(i.tcf20Restrictions),
      i.tcf20SpecialFeatures && ((r = i.tcf20SpecialFeatures), Jr(1), (tc = r)),
      i.tcf20 && ac());
    var a = pi("cX_atfr");
    ((e.library.m_atfr = na(a)), vi("cX_atfr"));
    try {
      var c = Yn(e.library.m_spaRecsClickUrl)
          ? {}
          : ci(e.library.m_spaRecsClickUrl.split("?")[1] || ""),
        s = di(),
        u = vr(s, li(), c),
        l = {},
        d = "edge_id",
        f = "newUser",
        p = "ref";
      if ("edgeid" === e.library.m_thirdPartyIds && s && s[d]) {
        var m = [d];
        (so(s[d]),
          s[p] && (kn.set("referrer", s[p]), m.push(p)),
          s[f] && ((e.library.m_isNewUser = "false" !== s[f]), m.push(f)),
          window.history.replaceState(
            {},
            "",
            (function (e, t) {
              var n = [];
              n = er(t) ? t : [t];
              var r = e;
              return (
                ar.forEach(n, function (e) {
                  var t = new RegExp("([?&])" + e + "=.*?(&|$)", "i");
                  ("&" !==
                    (r = r.replace(t, function (e, t, n) {
                      return "?" === t ? t : n;
                    })).slice(-1) &&
                    "?" !== r.slice(-1)) ||
                    (r = r.slice(0, -1));
                }),
                r
              );
            })(window.location.href, m),
          ));
      }
      (sr.forEach(u, function (e, t) {
        var n = "" + t;
        0 === n.indexOf("cx_") && (l[n.slice(3)] = e);
      }),
        _o(l));
    } catch (e) {
      Wn(e);
    }
    ((e.library.m_isSpaRecsDestination = !!e.library.m_spaRecsClickUrl),
      (e.library.m_spaRecsClickUrl = null),
      uc(),
      (function (t) {
        (t.siteId && Kr(t.siteId),
          (t.customParameters || t.externalIds) && (t.pageView = !0),
          t.customEventAttributes && Ro(t.customEventAttributes),
          "0" === Zr() ||
            Bn(e.callQueue) ||
            (t.customParameters &&
              e.callQueue.push(["setCustomParameters", t.customParameters]),
            t.externalIds &&
              ar.forEach(t.externalIds, function (t) {
                e.callQueue.push(["addExternalId", t]);
              }),
            t.pageView &&
              e.callQueue.push([
                "sendPageViewEvent",
                tr(t.pageView) ? t.pageView : {},
              ]),
            t.cookieSyncs &&
              ar.forEach(t.cookieSyncs, function (t) {
                e.callQueue.push(["sync", t]);
              }),
            t.segments &&
              ar.forEach(t.segments, function (t) {
                e.callQueue.push(["getUserSegmentIds", t]);
              })));
      })(i));
  }
  function dc(t) {
    try {
      if (tr(t) && Jn(t.data)) {
        var n = ci(t.data);
        Bn(n.elementId) || "updateAdSpace" !== n.method
          ? "updateParentMetrics" === n.method
            ? xa(n)
            : "setCxenseUserIdParent" === n.method
              ? ((e.library.m_p1Complete = !0), lo(co(!1), n.lst, n.cst))
              : "clientStorageResult" === n.method &&
                  t.origin === e.library.m_clientStorage.iframeOrigin
                ? (Jr(2), Ya(n))
                : "sendBasicPageView" === n.method && ro(n.repSrc)
          : Ho(n);
      }
    } catch (e) {
      Wn(e);
    }
  }
  function fc() {
    var e = Ir(Sa, 100);
    (xr(window, "message", dc),
      xr(window, "scroll", e, !0),
      xr(document, "keypress", da),
      xr(document, "keydown", da),
      xr(document, "keyup", da),
      xr(document, "mousedown", ha, !0),
      xr(document, "mousemove", fa));
  }
  function pc() {
    if (ya()) {
      try {
        _a();
      } catch (e) {
        Wn(e);
      }
      (clearTimeout(Ja), (Ja = _r(pc, 500)));
    }
  }
  function mc() {
    if (ga()) {
      try {
        Ia();
      } catch (e) {
        Wn(e);
      }
      (clearTimeout(Ka), (Ka = _r(mc, 500)));
    }
  }
  function vc() {
    (clearTimeout(Ka), clearTimeout(Ja));
  }
  function hc() {
    Ki("pv") || (vc(), ga() && _r(mc, 200), ya() && _r(pc, 200));
  }
  function gc() {
    (!(function () {
      try {
        (localStorage.getItem("_cX_P") && localStorage.removeItem("_cX_P"),
          localStorage.getItem("_cX_G") && localStorage.removeItem("_cX_G"),
          Vi("cX_segmentInfo") && Fi("cX_segmentInfo"),
          Vi("cX_partner") && Fi("cX_partner"),
          Vi("cX_S") && Fi("cX_S"));
      } catch (e) {
        Wn(e);
      }
    })(),
      sr.some(xi(), function (e) {
        return e;
      }) || vi("cX_cons"),
      (function () {
        try {
          var e = localStorage.getItem("_cX_expires");
          if (e) {
            var t = ci(e);
            (sr.forEach(t, function (e, n) {
              t[n] = parseInt(e, 10).toString(36);
            }),
              localStorage.setItem("_ls_ttl", Cr.stringify(t)),
              localStorage.removeItem("_cX_expires"));
          }
        } catch (e) {
          Wn(e);
        }
      })());
  }
  function yc(t) {
    (Jr(6),
      e.callQueue.push([
        "invoke",
        function () {
          ((a.statsCollectorUrl = e.library.statsCollectorUrl),
            (a.suspendEvents = !Ca()),
            (a.mode = t),
            Qa(),
            a.suspendEvents &&
              (function e() {
                Ca()
                  ? (sr.forEach(a._eventsCache, function (e) {
                      Aa(e[0], e[1], e[2], Pa(), Ua(), Ta());
                    }),
                    (a.suspendEvents = !1),
                    (a._eventsCache = []))
                  : _r(function () {
                      e();
                    }, 50);
              })());
        },
      ]));
  }
  function wc(e, t) {
    return (
      e.source === window.parent &&
      e.origin !== window.location.origin &&
      e.data &&
      "amp" === e.data.sentinel &&
      e.data.type === t
    );
  }
  function bc(e) {
    return function (t) {
      wc(t, "intersection") &&
        ar.forEach(t.data.changes, function (t) {
          !(function (e, t) {
            var n = zn(),
              r = ra(),
              i = n - r.prevTime;
            r.prevTime = n;
            var o = No(e),
              a = Rn(100 * t);
            ba(o, a, i, function () {
              a > o.visible.maxPercent && (o.visible.maxPercent = a);
            });
          })(e, t.intersectionRatio);
        });
    };
  }
  var _c = "0037",
    Ic = ["219", "220", "221", "223", "224", _c, "226", "222"];
  function Sc(e, t) {
    var n = "";
    return (
      (n +=
        '<a class="ad" rel="nofollow" tmp:href="' +
        ea(t.clickUrl) +
        '" target="_blank">\n'),
      (n += '<img tmp:src="' + ea(t.creative.source) + '" border="0" alt=""'),
      (n += ' width="' + t.creative.spec.width + '"'),
      (n += ' height="' + t.creative.spec.height + '" />\n'),
      (n += "</a>\n")
    );
  }
  function xc(e, t) {
    var n = "";
    ((n +=
      '<a class="ad" rel="nofollow" tmp:href="' +
      ea(t.clickUrl) +
      '" target="_blank"'),
      (n +=
        ' style="height: ' +
        e.adUnitHeight +
        "px; width: " +
        e.adUnitWidth +
        'px;">\n'),
      (n += '<span class="title">' + ea(t.creative.title) + "</span>\n"),
      (n += '<span class="body">\n'));
    for (var r = 0; r < t.creative.content.length; r++)
      n += "<span>" + ea(t.creative.content[r]) + "</span><br />\n";
    return (
      (n += "</span>\n"),
      t.creative.displayUrl &&
        (n += '<span class="url">' + ea(t.creative.displayUrl) + "</span>\n"),
      (n += "</a>\n")
    );
  }
  function kc(e, t) {
    var n = t.creative.spec.width,
      r = t.creative.spec.height,
      i = Pn(t.clickUrl),
      o =
        t.creative.source +
        (t.creative.source.indexOf("?") > -1 ? "&" : "?") +
        "clickTAG=" +
        i +
        "&clickTag=" +
        i +
        "&clicktag=" +
        i +
        "&clickTARGET=_blank",
      a = "cXFlashObj" + gr(),
      c = t.creative.imageSource;
    return (
      '<div style="width: ' +
      n +
      "px; height: " +
      r +
      'px; margin: 0; padding: 0; border: 0; outline: 0; display: inline-block;">\n<object id="' +
      a +
      'obj" classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" width="' +
      n +
      '" height="' +
      r +
      '">\n  <param name="AllowScriptAccess" value="never" />\n  <param name="movie" value="' +
      o +
      '" />\n  <param name="wmode" value="transparent" />\n  \x3c!--[if !IE]>--\x3e\n  <object id="' +
      a +
      'obj2" type="application/x-shockwave-flash" data="' +
      o +
      '" width="' +
      n +
      '" height="' +
      r +
      '">\n    <param name="AllowScriptAccess" value="never" />\n    <param name="movie" value="' +
      o +
      '" />\n    <param name="wmode" value="transparent" />\n  \x3c!--<![endif]--\x3e\n    <a class="ad" rel="nofollow" href="' +
      t.clickUrl +
      '" target="_blank" style="width: ' +
      n +
      "px; height: " +
      r +
      'px;">\n' +
      (c
        ? '    <img src="' +
          c +
          '" width="' +
          n +
          '" height="' +
          r +
          '" alt="Flash ad" />\n'
        : "") +
      "    </a>\n  \x3c!--[if !IE]>--\x3e\n  </object>\n  \x3c!--<![endif]--\x3e\n</object>\n</div>\n"
    );
  }
  function Cc(e, t) {
    var n = "";
    ((n +=
      '<a class="ad" rel="nofollow" tmp:href="' +
      ea(t.clickUrl) +
      '" target="_blank">\n'),
      (n += '<span class="title">' + ea(t.creative.title) + "</span>\n"),
      (n += '<span class="body">\n'));
    for (var r = 0; r < t.creative.content.length; r++) {
      n += "<span>" + ea(t.creative.content[r].value) + "</span><br />\n";
    }
    ((n += "</span>\n"),
      t.creative.displayUrl &&
        (n += '<span class="url">' + ea(t.creative.displayUrl) + "</span>\n"));
    for (var i = 0; i < t.creative.images.length; i++) {
      var o = t.creative.images[i];
      ((n += '<img tmp:src="' + ea(o.source) + '" border="0" alt=""'),
        (n += ' width="' + o.width + '"'),
        (n += ' height="' + o.height + '" />\n'));
    }
    for (var a = 0; a < t.creative.flashFiles.length; a++) {
      var c = t.creative.flashFiles[a];
      n += kc(0, {
        creative: {
          source: c.source,
          type: "FlashCreativeFeature",
          spec: { width: c.width, height: c.height },
        },
        clickUrl: t.clickUrl,
      });
    }
    return (n += "</a>\n");
  }
  function Ec(e, t) {
    var n,
      r,
      i,
      o = "",
      a = "cXThirdParty" + gr();
    return (
      (o +=
        '<iframe id="' +
        a +
        '" width="' +
        e.adUnitWidth +
        '" height="' +
        e.adUnitHeight +
        '" frameborder="0"></iframe>'),
      _r(
        ((n = a),
        (r = t.creative.thirdPartyAdCode),
        (i = r),
        function () {
          var e = En(n),
            t = e.contentDocument || e.contentWindow.document;
          (t.open(),
            t.write("<!DOCTYPE HTML>\n"),
            t.write("<html>\n"),
            t.write("<head>\n<title></title>\n"),
            t.write(
              '<style type="text/css">html, body, div { margin:0; padding: 0; }</style>\n',
            ),
            t.write('</head>\n<body style="overflow:hidden;">\n'),
            t.write(i + "\n</body>\n</html>\n"));
        }),
        1,
      ),
      o
    );
  }
  function Ac(e) {
    Kn(window.__tcfapi)
      ? ic("addEventListener", function (t, n) {
          n &&
            (("tcloaded" !== t.eventStatus &&
              "useractioncomplete" !== t.eventStatus) ||
              (e(t),
              t.listenerId && ic("removeEventListener", wr, t.listenerId)));
        })
      : e();
  }
  function Pc(e) {
    var t = uo();
    t
      ? e(Pn(t))
      : _r(function () {
          Pc(e);
        }, 1e3);
  }
  var Uc = "cX_partner";
  function Tc(e) {
    if (e) {
      var t = e.tcString;
      return "gdpr=" + (e.gdprApplies ? 1 : 0) + "&gdpr_consent=" + t;
    }
    return "gdpr=0&gdpr_consent=";
  }
  var Oc = function (e) {
      var t,
        n,
        r,
        i = {},
        o = e || [],
        a = pi("cX_segmentInfo");
      try {
        Yn(a) ||
          ar.forEach(a.split("/"), function (e) {
            var a = e.split("_");
            a &&
              3 === a.length &&
              ((t = a[0]),
              (n = Un(a[1] || "0", 10)),
              (r = a[2] ? a[2].split(".") : o),
              (i[t] = { requestTime: n, segmentIds: r }));
          });
      } catch (e) {
        Wn(e);
      }
      return i;
    },
    Lc = function (t) {
      var n = [];
      (sr.forEach(t, function (e, t) {
        n.push({
          persistedQueryId: t,
          requestTime: e.requestTime,
          segmentIds: e.segmentIds,
        });
      }),
        n.sort(function (e, t) {
          return t.requestTime - e.requestTime;
        }));
      for (var r, i = [], o = 0; o < 5 && o < n.length; o++)
        ((r = n[o]),
          i.push(
            r.persistedQueryId +
              "_" +
              r.requestTime +
              "_" +
              r.segmentIds.join("."),
          ));
      try {
        mi("cX_segmentInfo", i.join("/"), e.library.m_maxCookieExpires);
      } catch (e) {}
    };
  function Rc(e, t) {
    return e + "_" + Cr.stringify(t);
  }
  var Mc,
    Dc = {
      consent: {
        get: function (e) {
          var t = kn.get("consent");
          return e && t ? t[e] : t;
        },
        set: function (e, t) {
          if (Jn(e)) {
            var n = {};
            ((n[e] = t), kn.set("consent", n));
          } else kn.set("consent", e);
        },
        setByPreset: function (e) {
          kn.set("consent", e);
        },
        getByPurpose: function () {
          return kn.utils.getConsent();
        },
        setByPurpose: function (e, t, n) {
          kn.utils.setConsent(e, t, n);
        },
        setAllPurposes: function (e) {
          kn.utils.setConsent(e);
        },
      },
      consentClasses: gi,
      consentClassesV2: yi,
      denyWithoutConsent: wi,
      initializePage: lc,
      initCampaignReporting: Qa,
      _removeUnloadHandler: sc,
      _initializeUnloadHandler: uc,
      _handleRequireOrChangeConsent: function () {
        Ki("pv")
          ? (e.callQueue.push(["_initializeUnloadHandler"]),
            e.callQueue.push(["stopPolling"]),
            e.callQueue.push(["clearIds"]))
          : (e.callQueue.push(["_removeUnloadHandler"]),
            e.callQueue.push(["setupPolling"]));
      },
      requireConsent: _i,
      isConsentRequired: Si,
      setConsent: Ci,
      allUserConsents: xi,
      hasConsent: ki,
      ignoreConsentCache: function (t) {
        e.library.m_noConsentCache = rr(t);
      },
      isConsentCacheIgnored: Ii,
      setupIabCmp: wr,
      setAllConsentsTo: Ui,
      setupTcfApi: oc,
      requireTcf20: ac,
      setRestrictionsToConsentClasses: nc,
      _cmpFunc: wr,
      _doesNotHaveConsent: Ki,
      _consentActiveAndAvailableFor: Zi,
      _allUserConsentsList: Ei,
      getSiteId: Zr,
      getAccountId: ei,
      setSiteId: Kr,
      setAccountId: function (t) {
        e.library.m_accountId = t;
      },
      setGeoPosition: wr,
      requireOnlyFirstPartyIds: function () {
        var t;
        ((t = 3),
          (e.library.m_useCases ^= $r[t]),
          (e.library.m_thirdPartyIds = !1));
      },
      requireSecureCookies: function () {
        e.library.m_usesSecureCookies = !0;
      },
      makeUrlEndpoint: ai,
      addExternalId: function (t) {
        if (
          !Ki("pv") &&
          t.id &&
          !ar.some(ko, function (e) {
            return t.id === e;
          }) &&
          !ar.some(e.library.m_externalUserIds, function (e) {
            return t.id === e.id && t.type === e.type;
          }) &&
          e.library.m_externalUserIds.length < 5 &&
          ("" + t.id).length <= 128 &&
          ("" + t.type).length <= 10
        ) {
          var n = {};
          ((n[t.id + "{" + t.type + "}"] = { prefix: t.type, type: "CX" }),
            kn.set("users", n),
            e.library.m_externalUserIds.push(t));
        }
      },
      _getExternalIdsAsUrlParameters: Eo,
      setCustomParameters: _o,
      clearCustomParameters: function () {
        ((e.library.m_customParameters = []),
          (e.library.m_rawCustomParameters = {}));
      },
      setRetargetingParameters: function (e) {
        _o(e, "t_");
      },
      setUserProfileParameters: function (e) {
        _o(e, "u_");
      },
      startSessionAnnotation: function (e) {
        Io(vr(So(), e));
      },
      stopSessionAnnotation: function (e) {
        var t = So(),
          n = {};
        (sr.forEach(t, function (t, r) {
          var i = e[r];
          Jn(t) && (Bn(i) || (!Yn(i) && i !== t)) && (n[r] = t);
        }),
          Io(n));
      },
      stopAllSessionAnnotations: function () {
        Io({});
      },
      _getSessionAnnotations: So,
      _setSessionAnnotations: Io,
      _isInternalRequest: wo,
      _isTemplateCdnUrl: Ao,
      isRecsDestination: bo,
      isCompatModeActive: wr,
      setCompatMode: wr,
      isSafari: Er,
      isFirefox: Ar,
      isIE6Or7: function () {
        try {
          return (
            "Microsoft Internet Explorer" === navigator.appName &&
            (or(navigator.userAgent, "MSIE 6.") ||
              or(navigator.userAgent, "MSIE 7."))
          );
        } catch (e) {
          return !1;
        }
      },
      isEdge: Pr,
      isTopWindow: qr,
      isArray: er,
      isObject: tr,
      _isEmptyObject: ur,
      _clone: function (e) {
        return tr(e) ? mr(e) : er(e) ? pr(e) : e;
      },
      _cloneArray: pr,
      _cloneObject: mr,
      _applyArray: lr,
      _applyObject: fr,
      Array: ar,
      Object: sr,
      JSON: Cr,
      hasPostMessage: Ur,
      hasLocalStorage: Or,
      hasHistory: Mr,
      hasSessionStorage: Lr,
      hasPassiveEventListeners: Rr,
      _findRealReferrer: Po,
      _isAutoRefresh: yo,
      _ogsFieldModifiedTime: Uo,
      _sendApve: Mo,
      isPageViewReported: function (e) {
        return Oo(e || window.location.href);
      },
      sendPageViewEvent: function (t, n) {
        if (!Ki("pv")) {
          var r = t || {},
            i = r.location || window.location.href;
          bo(i) && !or(i, go) && (i += (or(i, "#") ? "&" : "#") + go);
          var o = r.referrer || Po();
          if (!wo()) {
            var a = !1;
            if ((rr(r.useAutoRefreshCheck) && (a = yo()), Lo(i))) {
              ((e.library.m_previousPageViewReport = To(i)),
                (e.library.m_referrer = i));
              var c = ao(),
                s = co(),
                u = uo(),
                l = zn(),
                d = "edgeid" === e.library.m_thirdPartyIds ? "edgeid" : "p1",
                f = (function (t) {
                  var n = Un(pi("cX_lastP1Time") || "0", 10);
                  return (
                    !!(Zn(n) || n < t - 432e6 || n > t) &&
                    (mi(
                      "cX_lastP1Time",
                      "" + t,
                      Dn(oi, e.library.m_maxCookieExpires),
                    ),
                    !0)
                  );
                })(l),
                p =
                  ("p1" === d && f
                    ? e.library.p1BaseUrl + "#"
                    : e.library.eventReceiverBaseUrlGif + "?") +
                  si({
                    ver: "2.8.92",
                    typ: "pgv",
                    rnd: ni(),
                    sid: Zr(),
                    loc: i,
                    new: e.library.m_isNewUser ? 1 : 0,
                    arf: a ? 1 : 0,
                    ltm: e.library.m_scriptStartTime,
                  });
              (Zi("device") &&
                (p +=
                  "&" +
                  si({
                    ref: o,
                    tzo: Qn(),
                    wsz: zr(Vr()),
                    res: zr({
                      width: window.screen.width || 0,
                      height: window.screen.height || 0,
                    }),
                    dpr: Bn(window.devicePixelRatio)
                      ? ""
                      : "" + window.devicePixelRatio,
                    col:
                      !Bn(window.screen) && $n(window.screen.colorDepth)
                        ? "" + window.screen.colorDepth
                        : "",
                    bln: Jn(navigator.language) ? navigator.language : "OO1OO",
                    chs: document.characterSet || "",
                  })),
                (p +=
                  "&" +
                  si({
                    cks: c,
                    ckp: s,
                    glb: u || "",
                    asi: r.assetId,
                    amo: Uo(),
                  })),
                Si() &&
                  (p +=
                    "&" + si({ con: Ai(), cv: e.library.m_consentVersion })),
                (p += Eo()));
              var m = e.library.m_customParameters.slice(0);
              try {
                _o(So());
              } catch (e) {
                Wn(e);
              }
              (nr(e.library.m_customParameters) ||
                (p += "&" + e.library.m_customParameters.join("&")),
                (e.library.m_customParameters = m));
              try {
                (e.library.m_atfr && (p += e.library.m_atfr),
                  (e.library.m_atfr = null));
              } catch (e) {
                Wn(e);
              }
              if (f)
                "p1" === d
                  ? (function (e) {
                      var t = io(e, void 0, { id: "cx_rep_iframe_" + Xn() }),
                        n = Xr();
                      if (n) t.send(n);
                      else {
                        var r = function () {
                          jr() ? t.send(jr()) : setTimeout(r, 100);
                        };
                        r();
                      }
                    })(p)
                  : "edgeid" === d &&
                    lo(
                      co(!1),
                      void 0,
                      void 0,
                      fi(window.location.href, "ref", o),
                    );
              else {
                var v = ro();
                v.src = p;
                var h = oo(zn());
                v.onload = function () {
                  (h(zn()),
                    Vn("== PageView sent", v.src),
                    Kn(n) && n({ url: v.src, context: r, isAnonymous: !1 }));
                };
              }
            }
          }
        }
      },
      sendActivityEvent: ia,
      sendARIEvent: Aa,
      onP1: function (t) {
        var n =
            e.library.eventReceiverBaseUrlGif + "?" + ui() + "&cst=" + Pn(t),
          r = pi("cX_lst");
        (Yn(r) || r !== t
          ? (mi("cX_lst", t, e.library.m_maxCookieExpires), (r = t))
          : (n += "&lst=" + Pn(r)),
          Qr(
            si({ method: "setCxenseUserIdParent", lst: Pn(r), cst: Pn(t) }),
            "*",
          ));
        var i = oo(zn());
        ro(n, function () {
          (i(zn()), Vn("== PageView sent", n));
        });
      },
      getSessionId: ao,
      getUserId: co,
      _localCxenseUserId: so,
      getCxenseUserId: uo,
      _cxenseUserIdRequest: lo,
      clearIds: function () {
        (e.env.hasLocalStorage &&
          ar.forEach(po, function (e) {
            localStorage.getItem("_" + e) && localStorage.removeItem("_" + e);
          }),
          e.env.hasSessionStorage &&
            ar.forEach(mo, function (e) {
              sessionStorage.getItem("_" + e) &&
                sessionStorage.removeItem("_" + e);
            }),
          ar.forEach(vo, function (e) {
            Vi(e) && Fi(e, "/", qi());
          }),
          ho());
      },
      _createExpireTokenRequest: fo,
      _clearThirdPartyIds: ho,
      onClearIds: function () {
        (fo(), pi("cX_lst") && vi("cX_lst"));
      },
      getPageContext: function () {
        var e = qr() ? {} : vr(di(), li());
        return {
          pageViewRandom: e.prnd || ni(),
          userId: e.usi || co(),
          location: e.ctx || window.location.href,
        };
      },
      getRandomString: gr,
      getRandomId: ni,
      setRandomId: ti,
      _getUseCases: function () {
        var t = [];
        return (
          ar.forEach($r, function (n, r) {
            (function (t) {
              return !!(e.library.m_useCases & $r[t]);
            })(r) && t.push(r);
          }),
          t
        );
      },
      getNowSeconds: qn,
      setEventAttributes: Ro,
      sendEvent: function (t, n, r) {
        if (!Ki("pv")) {
          n = n || {};
          var i = vr(e.library.m_customEventAttributes || {}, r || {}),
            o = i.identities || [];
          if (
            !ar.some(o, function (e) {
              return "cx" === e.type;
            })
          ) {
            var a = co();
            Yn(a) || o.push({ id: a, type: "cx" });
          }
          var c = [];
          sr.forEach(n, function (e, t) {
            c.push({ group: t, item: e, type: $n(e) ? "number" : "string" });
          });
          var s = {
              events: [
                {
                  type: t,
                  rnd: gr(),
                  siteId: Zr(),
                  prnd: ni(),
                  userIds: o,
                  origin: i.origin,
                  customParameters: c,
                  consent: Si() ? Ei() : void 0,
                },
              ],
            },
            u =
              e.library.dmpPushUrl +
              "&" +
              si({
                ver: "2.8.92",
                persisted: i.persistedQueryId,
                glb: uo() || "",
                json: Cr.stringify(s),
              });
          no(
            u,
            function (e) {
              (Vn("== Event sent", Cr.stringify(s), u),
                Kn(i.callback) && i.callback(e, { url: u, request: s }));
            },
            { synchronous: i.synchronous },
          );
        }
      },
      getUserSegmentIds: function (t, n) {
        if (!t || !Jn(t.persistedQueryId) || t.persistedQueryId.length < 5)
          throw new Error("A valid persistedQueryId is required");
        var r = t.defaultValue || [];
        if (Ki("segment")) return (Kn(t.callback) && t.callback(r), []);
        var i = Oc(t.defaultValue),
          o = i[t.persistedQueryId];
        o ||
          ((i[t.persistedQueryId] = { requestTime: 0, segmentIds: r }),
          (o = i[t.persistedQueryId]));
        var a = o.requestTime,
          c = o.segmentIds,
          s = qn(),
          u = t.maxAge ? Mn(t.maxAge, 300) : 300;
        if (
          or(e.library.m_previousSegmentReport, Rc(t.persistedQueryId, n)) &&
          a > s - u
        )
          return (Kn(t.callback) && t.callback(c), c);
        if (
          (e.library.m_previousSegmentReport.push(Rc(t.persistedQueryId, n)),
          Zn(a) || a < s - u || a > s || (er(c) && 0 === c.length))
        ) {
          if (
            ((o.requestTime = s),
            Lc(i),
            ((n = n || {}).identities = n.identities || []),
            !ar.some(n.identities, function (e) {
              return "cx" === e.type;
            }))
          ) {
            var l = co();
            Yn(l) || n.identities.push({ id: l, type: "cx" });
          }
          no(
            e.library.userSegmentUrl +
              "&" +
              si({ persisted: t.persistedQueryId, json: Cr.stringify(n) }),
            function (e) {
              var n = e && e.response && e.response.segments;
              (er(n) &&
                !nr(n) &&
                ((c = n),
                (((i = Oc(r))[t.persistedQueryId] || {}).segmentIds = n),
                Lc(i)),
                Kn(t.callback) && t.callback(c || r));
            },
            { synchronous: t.synchronous, timeout: t.timeout },
          );
        } else
          Kn(t.callback) &&
            _r(function () {
              Kn(t.callback) && t.callback(c);
            }, 1);
        return c;
      },
      getSegments: function (t, n, r) {
        var i = tr(t) ? t.persistedQueryId : t,
          o = tr(t) ? t.callback : Kn(n) ? n : wr;
        if (((r = tr(t) ? t.timeout : r), !Jn(i) || i.length < 5))
          throw new Error("A valid persistedQueryId is required");
        var a = e.library.segmentLookupUrl;
        if (((n = tr(n) && !Kn(n) ? n : {}), Ki("segment")))
          (delete n.identities, (n.identity = null));
        else {
          var c = co();
          n.identities
            ? Yn(c) ||
              ar.some(n.identities, function (e) {
                return "cx" === e.type;
              }) ||
              n.identities.push({ id: c, type: "cx" })
            : n.identity || (n.identity = { id: c, type: "cx" });
        }
        (n.context || (n.context = { siteId: Zr(), url: window.location.href }),
          no(
            (a += "&" + si({ persisted: i, json: Cr.stringify(n) })),
            function (e) {
              var t = e && e.response && e.response.segments;
              o(t || []);
            },
            { timeout: r },
          ));
      },
      getTimezoneOffset: Qn,
      _canSetSameSite: Dr,
      setCookie: Wi,
      getCookie: Vi,
      deleteCookie: Fi,
      getTopLevelDomain: qi,
      _renderTemplate: $o,
      renderTemplate: Jo,
      isTextNode: zo,
      getNodeValue: qo,
      setNodeValue: Qo,
      loadScript: Gr,
      jsonpRequest: no,
      getAllText: function e(t) {
        var n = "";
        return Jn(t)
          ? t
          : (sr.forEach(t, function (t) {
              Jn(t) ? (n += t) : tr(t) && (n += e(t));
            }),
            n);
      },
      createDelegate: function (e, t) {
        var n = On.call(arguments, 2);
        return function () {
          return t.apply(
            e,
            nr(n) ? arguments : On.call(arguments, 0).concat(n),
          );
        };
      },
      combineKeywordsIntoArray: Yr,
      combineArgs: vr,
      trim: br,
      parseMargins: Fo,
      getHashFragment: ui,
      parseHashArgs: li,
      parseUrlArgs: di,
      _filterHashArgs: Vo,
      sendSpaRecsClick: function (t, n) {
        ((e.library.m_spaRecsClickUrl = t.replace(
          /\/widget\/click\/(image\/)?/,
          "/widget/click/image/",
        )),
          ro(e.library.m_spaRecsClickUrl, n, n));
      },
      clickTracker: function (e, t, n) {
        function r() {
          ((t.href = e), n && n());
        }
        var i = "cXLinkId" + gr();
        return (
          e &&
            _r(function () {
              (t || (t = En(i)),
                t &&
                  (xr(t, "mousedown", function (e) {
                    (0 !== e.button && 1 !== e.button) || r();
                  }),
                  "ontouchstart" in window &&
                    xr(t, "touchstart", r, !!Rr() && { passive: !0 })));
            }, 1),
          i
        );
      },
      renderContainedImage: function (e) {
        var t = (
            e.image.dimensions || e.image.width + "x" + e.image.height
          ).split("x"),
          n = Un(t[0], 10),
          r = Un(t[1], 10),
          i = n / r,
          o = e.container.width / e.container.height,
          a = e.container.width / n,
          c = e.container.height / r,
          s = "zoom" === (e.tooWideStrategy || "zoom") ? c : a;
        i < o &&
          ((a = e.container.height / r),
          (c = e.container.width / n),
          (s = "zoom" === (e.tooTallStrategy || "zoom") ? c : a));
        var u =
            n *
            (s = Dn(Mn(s, e.scaleFactorMin || 0.001), e.scaleFactorMax || 1)),
          l = r * s,
          d =
            u > e.container.width
              ? $n(e.tooWideFocusPoint)
                ? e.tooWideFocusPoint
                : 0.5
              : { left: 0, center: 0.5, right: 1 }[e.horizontalAlign || "left"],
          f =
            l > e.container.height
              ? $n(e.tooTallFocusPoint)
                ? e.tooTallFocusPoint
                : 0
              : { top: 0, middle: 0.5, bottom: 1 }[e.verticalAlign || "top"];
        return (
          "<div" +
          (e.container.cssClass
            ? ' class="' + e.container.cssClass + '"'
            : "") +
          ' style="width: ' +
          e.container.width +
          "px; height: " +
          e.container.height +
          'px; overflow: hidden; position: relative;"><img' +
          (e.image.cssClass ? ' class="' + e.image.cssClass + '"' : "") +
          ' style="position: relative; left: ' +
          (e.container.width - u) * d +
          "px; top: " +
          (e.container.height - l) * f +
          'px;" src="' +
          e.image.src +
          '" width="' +
          u +
          '" height="' +
          l +
          '" tmp:alt="' +
          ea(e.image.alt || "") +
          '"' +
          (e.image.id ? ' tmp:id="' + ea(e.image.id) + '"' : "") +
          (e.image.title ? ' tmp:title="' + ea(e.image.title) + '"' : "") +
          " /></div>\n"
        );
      },
      _randomString: gr,
      _tempStore: ea,
      _domMatches: Sr,
      _domClosest: function (e, t) {
        do {
          if (Sr(e, t)) return e;
          e = e.parentElement || e.parentNode;
        } while (!Yn(e) && 1 === e.nodeType);
        return null;
      },
      addEventListener: xr,
      removeEventListener: kr,
      decodeUrlEncodedNameValuePairs: ci,
      _encodeUrlEncodedNameValuePairs: si,
      postMessageToParent: Qr,
      _sendMessageToChild: Br,
      _handlePostMessage: dc,
      _updateParentMetrics: xa,
      _updateWidget: Ho,
      calculateAdSpaceSize: Xo,
      insertWidget: function t(n, r) {
        if ((Jr(7), !Si() || e.library.m_hasSetConsent))
          return (
            "auto" === (n = n || {}).renderTemplateUrl &&
              (n.renderTemplateUrl =
                (e.env.isSecureProtocol
                  ? e.library.cdn.template.direct.https
                  : e.library.cdn.template.direct.http) + "generic_v1.html"),
            Ao(n.renderTemplateUrl) &&
              !e.env.hasHistory &&
              (n.renderTemplateUrl += "?ref=" + Pn(window.location.href)),
            Bn(n.forwardHashArgs) &&
              !qr() &&
              or(window.location.hash, "parentElementId") &&
              (n.forwardHashArgs = !0),
            (n.resizeToContentSize = rr(n.resizeToContentSize)),
            Ko(n, r)
          );
        _r(function () {
          t(n, r);
        }, 60);
      },
      _insertWidget: Ko,
      insertAdSpace: Zo,
      insertMultipleAdSpaces: function (t, n) {
        if (!Ki("ad")) {
          var r,
            i,
            o = [],
            a = "cXMaster" + Xn(),
            c = !1;
          (ar.forEach(t, function (e) {
            e &&
              (Jn(e.adSpaceId) && o.push(e.adSpaceId),
              (Jn(e.renderTemplateUrl) || !0 === e.useMappedRenderTemplate) &&
                (c = !0),
              (r =
                r ||
                e.targetElementId ||
                e.appendToElementId ||
                e.insertBeforeElementId));
          }),
            (i = vr(
              n,
              (i = {
                adSpaceIds: o,
                masterOnLoadHandler: function () {
                  ar.forEach(t, function (e) {
                    ((e.isSlave = !0),
                      (e.masterId = a),
                      tr(n) &&
                        ((e.backend = n.backend),
                        (e.baseAdDeliveryUrl = n.baseAdDeliveryUrl),
                        (e.secureBaseAdDeliveryUrl =
                          n.secureBaseAdDeliveryUrl)),
                      Zo(e));
                  });
                },
                masterId: a,
                masterTargetElementId: r,
              }),
            )),
            c &&
              (i.renderTemplateUrl =
                e.library.cdn.template.direct.http +
                "master-data-template.html"),
            Zo(i));
        }
      },
      trackElement: ta,
      _isAmpMessage: wc,
      isAmpIFrame: function () {
        return or(window.location.hash, "amp=1");
      },
      trackAmpIFrame: function (e) {
        if (!qr()) {
          var t = e.elementId || "amp-iframe-widget";
          (ta(fr({ elementId: t }, e)),
            window.parent.postMessage(
              { sentinel: "amp", type: "send-intersections" },
              "*",
            ),
            xr(window, "message", bc(t)));
        }
      },
      getElementPosition: Wr,
      getWindowSize: Vr,
      getDocumentSize: Fr,
      getScrollPos: ua,
      _onHIDEvent: da,
      _onMouseMoveEvent: fa,
      _onClickEvent: ha,
      reportActivity: la,
      requireActivityEvents: sa,
      shouldPollActivity: function (t) {
        ((e.shouldPoll = t), (e.library.shouldPoll = t));
      },
      _shouldPollActivity: ga,
      _onPollActiveTime: _a,
      _onPollActivity: Ia,
      _writeAtfr: va,
      setupPolling: hc,
      stopPolling: vc,
      cint: function (t, n) {
        if (
          (Jr(5),
          !e.env.isFirefox &&
            !e.env.isSafari &&
            or(Ic, t) &&
            !Ki("segment") &&
            "1" !== pi("cX_cintSet") &&
            Yn(Vi("cbcdfp")))
        ) {
          var r,
            i,
            o = co();
          return (
            t === _c
              ? ((r = "evid_"), (t = Bn(n) ? "502520002" : Pn(n)))
              : (r = "cxense_"),
            ro(
              (i =
                "https://c.cintnetworks.com/?a=2495&ip&i=" +
                t +
                "&id=" +
                (r + t + ":" + Pn(o))),
            ),
            mi("cX_cintSet", "1", Dn(oi, e.library.m_maxCookieExpires)),
            i
          );
        }
      },
      prebid: wr,
      sync: function () {
        (Jr(4),
          Ki("ad") ||
            ar.forEach(On.call(arguments), function (t) {
              var n,
                r,
                i,
                o = "";
              if (tr(t)) {
                if ((n = t).partner && n.customerId)
                  ((t = n.partner), (r = n.customerId));
                else {
                  if (!n.partner || !n.userId) return;
                  ((t = n.partner), (i = n.userId));
                }
                n.params &&
                  ar.forEach(n.params, function (e) {
                    o += "&" + e.key + "=" + e.value;
                  });
              }
              if ("idf" !== t)
                try {
                  var a = (function (e) {
                    var t,
                      n = eo(Uc);
                    if (Yn(n) || Bn(n)) ((n = e + "=1"), (t = 1));
                    else if (or(n, e)) {
                      var r = n.split(","),
                        i = [];
                      (ar.forEach(r, function (n) {
                        (n.slice(0, n.indexOf("=")) === e &&
                          ((t = Un(n.slice(e.length + 1), 10) + 1),
                          (n = e + "=" + t)),
                          i.push(n));
                      }),
                        (n = i.join()));
                    } else ((n = n + "," + e + "=1"), (t = 1));
                    return (to(Uc, n), t);
                  })(t);
                  if (Bn(a) || a > 2) return;
                } catch (e) {
                  Wn(e);
                }
              var c = Zr(),
                s = {
                  pubmatic: function () {
                    io(
                      "https://ads.pubmatic.com/AdServer/js/user_sync.html?p=" +
                        r +
                        "&predirect=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "pcs.gif?cxsite=" +
                            c +
                            "&userId=",
                        ),
                    ).send();
                  },
                  bla: function () {
                    ro(
                      "https://aid.send.microad.jp/asr?v=1&code=dY-5ZLLSddc&format=pixel",
                    );
                  },
                  smart: function (t) {
                    Ac(function (n) {
                      ro(
                        "https://sync.smartadserver.com/getuid?" +
                          Tc(n) +
                          "&url=" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "smt.png?cxsite=" +
                              c +
                              "&userId=[sas_uid]&cxckp=" +
                              t,
                          ),
                      );
                    });
                  },
                  simpli: function () {
                    Ac(function (e) {
                      ro("https://um.simpli.fi/cxense?" + Tc(e));
                    });
                  },
                  xl8: function () {
                    ro("https://loadm.exelator.com/load/?p=204&g=820&j=0");
                  },
                  neu: function () {
                    ro("https://aa.agkn.com/adscores/g.pixel?sid=9212271498");
                  },
                  p161: function (t) {
                    Ac(function (n) {
                      ro(
                        "https://ads.creative-serving.com/cm?" +
                          Tc(n) +
                          "&redir=" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "pfm.png?cxsite=" +
                              c +
                              "&uuid=${UUID}&cxckp=" +
                              t,
                          ),
                      );
                    });
                  },
                  liveramp: function (e) {
                    ro("https://idsync.rlcdn.com/421746.gif?partner_uid=" + e);
                  },
                  liveramp2: function () {
                    ro(
                      e.library.cookieSyncRUrl +
                        "?cxsite=" +
                        c +
                        "&partnerId=lr2",
                    );
                  },
                  adform: function (t) {
                    ro(
                      e.library.cookieSyncRUrl +
                        "?cxsite=" +
                        c +
                        "&partnerId=csr&cxckp=" +
                        t,
                    );
                  },
                  ddp: function (e) {
                    Ac(function (t) {
                      ro(
                        "https://cm.g.doubleclick.net/pixel?google_nid=cxense_ddp&google_cm&" +
                          Tc(t) +
                          "&cxckp=" +
                          e +
                          "&cxsite=" +
                          c,
                      );
                    });
                  },
                  kccs: function () {
                    ro("https://kcxcs.deqwas.net/DmpSyncService/Sync.aspx");
                  },
                  scaleout: function () {
                    ro("https://tg.socdm.com/aux/idsync?proto=cxense");
                  },
                  aone: function (t) {
                    ro(
                      "https://aw.dw.impact-ad.jp/c/u/?oid=" +
                        r +
                        "&rdr=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "aon.png?customerId=" +
                            r +
                            "&uid={AONEID}&cxckp=" +
                            t,
                        ),
                    );
                  },
                  frk: function () {
                    ro("https://sync.dmp.fout.jp/serve/?id=13336&mt=213");
                  },
                  appnexus: function (t) {
                    Ac(function (n) {
                      ro(
                        "https://secure.adnxs.com/getuid?" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "apn.png?cxsite=" +
                              c +
                              "&uid=$UID&cxckp=" +
                              t,
                          ) +
                          "&" +
                          Tc(n),
                      );
                    });
                  },
                  aam: function (t) {
                    ro(
                      "https://dpm.demdex.net/ibs:redir=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "aam.png?cxsite=" +
                            c +
                            "&userId=${DD_UUID}&cxckp=" +
                            t,
                        ),
                    );
                  },
                  xro: function () {
                    ro("https://dex.advg.jp/dx/p/sync?_aid=111&_page=2257");
                  },
                  pdx: function (t) {
                    ro(
                      "https://tags.bluekai.com/site/48528?redir=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "pdx.png?cxsite=" +
                            c +
                            "&userId=$_BK_UUID&cxckp=" +
                            t,
                        ),
                    );
                  },
                  frw: function () {
                    ro(
                      "https://ads.stickyadstv.com/data-registering?dataProviderId=1233&redirectId=1617",
                    );
                  },
                  adition: function (t) {
                    Ac(function (n) {
                      ro(
                        "https://dsp.adfarm1.adition.com/cookie/?" +
                          Tc(n) +
                          "&redirect=" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "sia.png?cxsite=" +
                              c +
                              "&userId=%%COOKIE%%&cxckp=" +
                              t,
                          ),
                      );
                    });
                  },
                  imdigital: function (t) {
                    ro(
                      "https://ad.360yield.com/ux?publisher_id=" +
                        r +
                        "&publisher_dmp_id=5&r=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "coo.png?cxsite=" +
                            c +
                            "&userId={PUB_USER_ID}&cxckp=" +
                            t,
                        ),
                    );
                  },
                  admatrix: function (t) {
                    ro(
                      e.library.cookieSyncRUrl +
                        "?cxsite=" +
                        c +
                        "&partnerId=adm&redir=" +
                        Pn(
                          "https://relay-dsp.t-ad-m.asia/dmp/sync/bizmatrix/async?pid=",
                        ) +
                        r +
                        "%26uid%3D" +
                        t,
                    );
                  },
                  rub: function (t) {
                    Ac(function (n) {
                      ro(
                        e.library.cookieSyncRUrl +
                          "?" +
                          Tc(n) +
                          "&cxsite=" +
                          c +
                          "&partnerId=rub&cxckp=" +
                          t,
                      );
                    });
                  },
                  spx: function (t) {
                    Ac(function (n) {
                      ro(
                        "https://sync.search.spotxchange.com/audience_sync/19?" +
                          Tc(n) +
                          "&redir=" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "spx.png?cxsite=" +
                              c +
                              "&uuid=$SPOTX_AUDIENCE_ID&cxckp=" +
                              t,
                          ),
                      );
                    });
                  },
                  lgd: function () {
                    ro("https://cr-p10350.ladsp.com/pid/10350");
                  },
                  imi: function () {
                    ro(
                      "https://sync.im-apps.net/imid/redirect?cid=" +
                        r +
                        "&tid=" +
                        n.testId +
                        o,
                    );
                  },
                  ttd: function () {
                    ro(
                      "https://match.adsrvr.org/track/cmf/generic?ttd_pid=" +
                        r +
                        "&ttd_tpi=1",
                    );
                  },
                  test: function () {
                    ro(
                      "https://csyn-r-stage.cxense.com/?partnerId=test&redir=" +
                        Pn(
                          "https://csyn-stage.cxense.com/test.gif?userId=${UUID}",
                        ),
                    );
                  },
                  tdi: function () {
                    ro(
                      "https://in.treasuredata.com/postback/v3/event/datacurrent_pianojapan/cxense_rd?td_global_id=td_global_id&td_write_key=8487/8f9ae55cc2626e48d85a6e19cdf9c9030a75f3ac&td_redirect=" +
                        Pn(
                          e.library.cookieSyncUrl +
                            "tdi.png?td_global_id=td_global_id",
                        ),
                    );
                  },
                  smc: function () {
                    ro("https://sync.sxp.smartclip.net/sync?type=red&dsp=93");
                  },
                  ntv: function () {
                    Ac(function (t) {
                      ro(
                        "https://jadserve.postrelease.com/dmp/19?" +
                          Tc(t) +
                          "&ntv_r=" +
                          Pn(
                            e.library.cookieSyncUrl +
                              "ntv.png?userId=NTV_USER_ID",
                          ),
                      );
                    });
                  },
                  idf: function (t) {
                    ro(
                      e.library.cookieSyncUrl +
                        "idf.png?cxsite=" +
                        c +
                        "&userId=" +
                        i +
                        "&cxckp=" +
                        t,
                    );
                  },
                  fid: function (t) {
                    ro(
                      e.library.cookieSyncUrl +
                        "fid.png?cxsite=" +
                        c +
                        "&userId=" +
                        i +
                        "&cxckp=" +
                        t,
                    );
                  },
                  uvt: function (t) {
                    ro(
                      e.library.cookieSyncUrl +
                        "uvt.png?cxsite=" +
                        c +
                        "&userId=" +
                        i +
                        "&cxckp=" +
                        t,
                    );
                  },
                  int: function (t) {
                    ro(
                      e.library.cookieSyncUrl +
                        "int.png?id=" +
                        i +
                        "&cxckp=" +
                        t,
                    );
                  },
                }[t];
              Bn(s) || Pc(s);
            }));
      },
      decrypt: function (t, n) {
        Ki("pv") ||
          no(
            e.library.cookieSyncUrl +
              ("idf" === t.provider || Bn(t.provider) ? "id5" : "") +
              "-decrypt?callback={{callback}}&" +
              si({ persisted: t.persistedQueryId, json: Cr.stringify(n) }),
            function (e) {
              Jn(e.response) && t.callback(e.response.replace(/"/g, ""));
            },
          );
      },
      _syncWithGlobalId: Pc,
      invoke: function (e) {
        e.apply(window, On.call(arguments, 1));
      },
      _throttle: Ir,
      _handleScroll: Sa,
      _registerEventListeners: fc,
      _setLocalStorage: mi,
      _expireLocalStorage: hi,
      getClientStorageVariable: function (e, t, n) {
        return $a({ method: "clientStorageGet", namespace: e, name: t }, n);
      },
      setClientStorageVariable: function (e, t, n, r) {
        var i = {
          method: "clientStorageSet",
          namespace: e,
          name: t,
          value: "" + n,
        };
        return (
          r && r.allow && (i.allow = r.allow),
          r && r.deny && (i.deny = r.deny),
          $a(i, r)
        );
      },
      removeClientStorageVariable: function (e, t, n) {
        return $a({ method: "clientStorageRemove", namespace: e, name: t }, n);
      },
      _initClientStorageIFrame: Ga,
      _sendClientStorageMessage: $a,
      _handleClientStorage: Ya,
      _processLocalStats: wr,
      startLocalStats: wr,
      getLocalStats: function () {
        return {
          prevSessionStartTime: new Date(),
          currSessionStartTime: new Date(),
        };
      },
      _defaultImageCreativeRenderer: Sc,
      _defaultTextCreativeRenderer: xc,
      _defaultFlashCreativeRenderer: kc,
      _defaultComboCreativeRenderer: Cc,
      _defaultThirdPartyCreativeRenderer: Ec,
      defaultAdRenderer: function (e, t) {
        var n = "",
          r = t.creative.type;
        return (
          or(r, "ImageCreativeFeature")
            ? (n += Sc(0, t))
            : or(r, "TextCreativeFeature")
              ? (n += xc(e, t))
              : or(r, "FlashCreativeFeature")
                ? (n += kc(0, t))
                : or(r, "ComboCreativeFeature")
                  ? (n += Cc(0, t))
                  : or(r, "ThirdPartyCreativeFeature") && (n += Ec(e, t)),
          n
        );
      },
    };
  try {
    ((e.callQueue = e.callQueue || []),
      (e._consentCallQueue = e._consentCallQueue || []),
      (e._prebidCallQueue = e._prebidCallQueue || []),
      e.loaded ||
        ((e.library = Dc),
        (Mc = function () {
          var t = e.options || {};
          (lc(!0),
            gc(),
            hi(),
            (function () {
              _r(Ba, 25);
              var t = e.callQueue.push;
              e.callQueue.push = function () {
                return (
                  t.apply(this, On.call(arguments)),
                  _r(Ba, 1),
                  this.length
                );
              };
            })(),
            e.library.m_activityEvents && sa(),
            t.campaignReporting && yc(t.campaignReporting),
            hc(),
            fc(),
            sr.forEach(e.library, function (e, t) {
              Kn(e) &&
                0 !== t.indexOf("_") &&
                (Hn()
                  ? (window.cX[t] = function () {
                      return (
                        Fn(t, Array.prototype.slice.apply(arguments)),
                        e.apply(null, arguments)
                      );
                    })
                  : (window.cX[t] = e));
            }),
            (e.consent = e.library.consent),
            (e.JSON = e.library.JSON),
            (e.Array = e.library.Array),
            (e.Object = e.library.Object),
            (e.version = "2.8.92"),
            Ao(window.location.href) &&
              e.env.hasHistory &&
              (or("" + window.location.href, "widgetId") ||
                !or("" + window.location.href, "asId=")) &&
              window.history.replaceState(
                {},
                "",
                fi(window.location.href, "ref", kn.get("referrer") || ""),
              ));
        }),
        document.prerendering
          ? document.addEventListener("prerenderingchange", Mc, { once: !0 })
          : Mc()),
      (e.loaded = !0));
  } catch (e) {
    Wn(e);
  }
})();